const spells_it = [
  {
    "name": "Aiuto",
    "level": 2,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una minuscola striscia di tessuto bianco)"
    ],
    "duration": "8 ore",
    "description": "Questo incantesimo rafforza il vigore e la determinazione degli alleati. L'incantatore sceglie fino a tre creature entro gittata. Il massimo dei punti ferita e i punti ferita attuali di ogni bersaglio aumentano di 5 per la durata dell'incantesimo. Ai Livelli Superiori. Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i punti ferita di un bersaglio aumentano di altri 5 punti per ogni slot di livello superiore al 2°.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una minuscola striscia di tessuto bianco",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "aiuto",
    "language": "it"
  },
  {
    "name": "Allarme",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una campanella e un frammento di un sottile cavo d'argento)"
    ],
    "duration": "8 ore",
    "description": "L'incantatore predispone un allarme contro le visite indesiderate. Sceglie una porta, una finestra o un'areaentro gittata che non sia piu' grande di un cubo con spigolo di 6 metri. Finché l'incantesimo non termina, un allarme avverte l'incantatore ogni volta che una creatura di taglia Minuscola o superiore tocca l'area protetta o vi entra. Al momento del lancio dell'incantesimo, l'incantatore designa quali creature non faranno scattare l'allarme. Sceglie inoltre se l'allarme e' mentale o udibile. Un allarme mentale fa scattare un suono nella mente dell'incantatore se questi si trova entro 1,5 km dall'area protetta. Questo suono lo sveglia se sta dormendo. Un allarme udibile genera il suono di una campana per 10 secondi entro 18 metri.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una campanella e un frammento di un sottile cavo d'argento",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "allarme",
    "language": "it"
  },
  {
    "name": "Alleato Planare",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore chiede l'aiuto di un'entita' ultraterrena che deve essergli nota: un dio, un primordiale, un principe dei demoni o qualche altro essere dotato di poteri cosmici. Quell'entita' invia un celestiale, un elementale o un immondo a lei fedele in aiuto dell'incantatore. La creatura appare in uno spazio libero entro gittata. Se l'incantatore conosce il nome di una creatura specifica, puo' pronunciare quel nome quando lancia l'incantesimo per richiedere l'intervento di quella creatura, ma potrebbe comunque ricevere quello di una creatura diversa (a scelta del DM). Quando la creatura appare, non e' obbligata in alcun modo a comportarsi in modo particolare. L'incantatore puo' chiederle di svolgere per lui un servizio in cambio di pagamento, ma essa non e' obbligata ad actettare. Il compito da svolgere potrebbe variare dai piu semplici (\"portaci in volo oltre il baratro\", \"aiutaci a vincere una battaglia\") ai piu' complessi (\"spia i nostri nemici\", \"proteggici durante la nostra incursione nel dungeon\"). L'incantatore deve essere in grado di comunicare con la creatura per mercanteggiare con lei e assicurarsi i suoi servigi. Il pagamento puo' assumere le forme piu' disparate. Un celestiale potrebbe richiedere un'ingente donazione in oro o in oggetti magici a un tempio alleato, mentre un immondo potrebbe esigere una creatura vivente in sacrificio o un tesoro in dono. Alcune creature potrebbero concedere i loro servigi in cambio di un compito che l'incantatore dovra' svolgere. Come regola generale un compito che puo' essere misurato in minuti richiede un pagamento del valore di 100 mo per minuto, un compito misurato in ore richiede 1. 000 mo all'ora e un compito misurato in giorni (fino a 10 giorni) richiede 10. 000 mo al giorno. Il DM puo' modificare questi pagamenti in base alle circostanze in cui l'incantatore lancia l'incantesimo. Se il compito e' in sintonia con l'etica della creatura, il pagamento potrebbe essere dimezzato o addirittura superfluo. I compiti non pericolosi solitamente richiedono soltanto la meta' del pagamento suggerito, mentre quelli particolarmente pericolosi potrebbero richiedere una  icompensa superiore. È raro che una creatura accetti un compito potenzialmente suicida. Dopo che la creatura ha portato a termine il compito, o quando la durata pattuita si esaurisce, la creatura fa ritorno al suo piano di origine dopo avere fatlo rapporto all'incantatore, se questo e' possibile e appropriato al compito in questione. Se l'incantatore non riesce ad accordarsi su un prezzo per i servizi della creatura, quest'ultima fa ritorno immediatamente sul suo piano di origine. Una creatura arruolata per unirsi al gruppo dell'incantatore conta come membro di quel gruppo e riceve la sua parte di punti esperienza concessi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "alleato-planare",
    "language": "it"
  },
  {
    "name": "Allucinazione di Forza",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un ciuffo di lana)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Il bersaglio deve effettuare un tiro salvezza su Intelligenza. Se lo fallisce, l'incantatore crea un oggetto, una creatura o un fenomeno fittizio di altra natura visibile a sua scelta, che non sia piu' grande di un cubo con spigolo di 3 metri e sia percepibile soltanto dal bersaglio per la durata dell'incantesimo. Questo incantesimo non ha effetto sui costrutti o sui non morti. L'allucinazione include suoni, temperature e altri stimoli analoghi, anch'essi evidenti soltanto alla creatura. Finché un bersaglio e' influenzato dall'incantesimo, considera l'allucinazione come se fosse reale. Il bersaglio razionalizza qualsiasi esito illogico prodotto dalle sue interazioni con l'allucinazione. Per esempio, un bersaglio che tenta di camminare su un ponte fittizio che attraversa un baratro cadra' non appena mette piede sul ponte. Se il bersaglio sopravvive alla caduta, credera' comunque che il ponte esista e pensera' a un'altra spiegazione per la sua caduta (e' stato spinto, e' scivolato, o un vento forte lo ha buttato di sotto). Un bersaglio influenzato e' talmente convinto che l'allucinazione sia reale che puo' perfino subire danni da essa. Un'allucinazione creata per apparire come una creatura puo' attaccare il bersaglio. Analogamenteun'allucinazione creata per apparire come un fuoco, una pozza d'acido o un flusso di lava puo' bruciare il bersaglio. A ogni round, nel turno dell'incantatore, l'allucinazione puo' infliggere 1d6 danni psichici al bersaglio se esso si trova nell'area dell'allucinazione o entro 1,5 metri da essa purché l'allucinazione riproduca una creatura o un pericolo in grado di infliggere danni logicamente, per esempio attaccando.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di lana",
    "damageTypes": [
      "acido",
      "fuoco",
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Intelligenza"
    ],
    "urlFriendlyName": "allucinazione-di-forza",
    "language": "it"
  },
  {
    "name": "Allucinazione Mortale",
    "level": 4,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore attinge agli incubi di una creatura entro gittata e che egli sia in grado di vedere, per creare unamanifestazione illusoria delle sue paure piu' recondite, visibile soltanto a quella creatura. Il bersaglio deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, diventa spaventato per la durata dell'incantesimo. Alla fine di ogni turno del bersaglio prima che l'incantesimo termini, il bersaglio deve superare un tiro salvezza su Saggezza, altrimenti subira' 4d10 danni psichici. Se lo supera, l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, i danni aumentano di 1d10 per ogni slot di livello superiore al 4°.",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "allucinazione-mortale",
    "language": "it"
  },
  {
    "name": "Alterare Sé Stesso",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore assume una forma diversa, scegliendo al momento del lancio dell'incantesimo una delle opzioni seguenti, i cui effetti permangono per la durata dell'incantesimo. Finché l'incantesimo permane, l'incantatore puo' porre fine a un'opzione con un'azione per ottenere i benefici di un'opzione diversa. Adattamento Acquatico. L'incantatore adatta il suo corpo a un ambiente acquatico: sviluppa le branchie e una membrana tra le dita. Puo' respirare sott'acqua e ottiene una velocita' di nuotare pari alla sua velocita' base sul terreno. Armi Naturali. L'incantatore sviluppa artigli, zanne, spine, corna o un'arma naturale diversa a sua scelta. I suoi colpi senz'armi infliggono 1d6 danni contundenti, perforanti o taglienti, come appropriato per l'arma naturale scelta, e l'incantatore e' competente nei colpi senz'armi. Infine, l'arma naturale e' magica e l'incantatore ottiene un bonus di +1 ai tiri per colpire e ai tiri per i danni che effettua quando la usa. Cambiare Aspetto. L'incantatore altera il suo aspetto. Decide come apparire e definisce altezza, peso, lineamenti facciali, suono della voce, lunghezza dei capelli, carnagione e tratti distintivi, se lo desidera. Puo' apparire come un membro di un'altra razza, ma nessuna delle sue statistiche cambia di conseguenza. Non puo' apparire come una creatura di taglia diversa dalla propria e la sua forma base resta la stessa; per esempio, se e' bipede, non puo' usare questo incantesimo per diventare quadrupede. In qualsiasi momento entro la durata dell'incantesimo puo' usare la sua azione per cambiare di nuovo aspetto in questo modo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "contundenti",
      "perforanti",
      "taglienti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "alterare-sé-stesso",
    "language": "it"
  },
  {
    "name": "Amicizia",
    "level": 0,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "S",
      " M (una piccola quantità di trucco da applicare al volto mentre si lancia l'incantesimo)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Per Ia durata dell'incantesimo, l'incantatore dispone di vantaggio a tutte le prove di Carisma rivolte a una creatura a sua scelta che non sia ostile nei suoi confronti. Quando l'incantesimo termina, la creatura capisce che l'incantatore ha usato la magia per influenzare il suo umore e potrebbe diventare ostile nei suoi confronti. Se la creatura e' tendente alla violenza, potrebbe attaccarlo. Un'altra creatura potrebbe cercare vendetta in altri modi (a discrezione del DM), in base alla natura delle sue interazioni con l'incantatore.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola quantità di trucco da applicare al volto mentre si lancia l'incantesimo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "amicizia",
    "language": "it"
  },
  {
    "name": "Amicizia con gli Animali",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un boccone di cibo)"
    ],
    "duration": "24 ore",
    "description": "Grazie a questo incantesimo l'incantatore convince una bestia che non ha alcuna intenzione di nuocerle. L'incantatore sceglie una bestia entro gittata e che egli sia in grado di vedere. La bestia deve vedere e sentire l'incantatore. Se l'Intelligenza della bestia e' pari o superiore a 4, l'incantesimo fallisce. Altrimenti, la bestia deve superare un tiro salvezza su Saggezza o essere affascinata dall'incantatore per la durata dell'incantesimo. Se l'incantatore o uno dei suoi compagni infligge danni al bersaglio, l'incantesimo termina. Al Livelli Superiori. Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, puo' influenzare una bestia aggiuntiva per ogni slot di livello superiore al 1°.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un boccone di cibo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "amicizia-con-gli-animali",
    "language": "it"
  },
  {
    "name": "Anatema",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una goccia di sangue)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore sceglie fino a tre creature entro gittata e che egli sia in grado di vedere, che dovranno effettuare un tiro salvezza su Carisma. Se una creatura fallisce il suo tiro salvezza, ogni volta che effettua un tiro per colpire o un tiro salvezza prima che l'incantesimo termini deve tirare un d4 e sottrarre il numero ottenuto dal tiro per colpire o dal tiro salvezza.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Bardo",
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia di sangue",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "anatema",
    "language": "it"
  },
  {
    "name": "Animale Messaggero",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un boccone di cibo)"
    ],
    "duration": "24 ore",
    "description": "Grazie a questo incantesimo, l'incantatore usa un animale per trasmettere un messaggio, scegliendo una bestia Minuscola entro gittata e che egli sia in grado di vedere (per esempio uno scoiattolo, una ghiandaia o un pipistrello). L'incantatore specifica un luogo, che deve avere gia' visitato, e un destinatario che orrisponda a una descrizione generica come \"un uomo o una donna che indossi l'uniforme della guardia cittadina\" o \"un nano dai capelli rossi che indossi un cappello a punta\". Pronuncia inoltre un messaggio di un massimo di venticinque parole. La bestia bersaglio viaggia per la durata dell'incantesimo verso il luogo specificato, percorrendo circa 75 km in 24 ore nel caso dl un messaggero volante, o 37,5 km nel caso di altri animali. Quando il messaggero arriva, trasmette il suo messaggio alla creatura che l'incantatore ha descritto, replicando il suono di sua scelta. Il messaggero parla solo con una creatura corrispondente alla descrizione fornita dall'incantatore. Se il messaggero non giunge a destinazione prima della fine dell'incantesimo, il messaggio e' perduto e la bestia si rimette in viaggio verso il punto in cui l'incantesimo e' stato lanciato.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, la durata dell'incantesimo aumenta di 48 ore per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un boccone di cibo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "animale-messaggero",
    "language": "it"
  },
  {
    "name": "Animare Morti",
    "level": 3,
    "school": "Necromanzia",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S",
      " M (una goccia di sangue, un brandello di carne, un pizzico di polvere d'osso)"
    ],
    "duration": "Istantanea",
    "description": "Questo incantesimo crea un servitore non morto, scegliendo un cadavere di umanoide Medio o Piccolo entro gittata. Il suo incantesimo infonde nel bersaglio un'empia parvenza di vita, animandolo come creatura non morta. Il bersaglio diventa uno scheletro se l'incantatore ha scelto le ossa o uno zombi se ha scelto un cadavere. (Il DM possiede le statistiche di gioco di queste creature). A ogni suo turno l'incantatore puo' usare un'azione bonus per comandare mentalmente qualsiasi creatura da lui creata tramite questo incantesimo e situata entro 18 metri da lui (se controlla piu' creature, puo' comandarle tutte o nessuna allo stesso tempo, impartendo lo stesso comando a ogni creatura). L'incantatore decide quale azione effettuera' la creatura e dove si muovera' durante il suo turno successivo, oppure puo' impartire un comando generale, come per esempio vigilare su una camera o un corridoio in particolare. Se l'incantatore non impartisce alcun comando, la creatura si limita a difendersi dalle creature ostili. Una volta ricevuto un ordine, la creatura continua a seguirlo finché non ha portato a termine il compito. La creatura rimane sotto il controllo dell'incantatore per 24 ore, dopodiché smette di obbedire ai comandi che l'incantatore le ha impartito. Per mantenere il controllo della creatura per altre 24 ore, l'incantatore deve lanciare di nuovo questo incantesimo su di essa prima che l'attuate periodo di 24 ore termini. Questo uso dell'incantesimo gli permette di ristabilire il controllo su un massimo di quattro creature da lui animate tramite questo incantesimo, anziché animarne una nuova.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, anima o ristabilisce il controllo su due creature non morte aggiuntive per ogni slot di livello superiore al 3°.Ognuna di queste creature deve provenire da un cumulo di ossa o da un cadavere diverso.",
    "availableClasses": [
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia di sangue, un brandello di carne, un pizzico di polvere d'osso",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "animare-morti",
    "language": "it"
  },
  {
    "name": "Animare Oggetti",
    "level": 5,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Gli oggetti prendono vita a comando dell'incantatore, che sceglie fino a dieci oggetti non magici entro gittata che non siano indossati o trasportati. I bersagli Medi contano come due oggetti;quelli Grandi come quattro;quelli Enormi come otto oggetti. L'incantatore non puo' animare oggetti di taglia superiore a Enorme. Ogni bersaglio si anima e diventa una creatura sotto il suo controllo finché l'incantesimo non termina o finché non scende a 0 punti ferita. Come azione bonus, l'incantatore puo' comandare mentalmente qualsiasi creatura creata con questo incantesimo e situata entro 150 metri da lui (se controlla piu' creature, puo' comandarle tutte o nessuna allo stesso tempo, impartendo lo stesso comando a ogni creatura). L'incantatore decide quale azione effettuera' la creatura e dove si muovera' durante il suo turno successivo, oppure puo' impartire un comando generale, come per esempio vigilare su una camera o un corridoio in particolare. Se l'incantatore non impartisce alcun comando, la creatura si limita a difendersi dalle creature ostili. Una volta ricevuto un ordine, la creatura continua a seguirlo finché non ha portato a termine il compito. Statistiche degli Oggetti AnimatiUn oggetto animato e' un costrutto dotato di CA, punti ferita, attacchi, Forza e Destrezza determinati dalla sua taglia. La sua Costituzione e' pari a 10;la sua Intelligenza e Saggezza sono pari a 3;il suo Carisma e' pari a 1;la sua velocita' e' pari a 9 metri. Se l'oggetto e' privo di gambe o altre appendici che possa usare per la locomozione, ottiene invece una velocita' di volare pari a 9 metri e puo' fluttuare. Se l'oggetto e' agganciato saldamente a una superficie o a un oggetto piu' grosso, come una catena imbullonata a una parete, la sua velocita' e' pari a 0. È dotato di vista cieca entro un raggio di 9 metri ed e' cieco oltre quella distanza. Quando l'oggetto animato scende a 0 punti ferita, riassume la forma dell'oggetto originale e ogni danno rimanente si trasforisce alla forma dell'oggetto originale. Se l'incantatore comanda a un oggetto di attaccare, esso puo' effettuare un singolo attacco in mischia contro una creatura entro 1,5 metri da esso. L'oggetto effettua un attacco con schianto con un bonus al tiro per colpire e ai danni contundenti determinati dalla sua taglia. Il DM potrebbe decidere che uno specifico oggetto infligga danni taglienti o perforanti, in base alla sua forma.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello osuperiore, puo' animare due oggetti aggiuntivi per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "contundenti",
      "perforanti",
      "taglienti"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "animare-oggetti",
    "language": "it"
  },
  {
    "name": "Anti-Individuazione",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un pizzico di polvere di diamante da spruzzare sul bersaglio del valore di 25 mo, che l'incantatore consuma)"
    ],
    "duration": "8 ore",
    "description": "Per la durata dell'incantesimo, l'incantatore nasconde un bersaglio da lui toccato dalle magie di divinazione. Il bersaglio puo' essere una creatura consenziente o un luogo o un oggetto non piu' grande di 3 metri in ognidimensione. Il bersaglio non puo' essere bersagliato da alcuna magia di divinazione né percepito dai sensori di scrutamento magico.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di polvere di diamante da spruzzare sul bersaglio del valore di 25 mo, che l'incantatore consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "anti-individuazione",
    "language": "it"
  },
  {
    "name": "Antipatia/Simpatia",
    "level": 8,
    "school": "Ammaliamento",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di allume immerso nell'aceto per un effetto di antipatia o una goccia di miele per un effetto di simpatia)"
    ],
    "duration": "10 giorni",
    "description": "Questo incantesimo attira o repelle un tipo di creatura. L'incantatore sceglie un bersaglio entro gittata, che puo' trattarsi di un oggetto o di una creatura di taglia Enorme o inferiore, o di un'area della grandezza massima di un cubo con spigolo di 60 metri. Dopodiché specifica un tipo di creatura intelligente, come i draghi rossi, i goblin o i vampiri. I'incantatore infonde nel bersaglio un'aura che attira o respinge le creature specificate per la durata dell'incantesimo, scegliendo antipatia o simpatia come effetto dell'aura. Quando una tale creatura vede il bersaglio o giunge entro 18 metri da esso, deve superare un tiro salvezza su Saggezza, altrimenti diventa spaventata. La creatura rimane spaventata fintanto che e' in grado di vedere il bersaglio o rimane entro 18 metri da esso. Finché e' spaventata dal bersaglio, deve usare il suo movimento per muoversi verso il punto sicuro piu' vicino da cui non vedra' piu' il bersaglio. Se la creatura si allontana a piu' di 18 metri dal bersaglio e non e' piu' in grado di vederlo, cessa di essere spaventata, ma lo diventa di nuovo se torna a vedere il bersaglio o a trovarsi entro 18 metri da esso. Quando una tale creatura vede il bersaglio o giunge entro 18 metri da esso, deve superare un tiro salvezza su Saggezza o usare il suo movimento in ogni suo turno per entrare nell'area o muoversi entro la portata del bersaglio. Una volta fatto questo, la creatura non puo' piu' muoversi volontariamente per allontanarsi dal bersaglio. Se il bersaglio infligge danni a una creatura influenzata o le nuoce in altri modi, essa puo' effettuare un tiro alvezza per terminare l'effetto come descritto sotto. Terminare l'Effetto. Se una creatura inftuenzata termina il suo turno oltre 18 metri dal bersaglio o non e' in grado di vederlo, effettua un tiro salvezza su Saggezza. Se lo supera, non e' piu' inftuenzata dal bersaglio e capisce che la sensazione di ripugnanza o di attrazione era magica. Inoltre, una creatura inftuenzata dall'incantesimo ha diritto a un altro tiro salvezza su Saggezza ogni 24 ore finché l'incantesimo permane. Una creatura che supera un tiro salvezza contro questo effetto e' immune a esso per 1 minuto, dopodiché puo' esserne influenzata di nuovo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di allume immerso nell'aceto per un effetto di antipatia o una goccia di miele per un effetto di simpatia",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "antipatiasimpatia",
    "language": "it"
  },
  {
    "name": "Arma Elementale",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Un'arma non magica toccata dall'incantatore diventa un'arma magica. L'incantatore sceglie uno dei tipi di danno seguenti: acido, freddo, fulmine, fuoco o tuono. Per la durata dell'incantesimo, l'arma ottiene un bonus di +1 ai tiri per colpire e infiigge 1d4 danni extra del tipo scelto quando colpisce.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° o 6° livello, il bonus ai tiri per colpire aumenta a +2 e i danni extra aumentano a 2d4.Quando l'incantatore usa uno slot incantesimo di 7° livello o superiore, il bonus aumenta a +3 e i danni extra aumentano a 3d4.",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "acido",
      "freddo",
      "fuoco",
      "fulmine",
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "arma-elementale",
    "language": "it"
  },
  {
    "name": "Arma Magica",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore tocca un'arma non magica e finché l'incantesimo non termina, quell'arma diventa un'arma magica con un bonus di +1 ai tiri per colpire e ai tiri per i danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, il bonus aumenta a +2.Quando l'incantatore usa uno slot incantesimo di 6° livello o superiore, il bonus aumenta a +3.",
    "availableClasses": [
      "Mago",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "arma-magica",
    "language": "it"
  },
  {
    "name": "Arma Spirituale",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore crea entro gittata un'arma fluttuante spettrale che permane per la durata dell'incantesimo o finché l'incantatore non lancia di nuovo questo incantesimo. Quando lancia questo incantesimo, l'incantatore puo' effettuare un attacco in mischia con questo incantesimo contro una creatura entro 1,5 metri dall'arma. Se colpisce, il bersaglio subisce 1d8 danni da forza + il modificatore di caratteristica da incantatore. Con un'azione bonus nel suo turno, l'incantatore puo' muovere l'arma di un massimo di 6 metri e ripetere l'attacco contro una creatura situata entro 1,5 metri da essa. L'arma puo' assumere la forma che l'incantatore preferisce. I chierici di una divinita' associata a un tipo particolare di arma (come per esempio St Cuthbert, noto per la sua mazza, o Thor per il suo martello) impartiranno all'arma creata da questo incantesimo la forma di tale arma.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° uvelo o superiore, i danni aumentano di 1d8 per ogni due slot incantesimo superiori al 2°.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "arma-spirituale",
    "language": "it"
  },
  {
    "name": "Armatura di Agathys",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (una coppa d'acqua)"
    ],
    "duration": "1 ora",
    "description": "Una forza magica protettiva circonda l'incantatore, manifestandosi come una patina di gelo spettrale chericopre sia lui che il suo equipaggiamento. L'incantatore ottiene 5 punti ferita temporanei per la durata dell'incantesimo. Se una creatura colpisce l'incantatore con un attacco in mischia finché egli possiede questi punti ferita, essa subisce 5 danni da freddo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, sia i punti ferita temporanei che i danni da freddo aumentano di 5 per ogni slot di livello  uperiore al 1°",
    "availableClasses": [
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una coppa d'acqua",
    "damageTypes": [
      "freddo"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "armatura-di-agathys",
    "language": "it"
  },
  {
    "name": "Armatura Magica",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un pezzo di cuoio trattato)"
    ],
    "duration": "8 ore",
    "description": "L'incantatore tocca una creatura consenziente che non indossi un'armatura, e una forza magica protettiva circonda quella creatura finché l'incantesimo non termina. La CA base del bersaglio diventa 13 + il suo modificatore di Destrezza. L'incantesimo termina se il bersaglio indossa un'armatura o se l'incantatore interrompe l'incantesimo con un'azione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pezzo di cuoio trattato",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "armatura-magica",
    "language": "it"
  },
  {
    "name": "Artificio Druidico",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Sussurrando agli spiriti della natura, l'incantatore crea uno degli effetti seguenti entro gittata:\r\nL'incantatore crea un minuscolo sensore innocuo che predice il tempo atmosferico nel suo luogo per le 24 ore successive. Il sensore potrebbe manifestarsi come un globo dorato in caso di cielo sereno, una nube in caso di pioggia, un ammasso di fiocchi di neve in caso di neve e cosi' via. L'effetto permane per 1 round. \r\nL'incantatore fa sbocciare istantaneamente un fiore, aprire un baccello o schiudere un germoglio. \r\nL'incantatore crea un effetto sensoriale istantaneo e innocuo come un cumulo di foglie volanti, uno sbuffo di vento, il rumore di un piccolo animale o il vago odore di una puzzola. L'effetto non deve essere piu' grande di un cubo con spigolo di 1,5 metri. \r\nL'incantatore accende o spegne istantaneamente una candela, una torcia o un piccolo fuoco da campo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "artificio-druidico",
    "language": "it"
  },
  {
    "name": "Aura di Purezza",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 9 metri)",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore emana un'aura di energia purificatrice entro un raggio di 9 metri. Finché l'incantesimo non termina, l'aura si muove assieme a lui ed e' centrata su di lui. Ogni creatura non ostile entro raura (incluso l'incantatore) non puo' diventare malata, e' dotata di resistenza ai danni da veleno e dispone di vantaggio ai tiri salvezza contro gli effetti che provocano qualsiasi condizione tra le seguenti:\r\naccecato;\r\naffascinato;\r\nassordato;\r\navvelenato;\r\nparalizzato;\r\nspaventato;\r\nstordito.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "aura-di-purezza",
    "language": "it"
  },
  {
    "name": "Aura di Vita",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 9 metri)",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore emana un'aura di energia che preserva la vita entro un raggio di 9 metri. Finché l'incantesimo non termina, l'aura si muove assieme a lui ed e' centrata su di lui. Ogni creatura non ostile entro l'aura (incluso l'incantatore) e' dotata di resistenza ai danni necrotici e il suo massimo dei punti ferita non puo' essere ridotto. Inoltre, ogni creatura vivente non ostile recupera 1 punto ferita quando inizia il proprio turno entro l'aura con 0 punti ferita.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "aura-di-vita",
    "language": "it"
  },
  {
    "name": "Aura di Vitalita'",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 9 metri)",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore emana un'aura di energia curativa entro un raggio di 9 metri. Finché l'incantesimo non termina, l'aura si muove assieme a lui ed e' incentrata su di lui. L'incantatore puo' usare un'azione bonus per far si che una creatura entro l'aura (incluso l'incantatore) recuperi 2d6 punti ferita.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "aura-di-vitalita-",
    "language": "it"
  },
  {
    "name": "Aura Magica di Nystul",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un pezzo quadrato di seta)"
    ],
    "duration": "24 ore",
    "description": "Il bersaglio puo' essere una creatura consenziente o un oggetto che non sia indossato o trasportato da un'altra creatura. Falsa Aura. L'incantatore cambia il modo in cui il bersaglio appare agli incantesimi e agli effetti magici che individuano le aure magiche, come per esempio Individuazione del Magico. L'incantatore puo' fare in modoche un oggetto non magico appaia magico o che un oggetto magico appaia non magico, oppure puo' cambiare l'aura magica dell'oggetto in modo che sembri appartenere a una scuola di magia specifica a sua scelta. Quando usa questo effetto su un oggetto, puo' rendere la falsa magia apparente a qualsiasi creatura che maneggi l'oggetto. Maschera. L'incantatore cambia il modo in cui il bersaglio appare agli incantesimi e agli effetti magici che individuano i tipi di creature, come la Percezione del Divino di un paladino o l'innesco di un incantesimo Simbolo. L'incantatore sceglie un tipo di creatura: gli altri incantesimi e oggetti magici considereranno ilbersaglio come se fosse una creatura di quel tipo o di quell'allineamento.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pezzo quadrato di seta",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "aura-magica-di-nystul",
    "language": "it"
  },
  {
    "name": "Aura Sacra",
    "level": 8,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un minuscolo reliquiario del valore di almeno 1.000 mo contenente una reliquia sacra, come un pezzo di stoffa della tunica di un santo o un frammento di pergamena di un testo religioso)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Dall'incantatore si diffonde una luce divina che si materializza in un tenue bagliore entro un raggio di 9 metri da lui. Le creature a sua scelta entro quel raggio nel momento in cui l'incantesimo viene lanciato proiettano luce fioca in un raggio di 1,5 metri e dispongono di vantaggio a tutti i tiri salvezza; le altre creature subiscono svantaggio ai tiri per colpire effettuati contro le creature scelte finché l'incantesimo non termina. Inoltre, usando un immondo o un non morto colpisce una creatura influenzata da questo incantesimo con un attacco in mischia, l'aura emette un bagliore accecante e l'attaccante deve superare un tiro salvezza su Costituzione, altrimenti resta accecato finché l'incantesimo non termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un minuscolo reliquiario del valore di almeno 1.000 mo contenente una reliquia sacra, come un pezzo di stoffa della tunica di un santo o un frammento di pergamena di un testo religioso",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "aura-sacra",
    "language": "it"
  },
  {
    "name": "Bacche Benefiche",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un rametto di vischio)"
    ],
    "duration": "Istantanea",
    "description": "Fino a dieci bacche compaiono in mano all'incantatore e sono pervase di magia per la durata dell'incantesimo. Una creatura puo' usare la sua azione per mangiare una bacca. Mangiare una bacca ripristina 1 punto ferita e la bacca fornisce nutrimento sufficiente a sfamare una creatura per un giorno. Le bacche perdono il loro potere se non vengono mangiate entro 24 ore dal lancio di questo incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un rametto di vischio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "bacche-benefiche",
    "language": "it"
  },
  {
    "name": "Bagliore Lunare",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (alcuni semi di qualsiasi pianta a chicchi e un frammento di feldspato opalescente)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Un bagliore argentato di luce pallida forma un cilindro del raggio di 1,5 metri e alto 12 metri, centrato su un punto entro gittata. Finché l'incantesimo non termina, il cilindro e' pervaso di luce fioca. Quando una creatura entra nell'area dell'incantesimo per la prima volta in un turno o vi inizia il proprio turno, viene avvolta da una cortina di fiamme spettrali che le provocano un dolore lancinante e la obbligano a effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 2d10 danni radiosi, mentre se lo supera, subisce soltanto la meta' di quei danni. Un mutaforma subisce svantaggio a questo tiro salvezza. Inoltre, se lo fallisce, riassume istantaneamente la sua forma originale e non puo' assumere una forma diversa finché non esce dalla luce dell'incantesimo. Nei suoi turni successivi, dopo avere lanciato questo incantesimo, l'incantatore puo' usare un'azione per muovere il bagliore di un massimo di 18 metri in qualsiasi direzione.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni aumentano di 1d10 per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "alcuni semi di qualsiasi pianta a chicchi e un frammento di feldspato opalescente",
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "bagliore-lunare",
    "language": "it"
  },
  {
    "name": "Bagliore Solare",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (linea di 18 metri)",
    "components": [
      "V",
      " S",
      " M (una lente d'ingrandimento)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Un bagliore di luce brillante scaturisce dalla mano dell'incantatore e genera una linea lunga 18 metri e larga 1,5 metri. Ogni creatura sulla linea deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 6d8 danni radiosi ed e' accecata fino al turno successivo dell'incantatore, mentre se lo supera, subisce soltanto lameta' di quei danni e non e' accecata da questo incantesirvo. Le melme e i non morti subiscono svantaggio a questo tiro salvezza. L'incantatore puo' creare una nuova linea di energia radiosa con la sua azione in qualsiasi turno finché l'incantesimo non termina. Per la durata dell'incantesimo, una scintilla di energia radiosa risplende nella mano dell'incantatore e proietta luce intensa entro un raggio di 9 metri e luce fioca per altri 9 metri. Questa luce e' considerata luce solare.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una lente d'ingrandimento",
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "bagliore-solare",
    "language": "it"
  },
  {
    "name": "Banchetto degli Eroi",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M, (una scodella tempestata di gemme del valore di almeno 1.000 mo, che l'incantatore consuma)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore evoca un grande banchetto, completo di sontuose pietanze e bevande. Pasteggiare al banchetto richiede 1 ora, al termine della quale il banchetto scompare; gli effetti benefici del banchetto non si applicano finché quell'ora non e' trascorsa. Fino a un massimo di altre dodici creature possono partecipare al banchetto. Una creatura che partecipa al banchetto ottiene vari benefici: viene curata da tutte le malattie e dai veleni, diventa immune ai veleni e alla condizione di spaventato, dispone di vantaggio a tutti i tiri salvezza su Saggezza, il suo massimo dei punti ferita aumenta di 2d10 e ottiene quello stesso numero di punti ferita. Questi benefici durano per 24 ore.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una scodella tempestata di gemme del valore di almeno 1.000 mo, che l'incantatore consuma",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "banchetto-degli-eroi",
    "language": "it"
  },
  {
    "name": "Barriera di Lame",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore crea un muro verticale di lame affilate turbinanti, fatte di energia magica. Il muro appare entro gittata e permane per la durata dell'incantesimo. L'incantatore puo' creare un muro in linea retta lungo fino a 30 metri, alto 6 metri e spesso 1,5 metri, oppure un muro circolare del diametro massimo di 18 metri, alto 6 metri e Spesso 1,5 metri. Il muro fornisce tre quarti di copertura alle creature dietro di esso e il suo spazio e' considerato terreno difficile. Quando una creatura entra nell'area del muro per la prima volta in un turno o vi inizia il proprio turno, essa deve superare, un tiro salvezza su Destrezza. Se lo fallisce, subisce 6d10 danni taglienti, mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "taglienti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "barriera-di-lame",
    "language": "it"
  },
  {
    "name": "Beffa Crudele",
    "level": 0,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore pronuncia una sequenza di insulti mescolati a sottili ammaliamenti contro una creatura entro gittata e che egli sia in grado di vedere. Se il bersaglio e' in grado di sentirlo (non e' neressario che lo capisca), deve superare un tiro salvezza su Saggezza, altrimenti subisce 1d4 danni psichici e svantaggio al tiro per colpire successivo che effettua prima della fine del suo turno successivo. I danni di questo incantesimo aumentano di 1d4 quando l'incantatore arriva al 5° livello (2d4), 11° livello (3d4) e 17° livello (4d4).",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "beffa-crudele",
    "language": "it"
  },
  {
    "name": "Benedizione",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (uno spruzzo di acqua santa)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore benedice fino a tre creature a sua scelta entro gittata. Ogni volta che un bersaglio effettua un tiro per colpire o un tiro salvezza prima che l'incantesimo termini puo' tirare un d4 e aggiungere il numero ottenuto al tiro per colpire o al tiro salvezza.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot superiore al 1°.",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "uno spruzzo di acqua santa",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "benedizione",
    "language": "it"
  },
  {
    "name": "Blocca Mostri",
    "level": 5,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (una piccola sbarra di ferro)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore sceglie una creatura entro gittata e che egli sia in grado di vedere. Il bersaglio deve superare un tiro salvezza su Saggezza, altrimenti sara' paralizzato per la durata dell'incantesimo. Questo incantesimo non ha effetto sui non morti. Alla fine di ogni suo turno, il bersaglio puo' effettuare un altro tiro salvezza su Saggezza. Se lo supera, l'incantesimo su di esso termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 5°.Le creature devono trovarsi a non piu' di 9 metri l'una dall'altra quando l'incantatore le bersaglia.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola sbarra di ferro",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "blocca-mostri",
    "language": "it"
  },
  {
    "name": "Blocca Persone",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (una piccola sbarra di ferro)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore sceglie un umanoide entro gittata e che egli sia in grado di vedere. Il bersaglio deve superare un tiro salvezza su Saggezza, altrimenti sara' paralizzato per la durata dell'incantesimo. Alla fine di ogni suo turno, il bersaglio puo' effettuare un altro tiro salvezza su Saggezza. Se lo supera, l'incantesimo su di esso termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, puo' bersagliare un umanoide aggiuntivo per ogni slot di livello superiore al 2°.Gli umanoidi devono trovarsi a non piu' di 9 metri l'uno dall'altro quando l'incantatore li bersaglia.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola sbarra di ferro",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "blocca-persone",
    "language": "it"
  },
  {
    "name": "Bocca Magica",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di un favo e polvere di giada del valore di almeno 10 mo, che l'incantesimo consuma)"
    ],
    "duration": "Finché non viene dissolto",
    "description": "L'incantatore inserisce un messaggio in un oggetto entro gittata, che sara' enunciato quando una condizione di innesco sara' soddisfatta. L'incantatore sceglie un oggetto che egli e' in grado di vedere e che non sia indossato o trasportato da un'altra creatura. Quindi pronuncia il messaggio, che non deve essere piu' lungo di 25 parole, e che puo' tuttavia essere ripetuto entro un periodo massimo di 10 minuti. Infine, l'incantatore determina la circostanza che inneschera' l'incantesimo e l'enunciazione del messaggio. Quando quella circostanza si verifica, una bocca magica appare sull'oggetto e recita il messaggio con la voce dell'incantatore, allo stesso volume in cui egli l'ha pronunciato. Se l'oggetto scelto dall'incantatore ha una bocca o qualcosa di simile a una bocca (per esempio, la bocca di una statua), la bocca magica appare in modo che le parole sembrino pronunciate dalla bocca dell'oggetto. Al momento del lancio, l'incantatore puo' stabilire se l'incantesimo termina nel momento in cui il messaggio viene enunciato o se esso viene ripetuto qualora le circostanze di innesco si verifichino di nuovo. La circostanza di innesco puo' essere generale o dettagliata, ma deve essere basata su condizioni visibili o udibili che si verifichino entro 9 metri dall'oggetto. Per esempio, l'incantatore potrebbe ordinare alla bocca di parlare quando una qualsiasi creatura giunge entro 9 metri dall'oggetto o quando una campana d'argento suona entro 9 metri da esso.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di un favo e polvere di giada del valore di almeno 10 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "bocca-magica",
    "language": "it"
  },
  {
    "name": "Braccia di Hadar",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore (raggio di 3 metri)",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore invoca il potere di Hadar, la Fame Oscura. Dalla sua persona si protendono alcuni tentacoli di energia oscura che tempestano di colpi tutte le creature entro 3 metri da lui. Ogni creatura in quell'area deve effettuare un tiro salvezza su Forza. Se lo fallisce, subisce 2d6 danni necrotici e non puo' effettuare reazioni fino al suo turno successivo. Se lo supera, subisce soltanto la meta' di quei danni, ma non subisce altri effetti.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d6 per ogni slot superiore al 1°.",
    "availableClasses": [
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "braccia-di-hadar",
    "language": "it"
  },
  {
    "name": "Caduta Morbida",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " M (una piccola piuma)"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore sceglie fino a cinque creature in caduta entro gittata. La velocita' di discesa di una creatura in caduta rallenta fino a 18 metri per round finché l'incantesimo non termina. Se la creatura atterra prima che l'incantesimo termini, essa non subisce alcun danno da caduta e puo' atterrare in piedi, e l'incantesimo termina per quella creatura.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola piuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "caduta-morbida",
    "language": "it"
  },
  {
    "name": "Calmare Emozioni",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di sopprimere le emozioni piu' intense in un gruppo di persone. Ogni umanoide entro una sfera del raggio di 6 metri centrata su un punto scelto dall'incantatore entro gittata deve effettuare un tiro salvezza su Carisma; una creatura puo' scegliere di fallire questo tiro salvezza, se lo desidera. Se una creatura fallisce il suo tiro salvezza, l'incantatore sceglie uno dei due effetti seguenti. L'incantatore puo' sopprimere qualsiasi effetto che rende un bersaglio affascinato o spaventato. Quando questo incantesimo termina, ogni effetto soppresso torna a essere applicato, purché la sua durata non si sia esaurita nel frattempo. In alternativa, l'incantatore puo' rendere un bersaglio indifferente ad alcune creature da lui scelte nei cui confronti il bersaglio risulterebbe ostile. Questa indifferenza termina se il bersaglio viene attaccato o danneggiato da un incantesimo, o se vede uno dei suoi amici subire danni. Quando l'incantesimo termina, la creatura torna a essere ostile, a meno che il DM non decida altrimenti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "calmare-emozioni",
    "language": "it"
  },
  {
    "name": "Camminare nel Vento",
    "level": 6,
    "school": "Trasmutazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (fuoco e acqua santa)"
    ],
    "duration": "8 ore",
    "description": "L'incantatore e un massimo di dieci creature consenzienti entro gittata e che egli sia in grado di vedere assumono Forma Gassosa per la durata dell'incantesimo, apparendo come sbuffi di fumo. Finché rimane in questa forma gassosa, una creatura possiede una velocita' di volare pari a 90 metri e resistenza ai danni delle armi non magiche. Le uniche azioni che una creatura puo' effettuare in questa forma sono l'azione di Scatto o tornare alla propria forma normale. Per tornare alla propria forma normale e' necessario 1 minuto, durante il quale la creatura e' incapacitata e non e' in grado di muoversi. Finché l'incantesimo non termina, la creatura puo' riassumere forma gassosa, cosa che richiede a sua volta 1 minuto per la trasformazione. Se una creatura si trova in forma gassosa e sta volando quando l'effetto termina, scende di 18 metri per round per 1 minuto finché non atterra, senza subire danni. Se pero' non riesce ad atterrare dopo 1 minuto, cade della distanza rimanente.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "fuoco e acqua santa",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "camminare-nel-vento",
    "language": "it"
  },
  {
    "name": "Camminare sull’Acqua",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un pezzo di sughero)"
    ],
    "duration": "1 ora",
    "description": "Questo incantesimo conferisce la capacita' di muoversi su una qualsiasi superficie liquida come l'acqua, l'acido,il fango, la neve, le sabbie mobili o la lava, come se si trattasse di un innocuo terreno solido (ma le creature che attraversano un tratto di lava fusa possono comunque subire danni dal calore). Fino a dieci creature consenzienti entro gittata e che l'incantatore sia in grado di vedere ottengono questa capacita' per la durata dell'incantesimo. Se l'incantatore bersaglia una creatura immersa in un liquido, l'incantesimo porta il bersaglio alla superficie di quel liquido a una velocita' di 18 metri per round.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pezzo di sughero",
    "damageTypes": [
      "acido"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "camminare-sullacqua",
    "language": "it"
  },
  {
    "name": "Campo Anti-Magia",
    "level": 8,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un pizzico di polvere o di limatura di ferro)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore viene circondato da una sfera di anti-magia invisibile del raggio di 3 metri. Quest'area e' isolata dall'energia magica che pervade il multiverso. All'interno della sfera non e' possibile lanciare incantesimi, le creature evocate scompaiono e perfino gli oggetti magici diventano oggetti comuni. Finché l'incantesimo non termina, la sfera si muove assieme all'incantatore, centrata su di lui. Gli incantesimi e gli altri effetti magici, ad eccezione di quelli creati da un artefatto o da una divinita', sono soppressi all'interno della sfera e non possono spingersi all'interno di essa. Uno slot speso per lanciare un incantesimo soppresso viene consumato. Finché un effetto e' soppresso, esso non funziona, ma il tempo che trascorre da soppresso viene comunque sottratto dalla sua durata. \r\nEffetti a Bersaglio. Gli incantesimi e gli altri effetti magici, come dardo incantato e charme su persone, che bersagliano una creatura o un oggetto all'interno della sfera non hanno alcun effetto su quel bersaglio. \r\nAree di Magia. L'area di un altro incantesimo o effetto magico, come palla di fuoco, non puo' estendersi all'interno della sfera. Se la sfera si sovrappone a un'area di magia, quella parte dell'area che e' coperta dalla sfera viene soppressa. Per esempio, le fiamme create da un muro di' fuoco sono soppresse all'interno della sfera e creano un varco nel muro se la sovrapposizione e' larga a sufficienza. \r\nIncantesimi. Ogni incantesimo o altro effetto magico su una creatura o un oggetto all'interno della sfera e' soppresso finché la creatura o l'oggetto in questione si trova al suo interno. \r\nOggetti Magici. Le proprieta' e i poteri degli oggetti magici sono soppressi all'interno della sfera. Per esempio, una spada lunga +1 all'interno della sfera funziona come una spada lunga non magica. Le proprieta' e i poteri di un'arma magica vengono soppressi se usati contro un bersaglio all'interno della sfera o impugnati da un attaccante all'interno della sfera. Se un'arma magica o una munizione magica esce interamente dalla sfera (per esempio se l'incantatore scaglia una freccia magica o una lancia magica verso un bersaglio al di fuori della sfera), la magia dell'oggetto cessa di essere soppressa non appena esce. \r\nViaggio Magico. Il teletrasporto e i viaggi planari non funzionano all'interno della sfera, che essa costituisca il punto di partenza o di arrivo di un tale viaggio magico. Un Portale verso un altro luogo, mondo o piano di esistenza, nonché un varco verso uno spazio extradimensionale come quello creato dall'incantesimo Trucco della Corda, si chiude temporaneamente finché si trova all'interno della sfera. \r\nCreatura e Oggetti. Una creatura o un oggetto evocato o creato dalla magia svanisce temporaneamente dall'esistenza all'interno della sfera. Una tale creatura ricompare istantaneamente una volta che lo spazio che essa occupa non si trova piu' all'interno della sfera. \r\nDissolvi Magie. Gli incantesimi e gli effetti magici come Dissolvi Magie non hanno alcun effetto sulla sfera. Analogamente, le sfere create da piu' incantesimi campo anti-magia non si annullano a vicenda.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di polvere o di limatura di ferro",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "campo-anti-magia",
    "language": "it"
  },
  {
    "name": "Camuffare Sé Stesso",
    "level": 1,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 ora",
    "description": "L'incantatore assume un aspetto diverso (che include i suoi abiti, armatura, armi e altri oggetti personali presenti sulla sua persona) per la durata dell'incantesimo o finché egli non usa la sua azione per terminarlo. I cambiamenti apportati da questo incantesimo non passano il vaglio di un'ispezione fisica. Per esempio, se l'incantatore usa questo incantesimo per aggiungere un cappello in testa, gli oggetti passerebbero attraverso il cappello e chiunque tocchi l'incantatore non sentirebbe nulla o toccherebbe la testa e i capelli dell'incantatore. Se l'incantatore usa questo incantesimo per apparire piu' magro rispetto alla realta', quando qualcuno protende la mano per toccarlo, urta l'incantatore quando la sua mano e' apparentemente ancora a mezz'aria. Per capire che l'incantatore e' camuffato, una creatura puo' usare la sua azione per ispezionare il suo aspetto e deve superare una prova di Intelligenza (Indagare) contro la CD del tiro salvezza dell'incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "camuffare-sé-stesso",
    "language": "it"
  },
  {
    "name": "Capanna di Leomund",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "Incantatore (semisfera del raggio di 3 metri)",
    "components": [
      "V",
      " S",
      " M (una biglia di cristallo)"
    ],
    "duration": "8 ore",
    "description": "Una cupola di forza immobile del raggio di 3 metri si materializza attorno all'incantatore e sopra di lui, epermane stazionaria per la durata dell'incantesimo. L'incantesimo termina se l'incantatore esce dalla sua area. Nove creature di taglia Media o inferiore possono essere ospitate all'interno della cupola assieme all'incantatore. L'incantesimo fallisce se la sua area include una creatura piu' grande o piu' di nove creature. Le creature e gli oggetti all'interno della cupola al momento del lancio dell'incantesimo possono attraversarla liberamente. A tutte le altre creature e oggetti e' proibito attraversarla. Gli incantesimi e gli altri effetti magici non possono estendersi attraverso la cupola o essere lanciati attraverso di essa. L'atmosfera all'interno dell'area e' gradevole e asciutta, a prescindere dal tempo atmosforico all'esterno. Finché l'incantesimo non termina, l'incantatore puo' decidere che all'interno della cupola ci sia luce fioca o oscurita'. La cupola appare opaca dall'esterno (di qualsiasi colore a scelta dell'incantatore), ma appare trasparente dall'interno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una biglia di cristallo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "capanna-di-leomund",
    "language": "it"
  },
  {
    "name": "Caratteristica Potenziata",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (peli o piume strappati a una bestia)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore tocca una creatura e le conferisce un potenziamento magico, scegliendo uno degli effetti seguenti che permane finché l'incantesimo non termina.",
    "atHigherLevels": "Quando rincantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot di livello uperiore al 2°.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "peli o piume strappati a una bestia",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "caratteristica-potenziata",
    "language": "it"
  },
  {
    "name": "Carne in Pietra",
    "level": 6,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di pietra calcarea, acqua e terra)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di pietrificare una creatura entro gittata e che egli sia in grado di vedere. Se il corpo del bersaglio e' fatto di carne, la creatura deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, e' trattenuto e la sua carne inizia a indurirsi, mentre se lo supera, non subisce alcun effetto. Una creatura trattenuta da questo incantesimo deve effettuare un altro tiro salvezza su Costituzione alla fine di ogni suo turno. Se supera il tiro salvezza contro questo incantesimo per tre volte, l'incantesimo termina. Se la creatura fallisce il tiro salvezza per tre volte, si trasforma in pietra ed e' soggetta alla condizione di pietrificato per la durata dell'incantesimo. Non e' necessario che i successi e i fallimenti siano consecutivi; basta tenere il conto di entrambi finché il bersaglio non accumula tre risultati di un determinato tipo. Se la creatura subisce una rottura fisica di qualche tipo mentre e' pietrificata, subira' una deformita' analoga quando torna al suo stato originale. Se l'incantatore mantiene la concentrazione su questo incantesimo per l'intera durata possibile, la creatura e' pietrificata finché l'effetto non viene rimosso.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di pietra calcarea, acqua e terra",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "carne-in-pietra",
    "language": "it"
  },
  {
    "name": "Catena di Fulmini",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (un ciuffo di pelliccia, un frammento d'ambra, di vetro o di una verga di cristallo, e tre spilli)"
    ],
    "duration": "Istantanea",
    "description": "I'incantatore crea un fulmine che sfreccia verso un bersaglio a sua scelta entro gittata e che egli sia in gradodi vedere. Tre fulmini sfrecciano poi dal bersaglio verso un massimo di altri tre bersagli, ognuno dei quali devetrovarsi entro 9 metri dal primo bersaglio. L'incantesimo puo' bersagliare una creatura o un oggetto, che puo' esserie bersagliato soltanto da uno dei fulmini. Un bersaglio deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 10d8 danni da fulmine mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, un fulmine aggiuntivo sfreccia dal primo bersaglio a un altro bersaglio per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di pelliccia, un frammento d'ambra, di vetro o di una verga di cristallo, e tre spilli",
    "damageTypes": [
      "fulmine"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "catena-di-fulmini",
    "language": "it"
  },
  {
    "name": "Cecita'/Sordita'",
    "level": 2,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore puo' accecare o assordare un nemico, scegliendo una creatura entro gittata e che egli sia in grado di vedere. Quella creatura deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, e' accecata o assordata (a scelta dell'incantatore) per la durata dell'incantesimo. Alla fine di ogni suo turno puo' effettuare un nuovo tiro salvezza su Costituzione. Se lo supera. l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot superiore al 2°.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "cecita-sordita-",
    "language": "it"
  },
  {
    "name": "Celare",
    "level": 7,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (una mistura composta di polvere di diamante, smeraldo, rubino e zaffiro del valore di almeno 5.000 mo, che l'incantesimo consuma)"
    ],
    "duration": "Finché non viene dissolto",
    "description": "Questo incantesimo consente all'incantatore di nascondere una creatura consenziente o un oggetto dai tentativi di individuazione per la durata dell'incantesimo. Quando l'incantatore lancia questo incantesimo e tocca il bersaglio, quest'ultimo diventa invisibile e non puo' essere bersagliato dagli incantesimi di divinazione o percepito dai sensori di scrutamento creati dagli incantesimi di divinazione. Se il bersaglio e' una creatura, essa entra in uno stato di animazione sospesa e smette di invecchiare; il tempo cessa di scorrere per lei. L'incantatore puo' stabilire una condizione che porra' termine all'incantesimo prematuramente. La condizione puo' essere qualsiasi cosa a sua scelta, ma deve verificarsi o essere visibile entro 1. 5 km dal bersaglio. Alcuni esempi includono \"dopo 1. 000 anni\" o \"quando il tarrasque si risveglia\". Questo incantesimo termina anche se il bersaglio subisce danni",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una mistura composta di polvere di diamante, smeraldo, rubino e zaffiro del valore di almeno 5.000 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "celare",
    "language": "it"
  },
  {
    "name": "Cerchio di Morte",
    "level": 6,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (polvere ricavata da una perla nera del valore di almeno 500 mo)"
    ],
    "duration": "Istantanea",
    "description": "Una sfera di energia negativa si espande crepitando fino a un raggio di 18 metri da un punto entro gittata. Ogni creatura entro quell'area deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 8d6 danni necrotici, mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, i danni aumentano di 2d6 per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "polvere ricavata da una perla nera del valore di almeno 500 mo",
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "cerchio-di-morte",
    "language": "it"
  },
  {
    "name": "Cerchio di Potere",
    "level": 5,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 9 metri)",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Dall'incantatore si irradia un flusso di energia divina distorcente entro un raggio di 9 metri. Finché l'incantesimo non termina, la sfera si muove assieme a lui ed e' centrata su di lui. Per la durata dell'incantesimo, ogni creatura amica situata entro l'area (incluso l'incantatore) dispone di vantaggio ai tiri salvezza contro gli incantesimi e gli altri effetti magici. Inoltre, quando una creatura influenzata supera un tiro salvezza contro un incantesimo o un effetto magico che consente un tiro salvezza per subire solo la meta' dei danni, in caso di tiro salvezza superato non subisce alcun danno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "cerchio-di-potere",
    "language": "it"
  },
  {
    "name": "Cerchio di Teletrasporto",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " M (gessetti e inchiostri rari infusi di gemme preziose del valore di 50 mo",
      " che l'incantesimo consuma)"
    ],
    "duration": "1 round",
    "description": "Quando l'incantatore lancia l'incantesimo, traccia un cerchio del diametro di 3 metri dotato di simboli checollegano il suo luogo a un cerchio di teletrasporto permanente a sua scelta, di cui gli e' nota la sequenza disimboli e che si trovi sul suo stesso piano di esistenza. All'interno del cerchio tracciato dall'incantatore si apre un portale scintillante che resta aperto fino alla fine del turno successivo dell'incantatore. Ogni creatura che entra nel portale appare istantaneamente entro 1,5 metri dal cerchio di destinazione, o nello spazio libero piu' vicino, se quello spazio e' occupato. Molti dei piu' importanti templi, gilde e altri luoghi simili possiedono un cerchio di teletrasporto permanente tracciato da qualche parte entro i loro confini. A ogni cerchio di questo tipo e' abbinata una sequenza di simboli unica, una serie di rune magiche disposte secondo uno schema particolare. Quando l'incantatore ottiene per la prima volta la capacita' di lanciare questo incantesimo, apprende la sequenza di simboli abbinata a due destinazioni situate sul Piano Materiale determinate dal DM. L'incantatore puo' apprendere ulteriori sequenze di simboli nel corso delle sue avventure. Per imparare a memoria una nuova sequenza di simboli ha bisogno di studiarla per 1 minuto. L'incantatore puo' creare un cerchio di teletrasporto permanente lanciando questo incantesimo sullo stesso luogo ogni giorno per un anno. Non e' obbligato a usare il cerchio di teletrasporto quando lo lancia in questo modo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "gessetti e inchiostri rari infusi di gemme preziose del valore di 50 mo che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "cerchio-di-teletrasporto",
    "language": "it"
  },
  {
    "name": "Cerchio Magico",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S",
      " M (acqua santa o polvere d'argento e di ferro del valore di almeno 100 mo, che l'incantesimo consuma)"
    ],
    "duration": "1 ora",
    "description": "L'incantatore crea un cilindro di energia magica del raggio di 3 metri e alto 6 metri centrato su un punto del terreno situato entro gittata e che egli sia in grado di vedere. Una sequenza di rune scintillanti appare nel punto in cui il cilindro si interseca con il pavimento o un'altra superficie. L'incantatore sceglie uno o piu' tipi di creature seguenti:Il cerchio influenza una creatura del tipo scelto nei modi seguenti:Quando l'incantatore lancia questo incantesimo, puo' decidere che la sua magia funzioni nella direzione inversa, impedendo a una creatura del tipo specificato di uscire dal cilindro e proteggendo i bersagli all'esterno.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, la durata aumenta di 1 ora per ogni slot di livello superiore al 3°.",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Paladino",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "acqua santa o polvere d'argento e di ferro del valore di almeno 100 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "cerchio-magico",
    "language": "it"
  },
  {
    "name": "Charme su Persone",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 ora",
    "description": "L'incantatore tenta di affascinare un umanoide entro gittata e che egli sia in grado di vedere. L'umanoide deve effettuare un tiro salvezza su Saggezza e dispone di vantaggio se l'incantatore o i suoi compagni stanno combattendo contro di lui. Se lo fallisce, e' affascinato dall'incantatore finché l'incantesimo non termina o finché l'incantatore o i suoi compagni non lo danneggiano in qualche modo. La creatura affascinata considera l'incantatore una figura conosciuta e amichevole. Quando l'incantesimo termina, la creatura capira' di essere stata affascinata dall'incantatore.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 1°.Le creature devono trovarsi a non piu' di 9 metri l'una dall'altra quando l'incantatore le bersaglia.",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "charme-su-persone",
    "language": "it"
  },
  {
    "name": "Chiaroveggenza",
    "level": 3,
    "school": "Divinazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": true,
    "range": "1,5 km",
    "components": [
      "V",
      " S",
      " M (un focus del valore di almeno 100 mo, a scelta tra un cornetto acustico ingioiellato per l'udito o un occhio di vetro per la vista)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'ncantatore crea un sensore invisibile entro gittata in un luogo a lui familiare (vale a dire un luogo che abbia visitato o visto in precedenza), oppure in un luogo ovvio che non gli sia familiare (per esempio dietro una porta, oltre un angolo o in mezzo a un boschetto). Il sensore rimane al suo posto per la durata dell'incantesimo e non e' possibile attaccarlo o interagire con esso in altri modi. Quando l'incantatore lancia l'incantesimo sceglie tra vista e udito. Puo' usare il senso scelto tramite il sensore, come se si trovasse nel suo spazio. Usando la sua azione, l'incantatore puo' passare da vista a udito o viceversa. Una creatura in grado di vedere il sensore (per esempio una creatura che beneficia di Vedere Invisibilita' o vista pura) vede un globo luminoso e intangibile grande all'incirca quanto il pugno dell'incantatore.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un focus del valore di almeno 100 mo, a scelta tra un cornetto acustico ingioiellato per l'udito o un occhio di vetro per la vista",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "chiaroveggenza",
    "language": "it"
  },
  {
    "name": "Clone",
    "level": 8,
    "school": "Necromanzia",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V. S",
      " M (un diamante del valore di almeno 1.000 mo e un cubo di carne della creatura da clonare con spigolo di almeno 2",
      "5 cm, che l'incantesimo consuma, e un involucro del valore di almeno 2.000 mo che abbia un coperchio sigillabile e sia abbastanza grande da contenere una creatura Media, come un'urna enorme, una bara, una ciste piena di fango nel terreno o un contenitore di cristallo riempito d'acqua salata)"
    ],
    "duration": "Istantanea",
    "description": "Questo incantesimo sviluppa un duplicato inerte di una creatura vivente come misura di sicurezza contro la morte. Questo clone si sviluppa all'interno di un involucro sigillato e raggiunge la taglia completa e la maturita' dopo 120 giorni; l'incantatore puo' anche scegliere che il clone sia una versione piu' giovane della stessa creatura. li clone rimane inerte e permane a tempo indeterminato, fintanto che il suo involucro rimane indisturbato. In un qualsiasi momento dopo che il clone e' giunto a maturazione, se la creatura originale muore, la sua anima si trasferisce nel clone, purché quell'anima sia libera e disposta a tornare. li clone e' fisicamente identico all'originale e possiede la personalita', i ricordi e le capacita' dell'originale, ma non il suo equipaggiamento. I resti fisici della creatura originale, se ancora esistono, diventano inerti e non possono piu' essere riportati in vita, dal momento che l'anima della creatura si trova altrove.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un diamante del valore di almeno 1.000 mo e un cubo di carne della creatura da clonare con spigolo di almeno 25 cm, che l'incantesimo consuma, e un involucro del valore di almeno 2.000 mo che abbia un coperchio sigillabile e sia abbastanza grande da contenere una creatura Media, come un'urna enorme, una bara, una ciste piena di fango nel terreno o un contenitore di cristallo riempito d'acqua salata",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "clone",
    "language": "it"
  },
  {
    "name": "Colpo Accurato",
    "level": 0,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "S"
    ],
    "duration": "Concentrazione, fino a 1 round",
    "description": "L'incantatore punta un dito contro un bersaglio entro gittata. La sua magia gli conferisce una fugace e accurata percezione delle difese del bersaglio. Nel suo turno successivo, l'incantatore dispone di vantaggio al suo tiro per colpire contro quel bersaglio, purché l'incantesimo non sia terminato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "colpo-accurato",
    "language": "it"
  },
  {
    "name": "Colpo Infuocato",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di zolfo)"
    ],
    "duration": "Istantanea",
    "description": "Una colonna verticale di fuoco divino scende dal cielo con un boato in un luogo indicato dall'incantatore. Ogni creatura entro un cilindro del raggio di 3 metri e alto 12 metri centrato su un punto entro gittata deve effettuare un tiro salvezza su Destrezza. Se lo fallisce subisce 4d6 danni da fuoco e 4d6 danni radiosi, mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, i danni da fuoco o i danni radiosi (a scelta dell'incantatore) aumentano di 1d6 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di zolfo",
    "damageTypes": [
      "fuoco",
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "colpo-infuocato",
    "language": "it"
  },
  {
    "name": "Colpo Intrappolante",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un attacco con un'arma entro la durata di questo incantesimo, una massa brulicante di rampicanti spinosi appare nel luogo dell'impatto e il bersaglio deve superare un tiro salvezza su Forza, altrimenti e' trattenuto dai rampicanti magici finché l'incantesimo non termina. Una creatura di taglia Grande o superiore dispone di vantaggi a questo tiro salvezza. Se il bersaglio supera il tiro salvezza, i rampicanti si ritraggono e avvizziscono. Finché e' trattenuto da questo incantesimo, il bersaglio subisce 1d6 danni perforanti all'inizio di ogni suo turno. Una creatura trattenuta dai rampicanti o un'altra creatura in grado di toccare la creatura trattenuta puo' usare la sua azione per effettuare una prova di Forza contro la CD del tiro salvezza dell'incantesimo. In caso di successo, la creatura bersaglio e' liberata.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "colpo-intrappolante",
    "language": "it"
  },
  {
    "name": "Comando",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "1 round",
    "description": "L'incantatore rivolge un comando di una parola a una creatura entro gittata e che egli sia in grado di vedere. Il bersaglio deve superare un tiro salvezza su Saggezza altrimenti obbedira' al comando nel proprio turno successivo. L'incantesimo non ha effetto se il bersaglio e' un non morto, se non capisce il linguaggio dell'incantatore o se il comando di quest'ultimo si rivela dannoso in modo diretto. Di seguito sono descritti alcuni tipici comandi assieme ai loro effetti. L'incantatore puo' impartire un comando diverso da quelli descritti di seguito. In quel caso e' il DM a determinare come si comporta il bersaglio. Se il bersaglio non puo' eseguire il comando, l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, puo' influenzare una creatura aggiuntiva per ogni slot di livello superiore al 1°.Le creature devono trovarsi a non piu' di 9 metri l'una dall'altra quando l'incantatore le bersaglia.",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "comando",
    "language": "it"
  },
  {
    "name": "Comprensione dei Linguaggi",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un pizzico di fuliggine e di sale)"
    ],
    "duration": "1 ora",
    "description": "Per la durata dell'incantesimo, l'incantatore comprende il significato letterale di qualsiasi linguaggio parlato che e' in grado di sentire. Comprende inoltre ogni linguaggio scritto che e' in grado di vedere, ma deve toccare la superficie su cui sono scritte le parole. È necessario circa 1 minuto per leggere una pagina di testo. Questo incantesimo non decodifica i messaggi segreti di un testo o di un glifo, come un sigillo arcano, che non faccia parte di un linguaggio scritto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di fuliggine e di sale",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "comprensione-dei-linguaggi",
    "language": "it"
  },
  {
    "name": "Compulsione",
    "level": 4,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Le creature a scelta dell'incantatore entro gittata, che siano in grado di sentirlo e che egli sia in grado di vedere, devono effettuare un tiro salvezza su Saggezza. Un bersaglio supera automaticamente questo tiro salvezza se non puo' essere affascinato. In caso di tiro salvezza fallito, un bersaglio e' influenzato da questo incantesimo. Finché l'incantesimo non termina, l'incantatore puo' usare un'azione bonus a ogni suo turno per designare una direzione orizzontale rispetto a lui. Ogni bersaglio influenzato deve usare la maggior parte possibile del suo movimento per muoversi in quella direzione nel suo turno successivo. Puo' effettuare la sua azione prima di muoversi. Dopo essersi mosso in questo modo, un bersaglio puo' effettuare un altro tiro salvezza su Saggezza per cercare di terminare l'effetto. Un bersaglio non e' obbligato a muoversi verso un terreno palesemente pericoloso, come un incendio o una fossa, ma provochera' attacchi di opportunita' nel muoversi verso la direzione designata.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "compulsione",
    "language": "it"
  },
  {
    "name": "Comunione",
    "level": 5,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (incenso e una fiala di acqua santa o sacrilega)"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore contatta la sua divinita' o un emissario di quella divinita' e pone fino a tre domande a cui sia possibile rispondere si' o no. L'incantatore deve porre le domande prima che l'incantesimo termini e riceve la risposta esatta a ogni domanda. Gli esseri divini non sono necessariamente onniscenti, quindi l'incantatore potrebbe ricevere \"incerto\" come risposta se una domanda riguarda informazioni che vanno oltre le conoscenze di quella divinita'. Nel caso in cui una risposta di una parola possa rivelarsi fuorviante o contraria agli interessi della divinita', il DM puo' fornire come risposta una breve frase. Se l'incantatore lancia l'incantesimo due o piu' volte prima di completare il suo riposo lungo successivo, esiste una probabilita' cumulativa del 25 per cento per ogni lancio dopo il primo che non ottenga alcuna risposta. Il DM effettua questo tiro in segreto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "incenso e una fiala di acqua santa o sacrilega",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "comunione",
    "language": "it"
  },
  {
    "name": "Comunione con la Natura",
    "level": 5,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore diventa un tutt'uno con la natura e sviluppa un'accurata conoscenza del territorio circostante. Nei luoghi esterni, questo incantesimo fornisce all'incantatore una conoscenza del territorio entro un raggio di 4,5 km. Nelle caverne e negli altri ambienti sotterranei naturali il raggio e' limitato a 90 metri. L'incantesimo non funziona la' dove la natura e' stata sostituita dalle costruzioni artificiali, come per esempio nei dungeon e nei paesi. L'incantatore apprende istantaneamente fino a tre fatti a sua scelta sugli argomenti seguenti correlati all'area:Per esempio, l'incantatore potrebbe determinare la posizione di un potente non morto nell'area, delle principali fonti di acqua potabile e di eventuali paesi vicini.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "comunione-con-la-natura",
    "language": "it"
  },
  {
    "name": "Confusione",
    "level": 4,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (tre gusci di noce)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Questo incantesimo assale e sconvolge le menti delle creature, inducendole al delirio e provocando azioni incontrollate. Ogni creatura entro una sfera del raggio di 3 metri incentrata su un punto a scelta dell'incantatore entro gittata deve superare un tiro salvezza su Saggezza nel momento in cui l'incantesimo viene lanciato, altrimenti ne sara' influenzata. Un bersaglio influenzato non puo' effettuare reazioni e deve tirare un d10 all'inizio di ogni suo turno per determinare il suo comportamento per quel turno. Alla fine di ogni suo turno, un bersaglio influenzato puo' effettuare un tiro salvezza su Saggezza. Se lo supera, questo effetto per lui termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, il raggio della sfera amuenta di 1,5 metri per ogni slot di livello superiore al 4°.",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "tre gusci di noce",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "confusione",
    "language": "it"
  },
  {
    "name": "Cono di Freddo",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore (cono di 18 metri)",
    "components": [
      "V",
      " S",
      " M (un piccolo cono di vetro o di cristallo)"
    ],
    "duration": "Istantanea",
    "description": "Una scarica di aria fredda prorompe dalle mani dell'incantatore. Ogni creatura entro un cono di 18 metri deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 8d8 danni da freddo, mentre se lo supera, subisce soltanto la meta' di quei danni. Una creatura uccisa da questo incantesimo diventa una statua di ghiaccio finché non si scioglie.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un piccolo cono di vetro o di cristallo",
    "damageTypes": [
      "freddo"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "cono-di-freddo",
    "language": "it"
  },
  {
    "name": "Conoscenza delle Leggende",
    "level": 5,
    "school": "Divinazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (incenso del valore di almeno 250 mo, che l'incantesimo consuma, e quattro bastoncini d'avorio del valore di almeno 50 mo ciascuno)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore nomina o descrive una persona, un luogo o un oggetto. L'incantesimo trasmette nella sua mente un breve riassunto delle conoscenze piu' significative relative a cio' che l'incantatore ha nominato. Queste conoscenze possono includere storie attuali, racconti dimenticati o perfino conoscenze segrete che non sono mai divenute note. Se cio' che l'incantatore ha nominato non e' di importanza leggendaria, nessuna informazione viene fornita. Piu' informazioni l'incantatore gia' possiede, piu' precise e dettagliate saranno quelle che riceve. Le informazioni apprese dall'incantatore sono accurate, ma potrebbero essere espresse tramite metafore e allegorie. Per esempio, se l'incantatore impugna un'ascia magica, l'incantesimo potrebbe fornire queste informazioni: \"La sventura attende il malfattore la cui mano tocca l'ascia, poiché perfino l'impugnatura puo' tagliare la mano di chi e' malvagio. Soltanto un vero Figlio della Pietra, fedele a Moradin e da lui benvoluto, potra' risvegliare i veri poteri dell'ascia, e soltanto con la parola sacra Rudnogg sulle sue labbra\".",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "incenso del valore di almeno 250 mo, che l'incantesimo consuma, e quattro bastoncini d'avorio del valore di almeno 50 mo ciascuno",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "conoscenza-delle-leggende",
    "language": "it"
  },
  {
    "name": "Contagio",
    "level": 5,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "7 giorni",
    "description": "Il tocco dell'incantatore trasmette una malattia. L'incantatore effettua un attacco in mischia con questo incantesimo contro una creatura entro la sua portata. Se colpisce, contamina la creatura con una malattia a sua scelta tra quelle descritte di seguito. Alla fine di ogni suo turno, il bersaglio deve effettuare un tiro salvezza su Costituzione. Dopo avere falito tre di questi tiri salvezza, gli effetti della malattia permangono per la durata dell'incantesimo e la creatura smette di effettuare questi tiri salvezza. Dopo avere superato tre di questi tiri salvezza, la creatura si riprende dalla malattia e l'incantesimo termina. Dal momento che questo incantesimo induce una malattia naturale nel suo bersaglio, ogni effetto che rimuove una malattia o migliora gli effetti di una malattia e' applicabile al bersaglio. \r\nCarne Putrefatta. La carne della creatura si decompone. La creatura subisce svantaggio alle prove di Carisma e vulnerabilita' a tutti i danni. \r\nDevastazione Vischiosa. La creatura inizia a perdere sangue inesorabilmente e subisce svantaggio alle prove di Costituzione e a i tiri salvezza su Costituzione. Inoltre, ogni volta che la creatura subisce danni, e' stordita fino alla fine del suo turno succesivo. \r\nFebbre Lurida. Il corpo della creatura brucia di febbre. La creatura subisce svantaggio alle prove di Forza, ai tiri salvezza su Forza e ai tiri per colpire che utilizzano Forza. \r\nFuoco Mentale. La mente della creatura e' febbricitante. La creatura subisce svantaggio alle prove di Intelligenza e ai tiri salvezza su Intelligenza, e si comporta come se fosse sotto gli effetti dell'incantesimo confusione durante il combattimento. \r\nInfermita' Accecante. La mente della creatura e' scossa dal dolore e i suoi occhi diventano lattiginosi. La creatura subisce svantaggio alle prove di Saggeza, ai tiri salvezza su Saggezza ed e' accecata. \r\nTremarella. La creatura e' colta da violenti brividi, subisce svantaggio alle prove di Destrezza, ai tiri salvezza su Destrezza e ai tiri per colpire che utilizzano la Destrezza.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "contagio",
    "language": "it"
  },
  {
    "name": "Contattare Altri Piani",
    "level": 5,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore contatta mentalmente un semidio, lo spirito di un sapiente defunto da tempo o qualche altra misteriosa entita' da un altro piano. Contattare questa intelligenza extraplanare puo' spossare o perfino sconvolgere la sua mente. QUando l'incantatore lancia questo incantesimo, effettua un tiro salvezza su Intelligenza con CD 15. Se lo falisce, subisce 6d6 danni psichici e diventa pazzo finché non completa un riposo lungo. Finché e' pazzo, non puo' effettuare azioni, non capisce cio' che dicono le altre creature, non sa leggere e dice solo parole senza senso. Un incantesimo Ristorare Superiore lanciato su di lui termina questo effetto. Se supera il tiro salvezza, l'incantesimo puo' porre all'entita' un massimo di cinque domande. Deve porre le domande prima che l'incantesimo termini. Il DM risponde a ogni domanda con una parola, come \"si'\", \"no\", \"forse\", \"mai\", \"irrilevante\" o \"ignoto\" (se l'entita' non conosce la risposta alla domanda). Se una risposta di una sola parola puo' risultare fuorviante, il DM puo' invece fornire una breve frase come risposta.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Intelligenza"
    ],
    "urlFriendlyName": "contattare-altri-piani",
    "language": "it"
  },
  {
    "name": "Contingenza",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (una statuetta dell'incantatore scolpita in avorio e decorata di gemme del valore di almeno 1.500 mo)"
    ],
    "duration": "10 giorni",
    "description": "L'incantatore sceglie un incantesimo di 5° livello o inferiore che sia in grado di lanciare, che abbia un tempo di lancio di 1 azione e che abbia come bersaglio l'incantatore stesso. L'incantatore puo' lanciare quell'incantesimo (chiamato incantesimo contingente) come parte del lancio di contingenza, spendendo gli slot incantesimo per entrambi. L'incantesimo contingente, tuttavia, non ha effetto. Avra' invece effetto quando si verifichera' una determinata circostanza descritta dall'incantatore al momento del lancio dei due incantesimi. Per esempio, un lancio di contingenza con Respirare sott'Acqua potrebbe stabilire che respirare sott'acqua avra' effetto quando l'incantatore sara' sommerso dall'acqua o da un liquido simile. L'incantesimo contingente ha effetto immediato non appena la circostanza viene soddisfatta la prima volta, che l'incantatore lo desideri o meno, poi contingenza termina. L'incantesimo contingente ha effetto solo sull'incantatore, anche se normalmente puo' bersagliare altri. L'incantatore puo' usare soltanto incantesimo di contingenza alla volta. Se lancia di nuovo questo incantesimo, l'effetto di un altro incantesimo contingenza presente su di lui termina. Inoltre, contingenza termina qualora la sua componente materiale cessi di trovarsi sulla persona dell'incantatore.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una statuetta dell'incantatore scolpita in avorio e decorata di gemme del valore di almeno 1.500 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "contingenza",
    "language": "it"
  },
  {
    "name": "Controincantesimo",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 reazione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore tenta di interrompere una creatura nell'atto di lanciare un incantesimo. Se la creatura sta lanciando un incantesimo di 3° livello o inferiore, l'incantesimo della creatura fallisce e non ha effetto. Se la creatura sta lanciando un incantesimo di 4° livello o superiore, l'incantatore effettua una prova di caratteristica usando la sua caratteristica da incantatore. La CD e' pari a 10 + il livello dell'incantesimo della creatura. In caso di successo, l'incantesimo della creatura fallisce e non ha effetto.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, l'incantesimo interrotto non ha effetto se il suo livello e' pari o inferiore al livello dello slot incantesimo usato dall'incantatore.",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "controincantesimo",
    "language": "it"
  },
  {
    "name": "Controllare Acqua",
    "level": 4,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "90 metri",
    "components": [
      "V",
      " S",
      " M (una goccia d'acqua e un pizzico di polvere)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Finché l'incantesimo non termina, l'incantatore controlla una massa libera d'acqua in un'area a sua scelta, fino a un volume massimo pari a un cubo con spigolo 30 metri. Puo' scegliere uno qualsiasi degli effetti seguenti quando lancia questo incantesimo. Con un'azione nel suo turno puo' ripetere lo stesso effetto o sceglierne uno diverso. \r\nDeviare la Corrente. L'incantatore fa scorrere l'acqua corrente all'interno dell'area in una direzione a sua scelta, anche se l'acqua deve superare degli ostacoli, risalire una parete o scorrere in altre direzioni improbabili. L'acqua nell'area si muove secondo le indicazioni dell'incantatore, ma una volta giunta oltre l'area dell'incantesimo, riprende a scorrere normalmente, secondo le condizioni del terreno. L'acqua continua a scorrere nella direzione scelta dall'incantatore finché l'incantesimo non termina o finché l'incantatore non sceglie un effetto diverso. \r\nGorgo. Questo effetto richiede una massa d'acqua in un'area quadrata con lato di almeno 15 metri e profonda almeno 7,5 metri. Il gorgo forma un vortice largo 1,5 metri alla base e 15 metri in cima, e alto 7,5 metri. Ogni creatura o oggetto situato in acqua entro 7,5 metri dal vortice viene trascinato di 3 metri verso di esso. Una creatura puo' allontanarsi a nuoto dal vortice effettuando una prova di Forza (Atletica) contro la CD del tiro salvezza dell'incantesimo. Quando una creatura entra nel vortice per la prima volta in un turno o vi inizia il proprio turno, deve effettuare un tiro salvezza su Forza. Se lo fallisce, subisce 2d8 danni contundenti ed e' catturata dal vortice finché l'incantesimo non termina, mentre se lo supera, subisce la meta' dei danni e si libera dal vortice. Una creatura nel vortice puo' usare la sua azione per tentare di allontanarsi a nuoto da esso nel modo sopra descritto, ma subisce svantaggio alla prova di Forza (Atletica) richiesta per farlo. La prima volta in ogni turno che un oggetto entra nel vortice, quell'oggetto subisce 2d8 danni contundenti; questi danni vengono inferti in ogni round in cui l'oggetto rimane nel vortice. \r\nInondazione. L'incantatore fa in modo che il livello di tutta l'acqua ferma nell'area si sollevi di un massimo di 6 metri. Se l'area include una riva, l'acqua crescente si riversa sulla terraferma. Se l'incantatore sceglie un'area contenuta in una vasta massa d'acqua, genera invece un'onda alta 6 metri da un lato dell'area all'altro, che si riversa poi in avanti. Ogni imbarcazione di taglia Enorme o inferiore che si trovi sul cammino viene trasportata dall'onda fino all'altro lato. Ogni imbarcazione di taglia Enorme o inferiore colpita dall'onda ha una probabilita' del 25 per cento di capovolgersi. Il livello dell'acqua rimane elevato finché l'incantesimo non termina o finché l'incantatore non sceglie un effetto diverso. Se questo effetto ha prodotto un'onda, l'onda si ripete all'inizio del turno successivo dell'incantatore fintanto che l'effetto di inondazione permane. \r\nSeparare le Acque. L'incantatore fa in modo che l'acqua nell'area si separi per creare un varco. Il varco attraversa tutta l'area di effetto e le acque separate formano un muro su entrambi i lati. Il varco rimane finché l'incantesimo non termina o l'incantatore non sceglie un effetto diverso. Poi l'acqua si riversa lentamente all'interno del varco nel corso del round successivo, finché il livello normale dell'acqua non viene ripristinato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia d'acqua e un pizzico di polvere",
    "damageTypes": [
      "contundenti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "controllare-acqua",
    "language": "it"
  },
  {
    "name": "Controllare Tempo Atmosferico",
    "level": 8,
    "school": "Trasmutazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 8 km dall'incantatore",
    "components": [
      "Componenti: V",
      " S",
      " M (incenso, terra e legno immersi in acqua)"
    ],
    "duration": "Durata: Concentrazione fino ad 8 ore",
    "description": "Acquisisci il controllo atmosferico entro 8 km da te. E' necessario trovarsi all'aperto. Se ci si sposta in un punto dove non e' possibile vedere con chiarezza il cielo , l'incantesimo termina all'istante. Quando l'incantesimo viene lanciato, il clima attuale viene alterato. Sono necessari 1d4 x 10 minuti affinché le nuove condizioni meteo si palesino. Una volta palesate, e' possibile alterarle nuovamente. Una volta terminato l'incantesimo, il clima ritorna gradualmente alla normalita'Quando alteri le condizioni climatiche, trova la condizione attuale sulla tabella e avanza di uno stadio ogni volta che  desideri alterare le condizioni . Quando si agisce sul vento, puoi cambiarne anche la direzione",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "incenso, terra e legno immersi in acqua",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "controllare-tempo-atmosferico",
    "language": "it"
  },
  {
    "name": "Cordone di Frecce",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "1,5 metri",
    "components": [
      "V",
      " S",
      " M (quattro o più frecce o quadrelli)"
    ],
    "duration": "8 ore",
    "description": "L'incantatore colloca quattro munizioni non magiche (frecce o quadrelli) nel terreno entro gittata e le rende magiche al fine di proteggere l'area. Finché l'incantesimo non termina, ogni volta che una creatura diversa dall'incantatore giunge entro 9 metri dalle munizioni per la prima volta in un turno o vi termina il proprio turno. una delle munizioni sfreccia in volo per colpirla. La creatura deve superare un tiro salvezza su Destrezza altrimenti subira' 1d6 danni perforanti. La munizione viene distrutta. L'incantesimo termina quando non rimangono piu' munizioni. Quando l'incantatore lancia questo incantesimo, pub designare un qualsiasi numero di creature a sua scelta che saranno ignorate dall'incantesimo. Ai Livelli Superiori Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, l'ammontare di munizioni che puo' essere influenzato aumenta di due per ogni slot di livello superiore al 2°",
    "atHigherLevels": "",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "quattro o più frecce o quadrelli",
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "cordone-di-frecce",
    "language": "it"
  },
  {
    "name": "Corona di Follia",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Un umanoide a scelta dell'incantatore, situato entro gittata e che l'incantatore sia in grado di vedere, deve superare un tiro salvezza su Saggezza, altrimenti diventa affascinato dall'incantatore per la durata dell'incantesimo. Finché il bersaglio e' affascinato in questo modo, una corona di ferro deforme e tagliente compare sulla testa e nei suoi occhi risplende un bagliore di follia. Il bersaglio affascinato deve usare la sua azione prima di muoversi in ognuno dei suoi turni per effettuare un attacco in mischia contro una creatura diversa da sé stesso e scelta mentalmente dall'incantatore. Il bersaglio puo' agire normalmente nel suo turno se l'incantatore non sceglie nessuna creatura o se nessuna creatura si trova entro la sua portata. Nei suoi turni successivi, l'incantatore deve usare la sua azione per mantenere il controllo sul bersaglio, altrimenti l'incantesimo termina. Il bersaglio puo' inoltre effettuare un tiro salvezza su Saggezza alla fine di ogni suo turno. Se lo supera, l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "corona-di-follia",
    "language": "it"
  },
  {
    "name": "Costrizione",
    "level": 5,
    "school": "Ammaliamento",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "30 giorni",
    "description": "L'incantatore impartisce un comando magico a una creatura entro gittata e che egli sia in grado di vedere, obbligandola a compiere per lui un servizio di qualche tipo o ad astenersi da un corso d'azione o un'attivita', come da lui stabilito. Se la creatura e' in grado di comprendere l'incantatore, deve superare un tiro salvezza su Saggezza, altrimenti e' affascinata dall'incantatore per la durata dell'incantesimo. Finché la creatura e' affascinata dall'incantatore, subisce 5d10 danni psichici ogni volta che agisce in maniera dichiaratamente contraria alle sue istruzioni, ma non piu' di una volta al giorno. Se la creatura non e' in grado di comprendere l'incantatore, non subisce l'effetto di questo incantesimo. L'incantatore puo' impartire un qualsiasi comando a sua scelta, ad eccezione di quelle attivita' che condurrebbero a morte certa. Se l'incantatore impartisce un comando suicida, l'incantesimo termina. L'incantatore puo' terminare l'incantesimo prematuramente usando un'azione. Anche un incantesimo Desiderio, Rimuovi Maledizione o Ristorare Superiore e' in grado di porre termine all'incantesimo.",
    "atHigherLevels": "Quando l'incantesimo lancia questo incantesimo usando uno slot incantesimo di 7° o 8° livello, la durata e' pari a 1 anno. Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 9° livello, l'incantesimo dura finché uno degli incantesimi menzionati piu' sopra non vi pone termine.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "costrizione",
    "language": "it"
  },
  {
    "name": "Creare Cibo e Acqua",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore crea 22,5 kg di cibo e 120 litri di acqua sul terreno o nei contenitori entro gittata, sufficienti a offrire sostentamento a un massimo di quindici umanoidi o cinque cavalcature per 24 ore. Il cibo e' poco saporito, ma e' nutriente. Il cibo si guasta se non viene mangiato nel giro di 24 ore, mentre l'acqua e' pulita e non va a male.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "creare-cibo-e-acqua",
    "language": "it"
  },
  {
    "name": "Creare Non Morti",
    "level": 6,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S",
      " M (un vaso d'argilla pieno di terra raccolta da un cimitero, un vaso d'argilla pieno di acqua salmastra e un'onice da 150 mo per ogni cadavere)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore puo' lanciare questo incantesimo solo di notte. Sceglie fino a tre cadaveri umanoidi di taglia Media o Piccola situati entro gittata. Ogni cadavere diventa un ghoul sotto il suo controllo. (Il DM possiede le statistiche di gioco di queste creature). A ogni suo turno l'incantatore puo' usare un'azione bonus per comandare mentalmente qualsiasi creatura da lui creata tramite questo incantesimo e situata entro 36 metri da lui (se controlla piu' creature, puo' comandarle tutte o nessuna allo stesso tempo, impartendo lo stesso comando a ogni creatura). L'incantatore decide quale azione effettuera' la creatura e dove si muovera' durante il suo turno successivo, oppure puo' impartire un comando generale, come per esempio vigilare su una camera o un corridoio in particolare. Se l'incantatore non impartisce alcun comando, la creatura si limita a difendersi dalle creature ostili. Una volta ricevuto un ordine, la creatura continua a seguirlo finché non ha portato a termine il compito. La creatura rimane sotto il controllo dell'incantatore per 24 ore, dopodiché smette di obbedire ai comandi che l'incantatore le ha impartito. Per mantenere il controllo della creatura per altre 24 ore, l'incantatore deve lanciare di nuovo questo incantesimo su di essa prima che l'attuale periodo di 24 ore termini. Questo uso dell'incantesimo gli permette di ristabilire il controllo su un massimo di tre creature da lui animate tramite questo incantesimo, anziché animarne di nuove.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello, anima o ristabilisce il controllo su quattro ghoul. Quando lancia questo incantesimo usando uno slot incantesimo di 8° livello, anima o ristabilisce il controllo su cinque ghoul, o due ghast o wight. Quando lancia questo incantesimo usando uno slot incantesimo di 9° livello, anima o ristabilisce il controllo su sei ghoul, tre ghast o wight, o due mummie.",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un vaso d'argilla pieno di terra raccolta da un cimitero, un vaso d'argilla pieno di acqua salmastra e un'onice da 150 mo per ogni cadavere",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "creare-non-morti",
    "language": "it"
  },
  {
    "name": "Creare o Distruggere Acqua",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 9 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (una goccia d'acqua per creare l'acqua o alcuni granelli di sabbia per distruggerla)"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore puo' creare o distruggere l'acqua. Creare Acqua.  L'incantatore crea fino a 40 litri d'acqua pulita in un contenitore aperto situato entro gittata. In alternativa, l'acqua cade sotto forma di pioggia in un cubo con spigolo di 9 metri entro gittata, estinguendo le fiamme nell'area. Distruggere Acqua.  L'incantatore distrugge fino a 40 litri d'acqua in un contenitore aperto situato entro gittata. In alternativa, puo' distruggere la nebbia all'interno di un cubo con spigolo di 9 metri situato entro gittata.",
    "atHigherLevels": "Quando l'incatatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, crea o distrugge 40 litri aggiuntivi d'acqua, oppure lo spigolo del cubo aumenta di 1,5 metri per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia d'acqua per creare l'acqua o alcuni granelli di sabbia per distruggerla",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "creare-o-distruggere-acqua",
    "language": "it"
  },
  {
    "name": "Creazione",
    "level": 5,
    "school": "Illusione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un minuscolo frammento di materia dello stesso tipo dell'oggetto che l'incantatore intende creare)"
    ],
    "duration": "Speciale",
    "description": "L'incantatore chiama a sé dei filamenti di sostanza d'ombra dalla Coltre Oscura per creare un oggetto non vivente di materia vegetale entro gittata: stoffa, corda, legno o altri materiali simili. Puo' usare questo incantesimo anche per creare oggetti fatti di minerali come pietra, cristallo o metallo. L'oggetto creato non deve essere piu' grande di un cubo con spigolo di 1,5 metri e deve avere una forma e un materiale che l'incantatore abbia gia' visto in precedenza. La durata dipende dal materiale dell'oggetto. Se l'oggetto e' composto da piu' materiali, si usa la durata piu' breve. L'uso di qualsiasi materiale creato da questo incantesimo come componente materiale di un altro incantesimo provoca il fallimento di quell'incantesimo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, lo spigolo del cubo aumenta di 1,5 metri per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un minuscolo frammento di materia dello stesso tipo dell'oggetto che l'incantatore intende creare",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "creazione",
    "language": "it"
  },
  {
    "name": "Crescita di Spine",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (sette spine aguzze o sette rametti appuntiti)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Spine e spuntoni nascono dal terreno entro un raggio di 6 metri centrato su un punto situato entro gittata. L'area diventa terreno difficile per la durata dell'incantesimo. Quando una creatura entra nell'area o si muove al suo interno, subisce 2d4 danni perforanti per ogni 1,5 metri di cui si muove. La trasformazione del terreno e' mimetizzata in modo da sembrare naturale. Ogni creatura che non abbia osservato l'area al momento del lancio dell'incantesimo deve effettuare una prova di Saggezza (Percezione) contro la CD del tiro salvezza dell'incantesimo per riconoscere la pericolosita' del terreno prima di entrarvi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "sette spine aguzze o sette rametti appuntiti",
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "crescita-di-spine",
    "language": "it"
  },
  {
    "name": "Crescita Vegetale",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione/8 ore",
    "ritual": false,
    "concentration": false,
    "range": "45 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Questo incantesimo incanala vitalita' nei vegetali di un'area specifica. Esistono due possibili usi dell'incantesimo, mirati a fornire benefici immediati o a lungo termine. Se l'incantatore lancia questo incantesimo usando 1 azione, sceglie un punto situato entro gittata. Tutti i vegetali normali entro un raggio di 30 metri centrato su quel punto crescono rigogliosamente fino a formare un groviglio. Una creatura che si muove attraverso quell'area deve spendere 120 cm di movimento per ogni 30 cm di cui si muove. L'incantatore puo' escludere una o piu' aree di qualsiasi dimensione all'interno dell'area dell'incantesimo per fare in modo che non ne siano influenzate. Se l'incantatore lancia questo incantesimo nell'arco di 8 ore, rende la terra fertile. Tutti i vegetali entro un raggio di 750 metri centrato in un punto situato entro gittata cresceranno rigogliosamente per 1 anno. Al momento del raccolto produrranno il doppio del cibo normale.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "crescita-vegetale",
    "language": "it"
  },
  {
    "name": "Cura Ferite",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Una creatura toccata dall'incantatore recupera un numero di punti ferita pari a 1d8 + il modificatore di caratteristica da incantatore. Questo incantesimo non ha effetto sui costrutti o sui non morti.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, la guarigione aumenta di 1d8 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Paladino",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "cura-ferite",
    "language": "it"
  },
  {
    "name": "Cura Ferite di Massa",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un'ondata di energia curativa si sprigiona da un punto a scelta dell'incantatore situato entro gittata. L'incantatore indica fino a sei creature entro una sfera del raggio di 9 metri centrata su quel punto. Ogni creatura bersaglio recupera un ammontare di punti ferita pari a 3d8 + il modificatore di caratteristica da incantatore. Questo incantesimo non ha effetto sui costrutti o sui non morti.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, la guarigione aumenta di 1d8 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "cura-ferite-di-massa",
    "language": "it"
  },
  {
    "name": "Danza Irresistibile di Otto",
    "level": 6,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore sceglie una creatura entro gittata e che egli sia in grado di vedere. La creatura inizia a danzare comicamente sul posto, agitando le braccia, battendo i piedi a terra e facendo capriole per la durata dell'incantesimo. Le creature che non possono essere affascinate sono immuni a questo incantesimo. Una creatura danzante deve usare tutto il suo movimento per danzare senza uscire dal suo spazio e subisce svantaggio ai tiri salvezza su Destrezza e ai tiri per colpire. Finché il bersaglio e' influenzato da questo incantesimo, le altre creature dispongono di vantaggio ai tiri per colpire contro di esso. Con un'azione, una creatura danzante puo' effettuare un tiro salvezza su Saggezza per riprendere il controllo di sé stessa. Se lo supera, l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "danza-irresistibile-di-otto",
    "language": "it"
  },
  {
    "name": "Dardo di Fuoco",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 36 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: istantanea",
    "description": "L'incantatore scaglia una scintilla di fuoco verso una creatura o un oggetto situato entro gittata, effettuando un attacco a distanza con questo incantesimo contro il bersaglio. Se colpisce, il bersaglio subisce 1d10 danni da fuoco. Un oggetto infiammabile colpito da questo incantesimo si incendia se non e' indossato o trasportato. I danni di questo incantesimo aumentano di 1d10 quando l'incantatore arriva al 5° livello (2d10), 11° livello (3d10) e 17° livello (4d10).",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "dardo-di-fuoco",
    "language": "it"
  },
  {
    "name": "Dardo Incantato",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore crea tre dardi lucenti di forza magica. Ogni dardo colpisce una creatura scelta dall'incantatore, situata entro gittata e che egli sia in grado di vedere. Un dardo infligge 1d4+1 danni da forza al suo bersaglio. Tutti i dardi colpiscono simultaneamente e l'incantatore puo' dirigerli per colpire una sola creatura o piu' creature.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, l'incantesimo crea un dardo aggiuntivo per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "dardo-incantato",
    "language": "it"
  },
  {
    "name": "Dardo Stregato",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un rametto di un albero colpito da un fulmine)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "Un raggio di energia azzurra crepitante sfreccia verso una creatura entro gittata, formando una scarica di fulmini prolungata che corre dall'incantatore al bersaglio. L'incantatore effettua un attacco a distanza con questo incantesimo contro quella creatura. Se colpisce, il bersaglio subisce 1d12 danni da fulmine, e l'incantatore, durante ogni proprio turno per la durata dell'incantesimo, puo' usare la propria azione per infliggere automaticamente 1d12 danni da fulmine al bersaglio. L'incantesimo termina se l'incantatore usa la propria azione per fare qualsiasi altra cosa. L'incantesimo termina inoltre se il bersaglio si porta al di fuori dalla gittata o se beneficia di copertura totale nei confronti dell'incantatore.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni iniziali aumentano di 1d12 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un rametto di un albero colpito da un fulmine",
    "damageTypes": [
      "fulmine"
    ],
    "isDamaging": true,
    "damageDices": [
      "d12"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "dardo-stregato",
    "language": "it"
  },
  {
    "name": "Dardo Tracciante",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 round",
    "description": "Effettua un attacco di incantesimo a distanza contro una creatura che puoi vedere. In un colpo, il bersaglio subisce 4d6 danni radianti, e prima della fine del tuo prossimo turno, il successivo tiro di attacco effettuato su di esso ha un vantaggio.",
    "atHigherLevels": "Il danno aumenta di 1d6 per ogni livello di slot superiore al 1°.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "dardo-tracciante",
    "language": "it"
  },
  {
    "name": "Deflagrazione Occulta",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un raggio di energia crepitante sfreccia verso una creatura entro gittata. L'incantesimo effettua un attacco a distanza con questo incantesimo contro il bersaglio. Se lo colpisce, il bersaglio subisce 1d10 danni da forza. Quando l'incantatore arriva ai livelli superiori, l'incantesimo crea piu' raggi: due raggi al 5° livello, tre raggi all'11° livello e quattro raggi al 17° livello. L'incantatore puo' indirizzare i raggi contro lo stesso bersaglio o contro bersagli diversi, effettuando un tiro per colpire separato per ogni raggio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "deflagrazione-occulta",
    "language": "it"
  },
  {
    "name": "Desiderio",
    "level": 9,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "Desiderio e' il piu' potente incantesimo che una creatura mortale sia in grado di lanciare. Pronunciando semplicemente il proprio desiderio ad alta voce, l'incantatore altera le fondamenta stesse della realta' in base a cio' che desidera. L'uso base di questo incantesimo e' riprodurre un qualsiasi altro incantesimo di livello pari o inferiore all'8°. L'incantatore non deve soddisfare alcun requisito di quell'incantesimo, nemmeno gli eventuali requisiti in componenti costose. L'incantesimo ha semplicemente effetto. In alternativa, l'incantatore puo' creare uno degli effetti seguenti a sua scelta:L'incantatore potrebbe essere in grado di realizzare qualcosa che vada oltre gli esempi soprastanti, dichiarando il suo desiderio al DM nel modo piu' preciso possibile. Il DM ha la massima liberta' di decidere cosa accade in questi casi: piu' potente e' il desiderio, maggiori sono le probabilita' che qualcosa vada storto. L'incantesimo potrebbe semplicemente fallire, e l'effetto desiderato dall'incantatore potrebbe avverarsi solo in parte, oppure l'incantatore potrebbe subire delle conseguenze inaspettate a seguito della formulazione del desiderio. Per esempio, se desidera che un suo nemico sia morto, potrebbe essere portato avanti nel tempo in un periodo in cui quel nemico non e' piu' in vita, finendo per essere rimosso dal gioco a tutti gli effetti. Analogamente, se desidera un oggetto magico leggendario o un artefatto, potrebbe essere trasportato istantaneamente in presenza del legittimo proprietario dell'oggetto. La tensione provocata dal lancio di questo incantesimo per produrre un qualsiasi effetto diverso dalla duplicazione di un altro incantesimo debilita l'incantatore. Dopo avere subito quella tensione, ogni volta che l'incantatore lancia un incantesimo prima di avere completato un riposo lungo subisce 1d10 danni necrotici per livello di quell'incantesimo. Questi danni non possono essere ridotti o prevenuti in alcun modo. Inoltre, la Forza dell'incantatore scende a 3 per 2d4 giorni (se non e' gia' pari o inferiore a 3). Per ognuno di quei giorni trascorso a riposare e a non fare nulla al di fuori di attivita' poco impegnative, il tempo di recupero rimanente diminuisce di 2 giorni. Esiste infine una probabilita' del 33 per cento che l'incantatore non sia in grado di lanciare desidario mai piu', se non riesce a reggere questa tensione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4",
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "desiderio",
    "language": "it"
  },
  {
    "name": "Destriero Fantomatico",
    "level": 3,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 ora",
    "description": "Una creatura Grande, simile a un cavallo e quasi reale, appare sul terreno in uno spazio libero a scelta dell'incantatore entro gittata. L'incantatore puo' scegliere l'aspetto della creatura, che deve pero' essere dotata di sella, morso e briglie. Tutto l'equipaggiamento creato dall'incantesimo svanisce in uno sbuffo di fumo se trasportato a piu' di 3 metri dalla cavalcatura. Per la durata dell'incantesimo, l'incantatore o una creatura a sua scelta puo' cavalcare il destriero. La creatura usa le statistiche di un cavallo da galoppo, ma ha una velocita' di 30 metri e puo' percorrere 15 km in un'ora o 20 km a passo veloce. Quando l'incantesimo termina, la cavalcatura svanisce gradualmente, concedendo al cavalcatore 1 minuto per smontare. L'incantesimo termina se l'incantatore usa un'azione per interromperlo o se la cavalcatura subisce danni.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "destriero-fantomatico",
    "language": "it"
  },
  {
    "name": "Disco Fluttuante di Tenser",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "Gittata: 9 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (una goccia di mercurio)"
    ],
    "duration": "Durata: 1 ora",
    "description": "Questo incantesimo crea un piano circolare e orizzontale di forza, del diametro di 90 cm e dello spessore di 2,5 cm, che fluttua a 90 cm dal terreno in uno spazio libero a scelta dell'incantatore, situato entro gittata e che egli sia in grado di vedere. Il disco permane per la durata dell'incantesimo e puo' sostenere fino a 250 kg. Se si aggiunge ulteriore peso, l'incantesimo termina e tutto cio' che si trovava sul disco cade a terra. Il disco e' immobile finché l'incantatore si trova entro 6 metri da esso. Se l'incantatore si allontana dal disco a piu' di 6 metri, il disco lo segue in modo da rimanere entro 6 metri da lui. Puo' muoversi sul terreno dissestato, lungo scalinate, pendii e cosi' via, ma non puo' superare un cambio di elevazione pari o superiore a 3 metri. Per esempio, il disco non potrebbe muoversi oltre una fossa profanda 3 metri e non potrebbe uscire da quella fossa se fosse stato creato sul fondo. Se l'incantatore si muove a piu' di 30 metri dal disco (solitamente perché il disco non puo' aggirare un ostacolo per seguirlo), l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia di mercurio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "disco-fluttuante-di-tenser",
    "language": "it"
  },
  {
    "name": "Disintegrazione",
    "level": 6,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (una calamita e un pizzico di polvere)"
    ],
    "duration": "Istantanea",
    "description": "Un sottile raggio verde si sprigiona dall'indice dell'incantatore fino a un bersaglio situato entro gittata e che egli sia in grado di vedere. Il bersaglio puo' essere una creatura, un oggetto o una creazione di forza magica, come il muro creato da un Muro di Forza. Una creatura bersagliata da questo incantesimo deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 10d6 + 40 danni da forza. Se questi danni riducono il bersaglio a 0 punti ferita, il bersaglio e' disintegrato. Una creatura disintegrata e tutto cio' che essa indossa e trasporta (tranne gli oggetti magici) si riduce in un cumulo di sottile polvere grigia. La creatura puo' essere riportata in vita soltanto tramite un incantesimo Desiderio o Resurrezione Pura. Questo incantesimo disintegra automaticamente un oggetto non magico di taglia Grande o inferiore o una creazione di forza magica. Se il bersaglio e' un oggetto o una creazione di forza magica di taglia Enorme o superiore, questo incantesimo disintegra una parte di esso grande quanto un cubo con spigolo di 3 metri. Un oggetto magico non e' influenzato da questo incantesimo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, i danni aumentano di 3d6 per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una calamita e un pizzico di polvere",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "disintegrazione",
    "language": "it"
  },
  {
    "name": "Dissolvi il Bene e il Male",
    "level": 5,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (acqua santa o polvere d'argento e di ferro)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore e' circondato da un alone di energia scintillante che lo protegge dai folletti, dai non morti e dalle creature originarie di un piano diverso dal Piano Materiale. Per la durata dell'incantesimo, i celestiali, gli elementali, i folletti, gli immondi e i non morti subiscono svantaggio ai tiri per colpire contro di lui. L'incantatore puo' porre fine all'incantesimo usando una delle funzioni speciali seguenti. Congedo.  Con la sua azione, l'incantatore effettua un attacco in mischia con questo incantesimo contro un celestiale, un elementale, un folletto, un immondo o un non morto entro la sua portata. Se lo colpisce, tenta di respingerlo sul suo piano di origine. La creatura deve superare un tiro salvezza su Carisma, altrimenti sara' ricacciata sul suo piano natio (se gia' non si trova laggiu'). Se non si trovano sul loro piano di origine, i non morti sono inviati nella Coltre Oscura e i folletti nella Selva Fatata. Spezzare Ammaliamento.  Con la sua azione, l'incantatore tocca una creatura situata entro la sua portata che sia affascinata, spaventata o posseduta da un celestiale, un elementale, un folletto, un immondo o un non morto. La creatura toccata non e' piu' affascinata, spaventata o posseduta da quella creatura.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "acqua santa o polvere d'argento e di ferro",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "dissolvi-il-bene-e-il-male",
    "language": "it"
  },
  {
    "name": "Dissolvi Magie",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore sceglie una creatura, oggetto o effetto magico situato entro gittata. Ogni incantesimo di 3° livello o inferiore termina. Per ogni incantesimo di 4° livello o superiore presente sul bersaglio, l'incantatore effettua una prova di caratteristica usando la propria caratteristica da incantatore. La CD e' pari a 10 + il livello dell'incantesimo. Se supera la prova, l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, termina automaticamente gli effetti di un incantesimo sul bersaglio se il livello di quell'incantesimo e' pari o inferiore al livello dello slot incantesimo usato dall'incantatore.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Paladino",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "dissolvi-magie",
    "language": "it"
  },
  {
    "name": "Dito della Morte",
    "level": 7,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore trasmette un flusso di energia negativa attraverso una creatura entro gittata e che egli sia in grado di vedere, provocandole un dolore lancinante. Il bersaglio deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 7d8 + 30 danni necrotici, mentre se lo supera, subisce soltanto la meta' di quei danni. Un umanoide ucciso da questo incantesimo si anima all'inizio del turno successivo dell'incantatore come zombi permanentemente al suo comando: obbedira' ai suoi ordini verbali al meglio delle sue capacita'.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "dito-della-morte",
    "language": "it"
  },
  {
    "name": "Divinazione",
    "level": 4,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (incenso e un'offerta sacrificale appropriata alla religione dell'incantatore, del valore complessivo di almeno 25 mo, che l'incantesimo consuma)"
    ],
    "duration": "Istantanea",
    "description": "Tramite la sua magia e la sua offerta, l'incantatore entra in contatto con una divinita' o con i servitori di una divinita'. L'incantatore puo' porre una singola domanda relativa a uno specifico obiettivo, evento o attivita' che si verifichera' entro 7 giorni. Il DM fornisce una risposta onesta, che potrebbe essere costituita da una breve frase, unaa rima enigmatica o un presagio. L'incantesimo non tiene conto delle possibili circostanze che potrebbero cambiare l'esito del responso, come il lancio di ulteriori incantesimi aggiuntivi o la perdita o l'aggiunta di un compagno. Se l'incantatore lancia l'incantesimo due o piu' volte prima di completare il suo riposo lungo successivo, esiste una probabilita' cumulativa del 25 per cento per ogni lancio dopo il primo di ottenere un responso casuale. Il DM effettua questo tiro in segreto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "incenso e un'offerta sacrificale appropriata alla religione dell'incantatore, del valore complessivo di almeno 25 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "divinazione",
    "language": "it"
  },
  {
    "name": "Dominare Bestie",
    "level": 4,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di soggiogare una bestia entro gittata e che egli sia in grado di vedere. Quella bestia deve superare un tiro salvezza su Saggezza, altrimenti sara' affascinata dall'incantatore per la durata dell'incantesimo. Se l'incantatore  o le creature a lui amichevoli stanno combattendo contro la bestia, quest'ultima dispone di vantaggio al tiro salvezza. Mentre la bestia e' affascinata, l'incantatore dispone di un legame telepatico con essa finché entrambi si trovano sullo stesso piano di esistenza. L'incantatore puo' usare questo legame telepatico per impartire comandi alla creatura finché e' cosciente (nessuna azione richiesta), ed essa fara' del suo meglio per obbedire. L'incantatore puo' specificare un corso d'azione semplice e generico come \"attacca quella creatura\", \"corri fin laggiu'\" o \"portami quell'oggetto\". Se la creatura porta a termine l'ordine e non riceve ulteriori indicazioni da parte dell'incantatore, essa si difende e si protegge al meglio delle sue capacita'. L'incantatore puo' usare la sua azione per assumere il controllo totale e preciso del bersaglio. Fino alla fine del turno successivo dell'incantatore, la creatura effettua soltanto le azioni scelte dall'incantatore e non fa niente che l'incantatore non le consenta di fare. Durante questo periodo, l'incantatore puo' anche fare in modo che la creatura usi una reazione, ma per farlo dovra' usare la sua stessa reazione. Ogni volta che il bersaglio subisce danni, effettua un nuovo tiro salvezza su Saggezza contro l'incantesimo. Se lo supera, l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo con uno slot incantesimo di 5° livello, la durata diventa concentrazione, fino a 10 minuti. Quando usa uno slot di 6° livello, la durata diventa concentrazione, fino a 1 ora. Quando usa uno slot incantesimo di 7° livello o superiore, la durata diventa concentrazione, fino a 8 ore.",
    "availableClasses": [
      "Druido",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "dominare-bestie",
    "language": "it"
  },
  {
    "name": "Dominare Mostri",
    "level": 8,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore tenta di soggiogare una creatura entro gittata e che egli sia in grado di vedere. Quella creatura deve superare un tiro salvezza su Saggezza, altrimenti sara' affascinata dall'incantatore per la durata dell'incantesimo. Se l'incantatore o le creature a lui amichevoli stanno combattendo contro la creatura, quest'ultima dispone di vantaggio al tiro salvezza. Mentre la creatura e' affascinata, l'incantatore dispone di un legame telepatico con essa finché entrambi si trovano sullo stesso piano di esistenza. L'incantatore puo' usare questo legame telepatico per impartire comandi alla creatura finché e' cosciente (nessuna azione richiesta), ed essa fara' del suo meglio per obbedire. L'incantatore puo' specificare un corso d'azione semplice e generico come \"attac quella creatura\", \"corri fin laggiu'\" o \"portami quell'oggetto\". Se la creatura porta a termine l'ordine e non riceve ulteriori indicazioni da parte dell'incantatore, essa si difende e si protegge al meglio delle sue capacita'. L'incantatore puo' usare la sua azione per assumere il controllo totale e preciso del bersaglio. Fino alla fine del turno successivo dell'incantatore, la creatura effettua soltanto le azioni scelte dall'incantatore e non fa niente che l'incantatore non le consenta di fare. Durante questo periodo, l'incantatore puo' anche fare in modo che la creatura usi una reazione, ma per farlo dovra' usare la sua stessa reazione. Ogni volta che il bersaglio subisce danni, effettua un nuovo tiro salvezza su Saggezza contro l'incantesimo. Se lo supera, l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo con uno slot incantesimo di 9° livello, la durata diventa concentrazione, fino a 8 ore.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "dominare-mostri",
    "language": "it"
  },
  {
    "name": "Dominare Persone",
    "level": 5,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di soggiogare un umanoide entro gittata e che egli sia in grado di vedere. Quell'umanoide deve superare un tiro salvezza su Saggezza, altrimenti sara' affascinato dall'incantatore per la durata dell'incantesimo. Se l'incantatore o le creature a lui amichevoli stanno combattendo contro l'umanoide, quest'ultimo dispone di vantaggio al tiro salvezza. Mentre il bersaglio e' affascinato, l'incantatore dispone di un legame telepatico con lui finché entrambi si trovano sullo stesso piano di esistenza. L'incantatore puo' usare questo legame telepatico per impartire comandi alla creatura finché e' cosciente (nessuna azione richiesta), ed essa fara' del suo meglio per obbedire. L'incantatore puo' specificare un corso d'azione semplice e generico come \"attacca quella creatura\", \"corri fin laggiu'\" o \"portami quell'oggetto\". Se la creatura porta a termine l'ordine e non riceve ulteriori indicazioni da parte dell'incantatore, essa si difende e si protegge al meglio delle sue capacita'. L'incantatore puo' usare la sua azione per assumere il controllo totale e preciso del bersaglio. Fino alla fine del turno successivo dell'incantatore, la creatura effettua soltanto le azioni scelte dall'incantatore e non fa niente che l'incantatore non le consenta di fare. Durante questo periodo, l'incantatore puo' anche fare in modo che la creatura usi una reazione, ma per farlo dovra' usare la sua stessa reazione. Ogni volta che il bersaglio subisce danni, effettua un nuovo tiro salvezza su Saggezza contro l'incantesimo. Se lo suepra, l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo con uno slot incantesimo di 6° livello, la durata diventa concentrazione, fino a 10 minuti.Quando usa uno slot incantesimo di 7° livello, la durata diventa concentrazione, fino a 1 ora.Quando usa uno slot incantesimo di 8° livello o superiore, la durata diventa concentrazione, fino a 8 ore.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "dominare-persone",
    "language": "it"
  },
  {
    "name": "Duello Obbligato",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 9 metri",
    "components": [
      "Componenti: V"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di obbligare una creatura a partecipare a un duello. Una creatura entro gittata e che egli sia in grado di vedere deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, e' obbligata dall'imposizione divina dell'incantatore ad avvicinarsi a lui. Per la durata dell'incantesimo, la creatura subisce svantaggio ai tiri per colpire contro le creature diverse dall'incantatore e deve effettuare un tiro salvezza ogni volta che tenta di muoversi fino a uno spazio piu' lontano di 9 metri da lui. Se supera il tiro salvezza, questo incantesimo non limita i movimenti della creatura per quel turno. L'incantesimo termina se l'incantatore attacca una qualsiasi altra creatura, se lancia un incantesimo che bersaglia una creatura ostile diversa dal bersaglio, se una creatura a lui amichevole infligge danni al bersaglio o lancia un incantesimo dannoso su di esso, o se l'incantatore termina il proprio turno a piu' di 9 metri dal bersaglio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "duello-obbligato",
    "language": "it"
  },
  {
    "name": "Eroismo",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "Una creatura consenziente toccata dall'incantatore e' animata da un grande coraggio. Finché l'incantesimo non termina, la creatura e' immune alla condizione di spaventato e ottiene un ammontare di punti ferita temporanei pari al modificatore di caratteristica da incantatore all'inizio di ogni proprio turno. Quando l'incantesimo termina, il bersaglio perde tutti i punti ferita temporanei rimanenti forniti da questo incantesimo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, l'incantatore puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 1°",
    "availableClasses": [
      "Bardo",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "eroismo",
    "language": "it"
  },
  {
    "name": "Esilio",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un oggetto sgradito al bersaglio)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di inviare su un altro piano di esistenza una creatura che egli sia in grado di vedere e che si trovi entro gittata. Il bersaglio deve superare un tiro salvezza su Carisma o sara' esiliato. Se il bersaglio e' originario del piano di esistenza in cui si trova, l'incantatore lo esilia su un semipiano innocuo. Mentre si trova laggiu', il bersaglio e' incapacitato e rimane in quel luogo finché l'incantesimo non termina, nel qual caso ricompare nello spazio che aveva lasciato o nello spazio libero piu' vicino se quello spazio e' occupato. Se il bersaglio e' originario di un piano di esistenza diverso da quello in cui si trova l'incantatore, esso viene esiliato con una piccola implosione a malapena udibile e fa ritorno al suo piano natio. Se l'incantesimo termina prima che sia trascorso 1 minuto, il bersaglio ricompare nello spazio che aveva lasciato o nello spazio libero piu' vicino, se quello spazio e' occupato. Altrimenti non fara' ritorno.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 4°.",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Paladino",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un oggetto sgradito al bersaglio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "esilio",
    "language": "it"
  },
  {
    "name": "Esplosione Solare",
    "level": 8,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (fuoco e un pezzo di pietra solare)"
    ],
    "duration": "Istantanea",
    "description": "Un luminoso bagliore solare si espande in un raggio di 18 metri centrato su di un punto entro portata a scelta dell'incantatore. Ogni creatura situata in quella luce deve effettuare un tiro salvezza Costituzione. Se lo fallisce, una creatura subisce 12d6 danni radianti e viene accecata per 1 minuto. Se lo supera, subisce la meta' del danno e non viene accecata. Non-morti e gelatine hanno svantaggio a questo tiro salvezza. Una creatura accecata da questo incantesimo effettua un altro tiro salvezza Costituzione alla fine di ognuno dei propri turni. Se lo supera, non e' piu' accecata. Questo incantesimo disperde qualsiasi oscurita' creata da un incantesimo nella propria area d'effetto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "fuoco e un pezzo di pietra solare",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "esplosione-solare",
    "language": "it"
  },
  {
    "name": "Estasiare",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore pronuncia una frastornante sequenza di parole e costringe le creature a sua scelta entro gittata e che egli sia in grado di vedere a effettuare un tiro salvezza su Saggezza. Ogni creatura che non puo' essere affascinata supera questo tiro salvezza automaticamente, e se l'incantatore o i suoi compagni stanno combattendo contro una creatura, quella creatura dispone di vantaggio al tiro salvezza. Se la creatura bersaglio fallisce il tiro salvezza, subisce svantaggio alle prove di Saggezza (Percezione) effettuate per percepire una qualsiasi creatura diversa dall'incantatore finché l'incantesimo non termina o finché il bersaglio non e' piu' in grado di sentirlo. L'incantesimo termina se l'incantatore e' incapacitato o non e' piu' in grado di parlare.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "estasiare",
    "language": "it"
  },
  {
    "name": "Evoca Animali",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore evoca spiriti fatati che prendono la forma di animali ed appaiono in uno spazio non occupato che egli possa vedere entro gittata. Sceglie una delle seguenti opzioni per decidere cosa appare:Ogni bestia e' considerata anche folletto e scompare quando finisce a 0 punti ferita o quando finisce l'incantesimo. Le creature evocate sono amichevoli nei confronti dell'incantatore e dei suoi alleati. L'incantatore tira per l'iniziativa delle creature evocate come gruppo, che ha i propri turni. Le creature evocate obbediscono ai comandi verbali impartiti dall'incantatore (nessuna azione richiesta). Se l'incantatore non impartisce un comando, le creature evocate si difendono da eventuali altre creature ostili, ma altrimenti non intraprendono alcuna azione. Il DM possiede le statistiche delle creature.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evoca-animali",
    "language": "it"
  },
  {
    "name": "Evoca Celestiale",
    "level": 7,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 27 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Concentrazione, fino a 1 ora",
    "description": "L'incantatore evoca un celestiale con grado sfida 4 o inferiore, che appare in uno spazio non occupato che sia visibile all'incantatore ed entro gittata. Il celestiale scompare se ridotto a 0 punti ferita o alla fine dell'incantesimo. Il celestiale e' amichevole nei confronti dell'incantatore e dei suoi alleati. L'incantatore tira per l'iniziativa del celestiale, che ha i propri turni. Il celestiale obbedisce ai comandi verbali impartiti dall'incantatore (nessuna azione richiesta), fintanto che questi non vadano contro il suo allineamento. Se l'incantatore non impartisce un comando, il celestiale si difende da eventuali altre creature ostili, ma altrimenti non intraprende alcuna azione. Il DM possiede le statistiche del celestiale.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 9° livello, puo' evocare un celestiale con grado sfida 5 o inferiore.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evoca-celestiale",
    "language": "it"
  },
  {
    "name": "Evoca Creature Boschive",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 18 m",
    "components": [
      "Componenti: V",
      " S",
      " M (una bacca d'agrifoglio per ogni creatura evocata)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 ora",
    "description": "L'incantatore evoca creature fatate che appaiono in uno spazio non occupato che egli possa vedere entro gittata. Sceglie una delle seguenti opzioni per decidere cosa appare:Una creatura evocata scompare se ridotta a 0 punti ferita o alla fine dell'incantesimo. Le creature evocate sono amichevoli nei confronti dell'incantatore e dei suoi alleati. L'incantatore tira per l'iniziativa delle creature evocate come gruppo, che ha i propri turni.  Le creature evocate obbediscono ai comandi verbali impartiti dall'incantatore (nessuna azione richiesta). Se l'incantatore non impartisce un comando, le creature evocate si difendono da eventuali altre creature ostili, ma altrimenti non intraprendono alcuna azione. Il DM possiede le statistiche delle creature.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una bacca d'agrifoglio per ogni creatura evocata",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evoca-creature-boschive",
    "language": "it"
  },
  {
    "name": "Evoca Elementale",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (acqua e sabbia per l'acqua, incenso bruciato per l'aria, zolfo e fosforo per il fuoco, argilla duttile per la terra)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore chiama a sé un servitore elementale, scegliendo un'area di acqua, aria, fuoco o terra delle dimensioni di un cubo con spigolo di 3 metri situato entro gittata. Un elementale con grado di sfida pari o inferiore a 5 e appropriato all'area scelta appare in uno spazio libero entro 3 metri da quell'area. Per esempio, un elementale del fuoco scaturisce da un falo', mentre un elementale della terra emerge dal terreno. L'elementale scompare quando scende a 0 punti ferita o quando l'incantesimo termina. L'elementale e' amichevole nei confronti dell'incantatore e dei suoi compagni per la durata dell'incantesimo. Si tira per l'iniziativa dell'elementale, che svolge i propri turni. L'elementale obbedisce ai comandi verbali impartiti dall'incantatore (nessuna azione richiesta). Se l'incantatore non impartisce un comando, l'elementale si difende da eventuali altre creature ostili, ma altrimenti non intraprende alcuna azione. Se la concentrazione dell'incantatore e' interrotta, l'elementale non scompare. L'incantatore perde invece il controllo dell'elementale, che diventa ostile nei suoi confronti e nei confronti dei suoi compagni e li potrebbe attaccare. Un elementale privo di controllo non puo' essere congedato dall'incantatore e scompare 1 ora dopo essere stato evocato. Il DM possiede le statistiche dell'elementale.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, il grado sfida aumenta di 1 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "acqua e sabbia per l'acqua, incenso bruciato per l'aria, zolfo e fosforo per il fuoco, argilla duttile per la terra",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evoca-elementale",
    "language": "it"
  },
  {
    "name": "Evoca Elementali Minori",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 27 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Concentrazione, fino a 1 ora",
    "description": "L'incantatore evoca elementali che appaiono in uno spazio non occupato che egli possa vedere entro gittata. Sceglie una delle seguenti opzioni per decidere cosa appare:Un elementale evocato da questo incantesimo scompare se ridotto a 0 punti ferita o alla fine dell'incantesimo. Le creature evocate sono amichevoli nei confronti dell'incantatore e dei suoi alleati. L'incantatore tira per l'iniziativa delle creature evocate come gruppo, che ha i propri turni.  Le creature evocate obbediscono ai comandi verbali impartiti dall'incantatore (nessuna azione richiesta). Se l'incantatore non impartisce un comando, le creature evocate si difendono da eventuali altre creature ostili, ma altrimenti non intraprendono alcuna azione. Il DM possiede le statistiche delle creature.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evoca-elementali-minori",
    "language": "it"
  },
  {
    "name": "Evoca Folletto",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore evoca un folletto con grado di sfida pari o inferiore a 6 o uno spirito fatato che assume la forma di una bestia con grado di sfida pari o inferiore a 6. Il folletto appare in uno spazio libero entro gittata e che l'incantatore sia in grado di vedere. Il folletto scompare quando scende a 0 punti ferita o quando l'incantesimo termina. Il folletto e' amichevole nei confronti dell'incantatore e dei suoi compagni per la durata dell'incantesimo. Si tira per l'iniziativa del folletto, che svolge i propri turni. Obbedisce ai comandi verbali impartiti dall'incantatore (nessuna azione richiesta). Se l'incantatore non gli impartisce un comando, il folletto si difende da eventuali altre creature ostili, ma altrimenti non intraprende alcuna azione. Se la concentrazione dell'incantatore e' interrotta, il folletto non scompare. L'incantatore perde invece il controllo del folletto, che diventa ostile nei suoi confronti e nei confronti dei suoi compagni e li potrebbe attaccare. Un folletto privo di controllo non puo' essere congedato dall'incantatore e sompare 1 ora dopo essere stato evocato. Il DM e' in possesso delle statistiche del folletto.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, il grado di sfida aumenta di 1 per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Druido",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evoca-folletto",
    "language": "it"
  },
  {
    "name": "Evoca Pioggia di Armi",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 45 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (un qualsiasi proiettile o arma da lancio)"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore lancia in aria un proiettile non-magico da un'arma a distanza o un'arma da lancio non-magica e sceglie uno spazio entro gittata. Centinaia di copie del proiettile o dell'arma cadono come pioggia dall'alto per poi scomparire. Ogni creatura all'interno di un cilindro con raggio di 12 metri e alto 6 metri centrato su quello spazio deve effettuare un tiro salvezza Destrezza. Se lo fallisce, una creatura subisce 8d8 danni mentre se lo supera subisce solo la meta' di quei danni. Il tipo di danno e' lo stesso di quello dell'arma o proiettile utilizzato come componente.",
    "atHigherLevels": "",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un qualsiasi proiettile o arma da lancio",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "evoca-pioggia-di-armi",
    "language": "it"
  },
  {
    "name": "Evoca Raffica",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Incantatore (cono di 18 metri)",
    "components": [
      "Componenti: V",
      " S",
      " M (un qualsiasi proiettile o arma da lancio)"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore lancia in aria un'arma non-magica o un proiettile non-magico per creare un cono di armi identiche che vengono scagliate in avanti per poi scomparire. Ogni creatura entro un cono di 18 metri deve effettuare un tiro salvezza Destrezza. Se lo fallisce, una creatura subisce 3d8 danni mentre se lo supera subisce solo la meta' di quei danni. Il tipo di danno e' lo stesso di quello dell'arma o proiettile utilizzato come componente.",
    "atHigherLevels": "",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un qualsiasi proiettile o arma da lancio",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "evoca-raffica",
    "language": "it"
  },
  {
    "name": "Evocazioni Istantanee di Drawmij",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (uno zaffiro del valore di 1.000 mo)"
    ],
    "duration": "Durata: Finché dissolto",
    "description": "L'incantatore tocca un oggetto del peso di 5 kg o inferiore la cui dimensione maggiore sia di 2 metri o inferiore. L'incantesimo lascia un marchio invisibile sulla sua superficie ed inscrive in maniera invisibile il nome dell'oggetto sullo zaffiro utilizzato come componente materiale. Ogni volta che l'incantatore lancia questo incantesimo deve utilizzare uno zaffiro differente. In qualsiasi momento da li' in avanti, l'incantatore puo' utilizzare un azione per pronunciare il nome dell'oggetto e frantumare lo zaffiro. L'oggetto appare istantaneamente nelle mani dell'incantatore, indipendentemente dalla distanza fisica o planare e l'incantesimo termina. Se un altra creatura sta impugnando o trasportando l'oggetto, frantumare lo zaffiro non teleporta l'oggetto all'incantatore, egli invece viene a conoscenza di chi sia la creatura in possesso dell'oggetto e piu' o meno dove quella creatura si trovi in quel momento. Dissolvi Magie o un effetto simile applicato con successo allo zaffiro termina l'effetto dell'incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "uno zaffiro del valore di 1.000 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "evocazioni-istantanee-di-drawmij",
    "language": "it"
  },
  {
    "name": "Fabbricare",
    "level": 4,
    "school": "Trasmutazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 36 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore converte materiali grezzi in prodotti dello stesso materiale. Per esempio, egli puo' fabbricare un ponte di legno da un gruppo di alberi, una corda da un cumulo di canapa o vestiti da lino o cotone. L'incantatore sceglie dei materiali grezzi che possa vedere entro gittata. Data una sufficiente quantita' di materiale grezzo, egli puo' fabbricare un oggetto di dimensione Grande o inferiore (contenuto in un cubo di 3 metri di lato o otto cubi connessi di 1,5 metri di lato). Tuttavia, se l'incantatore sta lavorando con metallo, pietra o altra sostanza minerale, l'oggetto creato non puo' essere piu' grande di dimensione Media (contenuto in un singolo cubo di 1,5 metri di lato). La qualita' degli oggetti creati dall'incantesimo e' equivalente alla qualita' dei materiali grezzi utilizzati. Attraverso questo incantesimo non si possono creare o trasmutare creature od oggetti magici. Inoltre, l'incantatore non puo' usare l'incantesimo per fabbricare oggetti che normalmente richiederebbero un alto livello di mano d'opera, come gioielleria, vetro, armi o armatura a meno che egli abbia competenza con il tipo di strumenti da artigiano adatti alla creazione di tali oggetti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "fabbricare",
    "language": "it"
  },
  {
    "name": "Fame di Hadar",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (un tentacolo di piovra conservato sott'olio)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore apre un portale fino all'oscurita' celata tra le stelle, una regione infestata da orrori ignoti. Appare una sfera del raggio di 6 metri composta di oscurita' e di freddo pungente, centrata su un punto entro gittata, che permane per la durata dell'incantesimo. All'interno di quel vuoto echeggia una cacofonia di tenui sussurri e fauci biascicanti che possono essere uditi fino a 9 metri di distanza. Nessuna luce, magica o meno che sia, puo' illuminare l'area e le creature che si trovano completamente al suo interno sono accecate. Il vuoto genera una distorsione nella trama dello spazio e l'area e' considerata terreno difficile. Ogni creatura che inizia il suo turno nell'area subisce 2d6 danni da freddo. Ogni creatura che termina il suo turno all'interno dell'area deve superare un tiro salvezza su Destrezza altrimenti subisce 2d6 danni da acido inferti da un nugolo di tentacoli lattiginosi e ultraterreni che la sfiorano.",
    "atHigherLevels": "",
    "availableClasses": [
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un tentacolo di piovra conservato sott'olio",
    "damageTypes": [
      "acido",
      "freddo"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "fame-di-hadar",
    "language": "it"
  },
  {
    "name": "Faretra Rapida",
    "level": 5,
    "school": "Trasmutazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (una faretra contenente almeno un proiettile)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "L'incantatore trasmuta la propria faretra cosi' che produca una scorta infinita di munizioni non-magiche, che paiono saltare nelle sue mani quando allunga il braccio per prenderle. Fino alla fine dell'incantesimo, in ognuno dei suoi turni, l'incantatore puo' utilizzare un azione bonus per effettuare due attacchi con un'arma che utilizzi le munizioni della faretra. Ogni volta che viene effettuato questo attacco a distanza, la faretra rimpiazza magicamente il proiettile utilizzato con un simile proiettile non-magico. Qualsiasi proiettile creato da questo incantesimo si polverizza alla fine dell'incantesimo. Se la faretra viene separata dal possesso dell'incantatore, l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una faretra contenente almeno un proiettile",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "faretra-rapida",
    "language": "it"
  },
  {
    "name": "Faro di Speranza",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Questo incantesimo infonde speranza e vitalita'. L'incantatore sceglie un qualsiasi numero di creature entro gittata. Per la durata dell'incantesimo, ogni bersaglio dispone di vantaggio ai tiri salvezza su Saggezza e ai tiri salvezza contro morte e recupera il numero massimo di punti ferita possibile da qualsiasi guarigione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "faro-di-speranza",
    "language": "it"
  },
  {
    "name": "Fatale",
    "level": 9,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Traendo dalle paure piu' profonde di un gruppo di creature, l'incantatore manifesta nelle loro menti delle entita' illusorie visibili soltanto ad esse. Ogni creatura all'interno di una sfera con raggio di 9 metri centrata in un punto entro gittata a scelta dell'incantatore, deve effettuare un tiro salvezza Saggezza. Se lo fallisce, una creatura diventa spaventata per la durata dell'incantesimo. L'illusione risveglia le paure piu' profonde della creatura, manifestando i suoi peggiori incubi come un'implacabile minaccia. All'inizio di ogni turno della creatura spaventata, essa deve superare un tiro salvezza Saggezza oppure subire 4d10 danni psichici. Se il tiro salvezza viene superato, l'incantesimo termina per quella creatura.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "fatale",
    "language": "it"
  },
  {
    "name": "Favore Divino",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Intonando una preghiera, l'incantatore e' pervaso da un alone radioso di luce divina. Finché l'incantesimo non termina, i suoi attacchi con le armi infliggono 1d4 danni radiosi extra se colpiscono.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "favore-divino",
    "language": "it"
  },
  {
    "name": "Ferire",
    "level": 6,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 18 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore rilascia una virulenta malattia contro una creatura che sia visibile ed entro gittata. Il bersaglio deve effettuare un tiro salvezza Costituzione. Se lo fallisce, subisce 14d6 danni necrotici oppure la meta' di quel danno se lo supera. Il danno non puo' ridurre i punti ferita del bersaglio a meno di 1. Se il bersaglio fallisce il tiro salvezza, i suoi punti ferita massimi sono ridotti per 1 ora di un ammontare pari al danno necrotico subito. Qualsiasi effetto che rimuova una malattia permette ad una creatura di recuperare i punti ferita massimi normali prima che passi quel tempo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "ferire",
    "language": "it"
  },
  {
    "name": "Fermare il Tempo",
    "level": 9,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore ferma brevemente lo scorrere del tempo per chiunque eccetto se' stesso. Il tempo non scorre per le altre creature, mentre l'incantatore guadagna 1d4+1 turni di seguito, durante i quali puo' effettuare azioni e muoversi come di consueto. Questo incantesimo termina se una delle azioni che l'incantatore effettua durante questo periodo, o qualsiasi effetto che egli possa creare durante questo periodo, interessa una creatura diversa dall'incantatore od un oggetto indossato o portato da qualcuno diverso dall'incantatore. Inoltre, l'incantesimo termina se l'incantatore si sposta in un luogo a piu' di 300 metri dalla zona in cui e' stato lanciato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "fermare-il-tempo",
    "language": "it"
  },
  {
    "name": "Fiamma Perenne",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (50 mo di polvere di rubino che verrà consumata)"
    ],
    "duration": "Durata: Finché dissipato",
    "description": "Una fiamma che illumina quanto una torcia appare su un oggetto toccato. Ha l'aspetto di una normale fiamma, ma non emette calore e non richiede aria . La fiamma puo' essere nascosta o coperta, ma non spenta.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "50 mo di polvere di rubino che verrà consumata",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "fiamma-perenne",
    "language": "it"
  },
  {
    "name": "Fiamma Sacra",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un bagliore simile a una fiamma scende fino a una creatura entro gittata e che l'incantatore sia in grado di vedere. Il bersaglio deve superare un tiro salvezza su Destrezza, altrimenti subisce 1d8 danni radiosi. Il bersaglio non trae beneficio dalla copertura per questo tiro salvezza. I danni di questo incantesimo aumentano di 1d8 quando l'incantatore arriva al 5° livello (2d8), 11° livello (3d8) e 17° livello (4d8).",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "fiamma-sacra",
    "language": "it"
  },
  {
    "name": "Fiotto Acido",
    "level": 0,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore scaglia una bolla di acido,scegliendo una creatura entro gittata oppure due creature entro gittata situate a non piu' di 1,5 metri l'una dall'altra. Un bersaglio deve superare un tiro salvezza su Destrezza, altrimenti subisce 1d6 danni da acido. I danni di questo incantesimo aumentano di 1d6 quando l'incantatore arriva al 5° livello (2d6), 11° livello (2d6) e 17° livello (4d6).",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "acido"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "fiotto-acido",
    "language": "it"
  },
  {
    "name": "Folata di Vento",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (linea di 18 metri)",
    "components": [
      "V",
      " S",
      " M (il seme di un legume)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Una linea di vento forte lunga 18 metri e larga 3 metri si diffonde dall'incantatore in una direzione a sua sceltaper la durata dell'incantesimo. Ogni creatura che inizia il suo turno su quella linea deve superare un tiro salvezza su Forza, altrimenti sara' spinta di 4,5 metri piu' lontana dall'incantatore, nella stessa direzione della linea. Ogni creatura sulla linea deve spendere 60 cm di movimento per ogni 30 cm di cui si muove quando cerca di avvicinarsi alrincantatore. La folata disperde i gas e i vapori ed estingue candele, torce e simili fiamme prive di protezione nell'area. Fa tremolare le fiamme protette come quelle delle lanterne e ha una probabilita' del 50% di spegnerle. Con un'azione bonus in ogni suo turno prima che l'incantesimo termini, l'incantatore puo' cambiare la direzione in cui la linea si diffonde da sé.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "il seme di un legume",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "folata-di-vento",
    "language": "it"
  },
  {
    "name": "Fondersi nella Pietra",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "8 ore",
    "description": "L'incantatore entra in un oggetto o in una superficie di pietra sufficientemente grande da contenere il suo intero corpo, fondendosi nella pietra assieme a tutto l'equipaggiamento che trasporta per la durata dell'incantesimo. Usando il suo movimento, egli entra nella pietra in un punto che e' in grado di toccare. Nulla della sua presenza rimane visibile o individuabile da qualsiasi senso non magico. Finché e' fuso con la pietra, l'incantatore non puo' vedere cosa accade all'esterno e ogni prova di Saggezza (Percezione) che effettua per udire suoni subisce svantaggio. L'incantatore rimane cosciente del passaggio del tempo e puo' lanciare incantesimi su sé stesso finché e' fuso nella pietra. Puo' usare il suo movimento per lasciare la pietra nel punto in cui e' entrato, cosa che termina l'incantesimo. Altrimenti, e' impossibilitato a muoversi. Gli eventuali danni minori inferti alla pietra non feriscono l'incantatore,, ma la sua distruzione parziale o un'alterazione della sua forma (se sufficiente a fare in modo che non contenga piu' il suo corpo) provoca l'espulsione dell'incantatore e gli infligge 6d6 danni contundenti. Quando l'incantatore viene espulso,, cade a terra prono nello spazio libero piu' vicino al punti in cui era entrato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "contundenti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "fondersi-nella-pietra",
    "language": "it"
  },
  {
    "name": "Forma Eterea",
    "level": 7,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Fino a 8 ore",
    "description": "L'incantatore mette i piedi nelle regioni di confine del Piano Etereo, nell'area dove si sovrappone con il suo piano attuale. L'incantatore rimane nei Confini Eterei per la durata oppure finche' effettua un'azione per dissolvere l'incantesimo. Durante questo periodo, si puo' spostare in qualsiasi direzione. Se l'incantatore si sposta verso l'alto o il basso, ogni metro di movimento costa un metro extra. L'incantatore e' in grado di vedere e sentire il piano dal quale proviene, ma ogni cosa appare grigia e non puo' vedere oltre 18 metri di distanza. Mentre si trova nel Piano Etereo, l'incantatore puo' influenzare ed essere influenzato solo da creature presenti in quel piano. Le creature che non si trovano nel Piano Etereo non possono percepire o interagire con l'incantatore, a meno che un'abilita' speciale o incantesimo garantisca loro la capacita' di farlo. L'incantatore ignora tutti gli oggetti ed effetti che non si trovano nel Piano Etereo, permettendogli di muoversi attraverso oggetti che percepisce nel piano dal quale proviene. Quando l'incantesimo termina, l'incantatore torna immediatamente al piano dal quale e' partito nel punto in cui si trova attualmente. Se l'incantatore occupa lo stesso spazio di un oggetto solido o una creatura quando cio' accade, viene subito spinto verso il piu' vicino spazio libero che possa occupare e subisce danni da forza pari al doppio dei metri di cui viene spostato. Questo incantesimo non ha effetto se viene lanciato mentre l'incantatore si trova nel Piano Etereo o in un piano che non sia confinante con esso, come uno dei Piani Esterni.",
    "atHigherLevels": "Se questo incantesimo viene lanciato utilizzando uno slot incantesimo di 8° livello o superiore, possono essere scelte come bersaglio fino ad altre tre creature consenzienti (incantatore incluso) per ogni livello di slot incantesimo oltre il 7°. Le creature devono trovarsi entro 6 metri dall'incantatore quando l'incantesimo viene lanciato.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "forma-eterea",
    "language": "it"
  },
  {
    "name": "Forma Gassosa",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un frammento di garza e uno sbuffo di fumo)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore trasforma una creatura consenziente da lui toccata (assieme a tutto cio' che essa indossa e trasporta) in una nube di foschia per la durata dell'incantesimo. L'incantesimo termina se la creatura scende a 0 punti ferita. Una creatura incorporea non e' influenzata dall'incantesimo. Finché il bersaglio si trova in questa forma, il suo unico metodo di movimento e' una velocita' di volare pari a 3 metri. Il bersaglio puo' entrare nello spazio di un'altra creatura e occuparlo, dispone di resistenza ai danni non magici e di vantaggio ai tiri salvezza su Forza, Destrezza e Costituzione. Il bersaglio puo' passare attraverso piccoli fori, aperture strette e perfino semplici crepe, ma considera i liquidi come se fossero superfici solide. Il bersaglio non puo' cadere e continua a fluttuare nell'area anche quando e' stordito o incapacitato in altri modi. Finché e' in forma gassosa, il bersaglio non puo' parlare o manipolare oggetti, e quelli che trasporta o impugna non possono essere usati, lasciati cadere o manipolati in alcun modo. Il bersaglio non puo' attaccare o lanciare incantesimi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di garza e uno sbuffo di fumo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "forma-gassosa",
    "language": "it"
  },
  {
    "name": "Forme Animali",
    "level": 8,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 24 ore",
    "description": "La magia dell'incantatore trasforma gli altri in bestie. L'incantatore sceglie un qualsiasi numero di creature consenzienti che possa vedere ed entro gittata. Ogni bersaglio viene trasformato nella forma di una bestia di taglia Grande o piu' piccola con un grado sfida di 4 o inferiore. Nei turni successivi, l'incantatore puo' usare la propria azione per trasformare le creature influenzate in nuove forme. La trasformazione permane per ogni bersaglio attraverso la durata dell'incantesimo oppure finche' un bersaglio viene ridotto a 0 punti ferita o muore. L'incantatore puo' scegliere una forma differente per ciascun bersaglio. Le statistiche di gioco di un bersaglio vengono sostituite dalle statistiche della creatura scelta, tuttavia il bersaglio mantiene il proprio allineamento e i propri punteggi di Intelligenza, Saggezza e Carisma. Il bersaglio ottiene i punti ferita della sua nuova forma e quando torna alla propria forma naturale ritorna al numero di punti ferita che aveva prima della trasformazione. Se il bersaglio si ritrasforma per essere stato ridotto a 0 punti ferita, ogni danno in eccesso viene trasferito alla forma naturale. Fintanto che il danno in eccesso non riduca la forma naturale del bersaglio a 0 punti ferita, esso non viene reso incosciente. Il bersaglio e' limitato nelle azioni che puo' intraprendere dalla natura della sua nuova forma e non puo' parlare o lanciare incantesimi. L'equipaggiamento del bersaglio si fonde alla nuova forma. Il bersaglio non puo' attivare, impugnare o altrimenti beneficiare di alcun oggetto del proprio equipaggiamento.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "forme-animali",
    "language": "it"
  },
  {
    "name": "Frantumare",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di mica)"
    ],
    "duration": "Istantanea",
    "description": "Un rumore improvviso e assordante, dolorosamente intenso, si diffonde da un punto a scelta dell'incantatore situato entro gittata. Ogni creatura entro una sfera del raggio di 3 metri centrata su quel punto deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 3d8 danni da tuono, mentre se lo supera, subisce soltanto la meta' di quei danni. Una creatura fatta di materiale inorganico come pietra, cristallo o metallo subisce svantaggio a questo tiro salvezza. Anche un oggetto non magico che non sia indossato o trasportato subisce i danni se si trova entro l'area dell'incantesimo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di mica",
    "damageTypes": [
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "frantumare",
    "language": "it"
  },
  {
    "name": "Freccia Acida di Melf",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (una foglia di rabarbaro in polvere e lo stomaco di una vipera)"
    ],
    "duration": "Istantanea",
    "description": "Una freccia verde scintillante vola fino a un bersaglio entro gittata ed esplode generando uno spruzzo d'acido. L'incantatore effettua un attacco a distanza con questo incantesimo contro il bersaglio. Se colpisce, il bersaglio subisce immediatamente 4d4 danni da acido e 2d4 danni da acido alla fine del suo turno successivo. Se manca, la freccia spruzza di acido il bersaglio infliggendo la meta' dei danni iniziali e nessun danno alla fine del turno successivo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni (sia quelli iniziali che quelli successivi) aumentano di 1d4 per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una foglia di rabarbaro in polvere e lo stomaco di una vipera",
    "damageTypes": [
      "acido"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "freccia-acida-di-melf",
    "language": "it"
  },
  {
    "name": "Freccia Folgorante",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "La prossima volta in cui l'incantatore effettui un attacco con arma a distanza nel corso della durata dell'incantesimo, il proiettile dell'arma o l'arma stessa, se si tratta di un'arma da lancio, si trasforma in una saetta folgorante. L'incantatore effettua l'attacco come di consueto. Invece del normale danno dell'arma, il bersaglio subisce 4d8 danni da elettricita' se viene colpito, o la meta' di quel danno se viene mancato. Sia che l'incantatore colpisca o manchi, ogni creatura entro 6 metri dal bersaglio deve effettuare un tiro salvezza su Destrezza. Ognuna di quelle creature subisce 2d8 danni da elettricita' se lo fallisce, oppure la meta' di quel danno se lo supera. Il proiettile o arma successivamente torna alla sua forma normale.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo utilizzando uno slot incantesimo di 4° livello o superiore, il danno per entrambi gli effetti dell'incantesimo aumenta di 1d8 per ogni livello di slot superiore al 3°.",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "freccia-folgorante",
    "language": "it"
  },
  {
    "name": "Frusta di Spine",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (il gambo di una pianta spinata)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore crea una lunga frusta simile a un rampicante e coperta di spine che al suo comando sferza fino a una creatura entro gittata. L'incantatore effettua un attacco in mischia con questo incantesimo contro la creatura. Se colpisce, la creatura subisce 1d6 danni perforanti, e se la creatura e' di taglia Grande o inferiore, l'incantatore puo' trascinarla verso di sé di un massimo di 3 metri. I danni di questo incantesimo aumentano di 1d6 quando l'incantatore arriva al 5° livello (2d6), 11° livello (3d6) e 17° livello (4d6).",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "il gambo di una pianta spinata",
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "frusta-di-spine",
    "language": "it"
  },
  {
    "name": "Fulmine",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore (linea di 30 metri)",
    "components": [
      "V",
      " S",
      " M (un ciuffo di pelo e una verga d'ambra, di cristallo o di vetro)"
    ],
    "duration": "Istantanea",
    "description": "Un fulmine parte dall'incantatore in una direzione a sua scelta, formando una linea lunga 30 metri e larga 1,5 metri. Ogni creatura entro la linea deve effettuare un tiro salvezza su Destrezza. Se lo fallisce subisce 8d6 danni da fulmine, mentre se lo supera, subisce soltanto al meta' di quei danni. Il fulmine incendia oggetti infiammabili nell'area che non sono indossati o trasportati.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 3°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di pelo e una verga d'ambra, di cristallo o di vetro",
    "damageTypes": [
      "fulmine"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "fulmine",
    "language": "it"
  },
  {
    "name": "Fuorviare",
    "level": 5,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore diventa invisibile nello stesso momento in cui una sua replica illusoria appare nel punto in cui si trova. Il doppione permane per la durata dell'incantesimo, ma l'invisibilita' termina se l'incantatore attacca o lancia un incantesimo. L'incantatore puo' utilizzare la sua azione per spostare il doppione fino al doppio della propria velocita' e farlo gesticolare, parlare e comportare in qualsiasi maniera egli scelga. L'incantatore puo' vedere attraverso gli occhi della replica ed udire attraverso le sue orecchie come se si trovasse nello stesso punto. In ciascuno dei propri turni, come azione bonus, l'incantatore puo' passare dall'utilizzare i propri sensi a quelli della replica o viceversa. Mentre l'incantatore utilizza i sensi del doppione, si trova cieco e sordo in rapporto all'ambiente che lo circonda.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "fuorviare",
    "language": "it"
  },
  {
    "name": "Gabbia di Forza",
    "level": 7,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "30 metri",
    "components": [
      "V",
      " S",
      " M (polvere di rubino del valore di 1,500 mo)"
    ],
    "duration": "1 ora",
    "description": "Un immobile e invisibile prigione di forma cubica composta di energia magica prende forma attorno ad un area entro gittata a scelta dell'incantatore. La prigione puo' essere una gabbia o una scatola solida, a discrezione dell'incantatore. La prigione a forma di gabbia puo' essere lunga fino a 6 metri per lato ed e' composta da barre del diametro di 1,5 cm spaziate fra di loro di 1,5 cm. La prigione a forma di scatola puo' essere lunga fino a 3 metri per lato, creando una barriera solida che impedisce il passaggio di qualsiasi materia attraverso di essa e bloccando qualsiasi incantesimo lanciato verso l'interno o verso l'esterno di quell'area. Quando l'incantatore lancia l'incantesimo, qualsiasi creatura che si trovi completamente all'interno dell'area della gabbia viene intrappolata. Le creature solo parzialmente all'interno dell'area, o quelle troppo grandi per poter essere contenute all'interno dell'area, vengono allontanate dal centro dell'area finche' non se ne trovano completamente all'esterno. Una creatura all'interno della gabbia non puo' uscirne attraverso mezzi non-magici. Se la creatura prova ad utilizzare teletrasporto o viaggio interplanare per uscire dalla gabbia, deve prima effettuare un tiro salvezza su Carisma. Con un successo, la creatura puo' usare quella magia per uscire dalla gabbia. Con un fallimento, la creatura non puo' uscire e consuma l'utilizzo dell'incantesimo o abilita' senza alcun effetto. La gabbia si estende anche nel Piano Etereo, bloccando lo spostamento etereo. Questo incantesimo non puo' essere dissolto dall'incantesimo Dissolvi Magie.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "polvere di rubino del valore di 1,500 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "gabbia-di-forza",
    "language": "it"
  },
  {
    "name": "Giara Magica",
    "level": 6,
    "school": "Necromanzia",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (una gemma, un cristallo, un reliquiario o altro contenitore ornamentale del valore di almeno 500 mo)"
    ],
    "duration": "Finchè dissolto",
    "description": "Il corpo dell'incantatore cade in uno stato catatonico mentre la sua anima lo abbandona per entrare nel contenitore utilizzato come componente materiale dell'incantesimo. Mentre la sua anima si trova all'interno del contenitore, l'incantatore e' consapevole dell'ambiente circostante come se si trovasse nello spazio del contenitore. L'incantatore non puo' muoversi o utilizzare reazioni. L'unica azione che puo' intraprendere e' proiettare la propria anima fino a 30 metri all'esterno del contenitore, che sia per tornare al proprio corpo (ponendo fine all'incantesimo) o per tentare di possedere un corpo umanoide. L'incantatore puo' provare a possedere qualsiasi umanoide entro 30 metri che egli possa vedere (le creature protette dagli incantesimi Protezione dal Bene e dal Male o Circolo magico non posso essere possedute). Il bersaglio deve effettuare un tiro salvezza Carisma. Se lo fallisce, l'anima dell'incantatore si sposta all'interno del corpo del bersaglio e l'anima del bersaglio viene intrappolata nel contenitore. Se lo supera, il bersaglio resiste al tentativo di possessione dell'incantatore e quest'ultimo non puo' tentare di possederlo nuovamente per 24 ore. Una volta in possesso del corpo del bersaglio, l'incantatore lo controlla. Le sue statistiche di gioco vengono sostituite da quelle della creatura, tuttavia mantiene il proprio allineamento e i propri punteggi di Intelligenza, Saggezza e Carisma. Mantiene anche i benefici dei propri privilegi di classe. Se il bersaglio ha uno o piu' livelli in una qualsiasi classe, l'incantatore non puo' utilizzare alcuno dei suoi privilegi di classe. Nel frattempo, l'anima della creatura posseduta puo' percepire dall'interno del contenitore attraverso i propri sensi, ma non puo' muoversi o effettuare alcuna azione. Mentre possiede un corpo, l'incantatore puo' usare la propria azione per tornare dal corpo ospite al contenitore se questo si trova entro 30 metri di distanza, facendo tornare nel proprio corpo l'anima della creatura ospite. Se il corpo ospite muore mentre l'incantatore si trova al suo interno, la creatura muore ed esso deve effettuare un tiro salvezza su Carisma contro la propria CD Incantesimi. Se lo supera, l'incantatore torna al contenitore, se questo si trova entro 30 metri di distanza. Altrimenti, muore. Se il contenitore viene distrutto o l'incantesimo termina, l'anima dell'incantatore torna immediatamente al proprio corpo. Se il suo corpo e' morto oppure si trova a piu' di 30 metri di distanza quando prova a farvi ritorno, l'incantatore muore. Se l'anima di un'altra creatura si trova all'interno del contenitore quando viene distrutto, l'anima della creatura torna al proprio corpo se questo e' vivo e si trova entro 30 metri. Altrimenti, quella creatura muore. Quando l'incantesimo ha termine, il contenitore viene distrutto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una gemma, un cristallo, un reliquiario o altro contenitore ornamentale del valore di almeno 500 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "giara-magica",
    "language": "it"
  },
  {
    "name": "Glifo di Interdizione",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (incenso e polvere di dinamite del valore di almeno 200 mo, che l’incantesimo consuma)"
    ],
    "duration": "Durata: Finché non viene dissolto o innescato",
    "description": "Quando l’incantatore lancia questo incantesimo, traccia un glifo da cui in seguito si sprigionera' un effetto magico. Il glifo puo' essere tracciato su una superficie (come un tavolo, una sezione di pavimento o una parete) o all’interno di un oggetto che puo' essere chiuso (come un libro, una pergamena o un forziere del tesoro), al fine di nasconderlo. Il glifo puo' coprire un’area massima del diametro di 3 metri. Se la superficie o l’oggetto viene spostato per piu' di 3 metri dal punto in cui l’incantatore ha lanciato questo incantesimo, il glifo si infrange e l’incantesimo termina senza essereinnescato. Il glifo e' pressoché invisibile e richiede una prova di Intelligenza (Indagare) contro la CD del tiro salvezza dell’incantesimo per essere individuato. L’incantatore decide cosa innesca il glifo quando lancia l’incantesimo. Nel caso dei glifi tracciati su una superficie, gli inneschi piu' comuni includono toccare il glifo, camminare sul glifo, rimuovere un oggetto che copre il glifo, giungere ad una certa distanza dal glifo o manipolare l’oggetto su cui il glifo e' stato tracciato. Nel caso di un glifo tracciato su un oggetto, gli inneschi piu' comuni includono aprire quell’oggetto, giungere entro una certa distanza dall’oggetto, vedere o leggere il glifo. Una volta innescato il glifo, questo incantesimo termina. L’incantatore puo' affinare ulteriormente l’innesco in modo che l’incantesimo si attivi solo in certe circostanze o in base a certe caratteristiche fisiche (come per esempio l’altezza o il peso), il tipo della creatura (per esempio, l’interdizione potrebbe essere regolata per influenzare le aberrazioni o i drow) o l’allineamento. L’incantatore puo' anche stabilire le condizioni per quelle creature che non innescano il glifo, come per esempio quelle che pronunceranno una certa parola d’ordine. Quando l’incantatore traccia il glifo, puo' scegliere tra gli'fo magico e rune esplosive. Glifo Magico: L’incantatore puo' custodire un incantesimo preparato di 3° livello o inferiore all’interno del glifo lasciandolo come parte della procedura di creazione del glifo. L’incantesimo deve bersagliare una singola creatura o un’area. L’incantesimo custodito non ha alcun effetto immediato quando viene lanciato in questo modo. Quando il glifo si innesca, l’incantesimo custodito viene lanciato. Se l’incantesimo ha un bersaglio, bersaglia la creatura che hainnescato il glifo. Se l’incantesimo influenza un’area, l’area e' centrata su quella creatura. Se l’incantesimo evoca creature ostili o crea oggetti o trappole dannose, cio' che viene creato o evocato appare nel punto piu' vicino possibile all’intruso e lo attacca. Se l’incantesimo richiede concentrazione, permane fino alla fine della sua durata. Rune Esplosive: Quando questo glifo viene innescato, diffonde un’ondata di energia magica in una sfera del raggio di 6 metri centrata su di esso. La sfera si diffonde oltre gli angoli. Ogni creatura entro l’area deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 5d8 danni da acido, freddo, fulmine, fuoco o tuono (a scelta dell’incantatore al momento della creazione del glifo), mentre se lo supera, subisce soltanto la meta' di quei danni. Ai Livelli Superiori: Quando l’incantatore crea un glifo magico, puo' custodire qualsiasi incantesimo di livello pari o inferiore al livello dello slot usato per il glifo di interdizione. Se l’incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, i danni di un glifo rune esplosive aumentano di 1d8 per ogni slot di livello superiore al 3°.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "incenso e polvere di dinamite del valore di almeno 200 mo, che l’incantesimo consuma",
    "damageTypes": [
      "acido",
      "freddo",
      "fuoco",
      "fulmine",
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "glifo-di-interdizione",
    "language": "it"
  },
  {
    "name": "Globo Cromatico",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (un diamante di almeno 50 mo)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore scaglia una sfera di diametro 10 cm, contro una creatura entro gittata e che egli sia in grado di vedere. Puo' scegliere che tipo di globo creare tra acido, freddo, fulmine, fuoco, tuono o veleno e poi effettuare un attacco a distanza con questo incantesimo contro il bersaglio. Se l'attacco colpisce, la creatura subisce 3d8 danni del tipo scelto dall'incantatore.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un diamante di almeno 50 mo",
    "damageTypes": [
      "acido",
      "freddo",
      "fuoco",
      "fulmine",
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "globo-cromatico",
    "language": "it"
  },
  {
    "name": "Globo di Invulnerabilita'",
    "level": 6,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 3 metri)",
    "components": [
      "V",
      " S",
      " M (una perla di vetro o cristallo che si frantuma al termine dell'incantesimo)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Un immobile e tenuamente scintillante barriera prende forma in un raggio di 3 metri intorno all'incantatore e permane per la durata. Qualsiasi incantesimo di 5° livello o inferiore lanciato dall'esterno della barriera non puo' influenzare le creature od oggetti al suo interno, persino se l'incantesimo viene lanciato utilizzando uno slot incantesimo di livello superiore. Un incantesimo di questo tipo puo' prendere come bersaglio creature ed oggetti all'interno della barriera, ma l'incantesimo non ha alcun effetto su di essi. In maniera analoga, l'area all'interno della barriera viene esclusa dall'area d'effetto di quegli incantesimi.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo utilizzando uno slot incantesimo di 7° livello o superiore, la barriera blocca incantesimi di un livello superiore per ogni livello di slot superiore al 6°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una perla di vetro o cristallo che si frantuma al termine dell'incantesimo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "globo-di-invulnerabilita-",
    "language": "it"
  },
  {
    "name": "Guardiani Spirituali",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 4,5 metri)",
    "components": [
      "V",
      " S",
      " M (un simbolo sacro)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore chiama a sé degli spiriti che lo proteggano. Gli spiriti fluttuano attorno a lui a una distanza di 4,5 metri per la durata dell'incantesimo. Se l'incantatore e' buono o neutrale, la loro forma spettrale appare angelica o fatata (a scelta dell'incantatore). Se e' malvagio, appaiono come immondi. Quando l'incantatore lancia questo incantesimo, puo' designare un qualsiasi numero di creature che egli sia in grado di vedere, che non ne saranno influenzate. La velocita' di una creatura influenzata viene dimezzata nell'area, e quando la creatura entra nell'area per la prima volta o vi inizia il proprio turno, deve effettuare un tiro salvezza su Saggezza. Se lo fallisce subisce 3d8 danni radiosi (se l'incantatore e' buono o neutrale) o 3d8 danni necrotici (se e' malvagio), mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 3°.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un simbolo sacro",
    "damageTypes": [
      "radiosi",
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "guardiani-spirituali",
    "language": "it"
  },
  {
    "name": "Guardiano della Fede",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V"
    ],
    "duration": "8 ore",
    "description": "Un guardiano spettrale Grande compare e fluttua per la durata dell'incantesimo in uno spazio libero a scelta dell'incantatore situato entro gittata e che egli sia in grado di vedere. Il guardiano occupa quello spazio ed e' sfocato, ad eccezione di una spada scintillante e uno scudo decorati con il simbolo della divinita' dell'incantatore. Ogni creatura ostile all'incantatore che si muova fino a uno spazio entro 3 metri dal guardiano per la prima volta in un turno deve superare un tiro salvezza su Destrezza. Se lo fallisce, subisce 20 danni radiosi, mentre se lo supera, subisce soltanto la meta' di quei danni. Il guardiano svanisce quando ha inferto un totale di 60 danni.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "guardiano-della-fede",
    "language": "it"
  },
  {
    "name": "Guarigione",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore sceglie una creatura che puo' vedere. Riacquista 70 punti ferita. Cecita', sordita' e qualsiasi malattia finiscono. Questo incantesimo non ha effetto su non morti o costrutti.",
    "atHigherLevels": "La guarigione aumenta di 10 per ogni livello di slot sopra il 6°.",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "guarigione",
    "language": "it"
  },
  {
    "name": "Guarigione di Massa",
    "level": 9,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Durata: Istantaneo",
    "description": "L'incantatore puo' ripristinare fino a 700 punti ferita, divisi tra qualsiasi numero di creature che riesce a vedere. Le creature sono anche guarite da tutte le malattie, dalla cecita' e dalla sordita'. Questo incantesimo non ha effetto su non morti o costrutti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "guarigione-di-massa",
    "language": "it"
  },
  {
    "name": "Guida",
    "level": 0,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tocca una creatura consenziente. Una volta prima che l'incantesimo termini, il bersaglio puo' tirare un d4 e aggiungere il risultato a una prova di caratteristica a sua scelta. Puo' tirare il dado prima o dopo avere effettuato la prova di caratteristica. Dopodiché l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "guida",
    "language": "it"
  },
  {
    "name": "Guscio Anti-Vita",
    "level": 5,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore (raggio di 3 metri)",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Una scintillante barriera si estende verso l'esterno dalla posizione dell'incantatore in un raggio di 3 metri e si sposta insieme ad esso, rimandendo centrata sulla sua posizione e respingendo le creature diverse da non-morti e costrutti. La barriera permane per la durata. La barriera impedisce ad una creatura influenzata di passare o estendersi attraverso di essa. Una creatura influenzata puo' lanciare incantesimi o effettuare attacchi con armi a distanza o con portata attraverso la barriera. Se l'incantatore si sposta in maniera tale che una creatura influenzata sia costretta a passare attraverso la barriera, l'incantesimo ha termine.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "guscio-anti-vita",
    "language": "it"
  },
  {
    "name": "Identificare",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (una perla dal valore di almeno 100 monete d'oro e una piuma di gufo)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore sceglie un oggetto che deve toccare durante il lancio dell'incantesimo. Se si tratta di un oggetto magico o di un altro oggetto infuso di magia, apprende le sue proprieta' e come usarlo, se necessita di sintonia per usarlo e quante cariche contiene, se ne contiene. Apprende se l'oggetto e' influenzato da eventuali incantesimi e quali essi siano. Se l'oggetto e' stato creato da un incantesimo, l'incantatore apprende quale incantesimo l'ha creato. Se invece tocca una creatura durante il lancio dell'incantesimo, apprende quali incantesimi influenzano attualmente quella creatura, se ce ne sono.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una perla dal valore di almeno 100 monete d'oro e una piuma di gufo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "identificare",
    "language": "it"
  },
  {
    "name": "Illusione Minore",
    "level": 0,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "S",
      " M (un ciuffo di lana)"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore crea un suono o un'immagine di un oggetto entro gittata che permane per la durata dell'incantesimo. Se l'incantatore crea un suono, il suo volume puo' variare da un sussurro a un urlo. Puo' trattarsi della voce dell'incantatore, della voce di qualcun altro, del ruggito di un leone, di un rullo di tamburi o di un qualsiasi altro suono a sua scelta. Il suono puo' echeggiare ininterrottamente per tutta la durata, oppure l'incantatore puo' emettere suoni piu' discreti in momenti diversi prima che l'incantesimo termini. Se l'incantatore crea l'immagine di un oggetto (come per esempio una sedia, una serie di impronte nel fango o uno scrigno), quell'oggetto non deve essere piu' grande di un cubo con spigolo di 1,5 metri. L'immagine non puo' emettere suoni, luci, odori o qualsiasi altro effetto sensoriale.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di lana",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "illusione-minore",
    "language": "it"
  },
  {
    "name": "Illusione Programmata",
    "level": 6,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un ciuffo di lana e polvere di giada del valore di almeno 25 mo)"
    ],
    "duration": "finché non viene dissolto",
    "description": "Questa esibizione preprogrammata puo' durare un massimo di 5 minuti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di lana e polvere di giada del valore di almeno 25 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "illusione-programmata",
    "language": "it"
  },
  {
    "name": "Immagine Maggiore",
    "level": 3,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un pezzo di vello)"
    ],
    "duration": "Concentrazione, massimo 10 minuti",
    "description": "Crei l’immagine di un oggetto, una creatura o qualche altro fenomeno visibile non piu' grande di un cubo di 6 metri di spigolo. L’immagine appare in un punto a gittata che puoi vedere e vi rimane per la durata dell’incantesimo. L’immagine sembra completamente reale, e comprende suoni, odori e la temperatura appropriata alla cosa raffigurata. Non puoi generare calore o freddo sufficiente a provocare danni, né un suono abbastanza forte da infliggere danno da tuono o assordare una creatura, o un odore che possa far star male una creatura (come il fetore di un troglodita). Ai Livelli Piu' Alti.  Quando lanci questo incantesimo usando uno slot incantesimo di 6° livello o piu' alto, l’incantesimo dura finché non viene dissolto, senza richiedere la tua concentrazione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pezzo di vello",
    "damageTypes": [
      "freddo",
      "tuono"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "immagine-maggiore",
    "language": "it"
  },
  {
    "name": "Immagine Proiettata",
    "level": 7,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "750 km",
    "components": [
      "V",
      " S",
      " M (una riproduzione in miniatura dell'incantatore fatta di materiali del valore di almeno 5 mo)"
    ],
    "duration": "Concentrazione, fino a 1 giorno",
    "description": "L'incantatore crea una copia illusoria di sé stesso che permane per la durata dell'incantesimo. La copia puo' apparire in un qualsiasi luogo situato entro gittata e che l'incantatore abbia visto in precedenza, a prescindere dagli ostacoli frapposti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una riproduzione in miniatura dell'incantatore fatta di materiali del valore di almeno 5 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "immagine-proiettata",
    "language": "it"
  },
  {
    "name": "Immagine Silenziosa",
    "level": 1,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un ciuffo di lana)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore crea l'immagine di un oggetto, una creatura o un altro fenomeno visibile che non sia piu' grande di un cubo con spigolo di 4,5 metri. L'immagine appare in un punto situato entro gitata e permane per la durata dell'incantesimo. L'immagine e' puramente visiva; non e' accompagnata da suoni, odori o altri effetti sensoriali. L'incantatore puo' usare la sua azione per fare in modo che l'immagine si muova fino a qualsiasi altro punto entro gittata. Quando l'immagine cambia luogo, l'incantatore puo' alterare il suo aspetto in modo che il movimento appaia naturale per l'immagine. Per esempio, se crea l'immagine di una creatura e decide di muoverla, puo' alterare l'immagine in modo che sembri camminare.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di lana",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "immagine-silenziosa",
    "language": "it"
  },
  {
    "name": "Immagine Speculare",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 minuto",
    "description": "Tre duplicati illusori dell'incantatore compaiono nel suo spazio. Finché l'incantesimo non termina, i duplicati si muovono assieme a lui e imitano le sue azioni, cambiando posizione in modo che sia impossibile individuare quale immagine sia quella vera. L'incantatore puo' usare la  sua azione per congedare i duplicati illusori. Ogni volta che una creatura bersaglia l'incantatore con un attacco, l'incantatore tira un d20 per determinare se l'attacco bersaglia invece uno dei duplicati. Se l'incantatore possiede tre duplicati, deve ottenere al tiro un 6 o piu' per spostare il bersaglio dell'attacco su un duplicato. Se possiede due duplicati, deve ottenere al tiro un 8 o piu'. Se possiede un duplicato, deve ottenere al tiro un 11 o piu'. La CA di un duplicato e' pari a 10 + il modificatore di Destrezza dell'incantatore. Se un attacco colpisce un duplicato, esso viene distrutto. Un duplicato puo' essere distrutto solo da un attacco che lo colpisce. Ignora tutti gli altri danni ed effetti. L'incantesimo termina quando tutti e tre i duplicati sono distrutti. Una creatura non e' influenzata da questo incantesimo se non puo' vedere, se si affida ai sensi diversi dalla vista, come per esempio la vista cieca, o se puo' percepire le illusioni come false, nel caso sia dotata di visione del vero.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d20"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "immagine-speculare",
    "language": "it"
  },
  {
    "name": "Imprigionare",
    "level": 9,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un ritratto su pergamena o una statuetta che riproduce le fattezze del bersaglio e una componente speciale che varia in base alla versione dell'incantesimo che si desidera lanciare, del valore di almeno 500 mo per ogni Dado Vita del bersaglio) ​​​​​​"
    ],
    "duration": "Finché non viene dissolto",
    "description": "L'incantatore crea una costrizione magica per trattenere una creatura entro gittata e che egli sia in grado di vedere. Il bersaglio deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, sara' vincolato dall'incantesimo; se invece lo supera, sara' immune a questo incantesimo qualora l'incantatore dovesse lanciarlo di nuovo. Finché e' influenzata da questo incantesimo, la creatura non ha bisogno di respirare, mangiare o bere e non invecchia. Gli incantesimi di divinazione non possono localizzare o percepire il bersaglio. Quando l'incantatore lancia l'incantesimo, sceglie una delle seguenti forme di prigionia. Ceppi. Il bersaglio e' bloccato sul posto da una serie di pesanti catene saldamente ancorate al terreno. Il bersaglio e' trattenuto finché l'incantesimo non termina e non puo' muoversi o essere mosso in alcun modo fino ad allora. La componente speciale per questa versione dell'incantesimo e' una catenella di metallo prezioso. Prigione Delimitata. L'incantesimo trasporta il bersaglio su un minuscolo semipiano protetto da un'interdizione contro il teletrasporto e i viaggi planari. Il semipiano puo' essere un labirinto, una gabbia, una torre o un'analoga struttura confinata a scelta dell'incantatore. La componente speciale per questa versione dell'incantesimo e' una riproduzione in miniatura della prigione desiderata fatta di giada. Prigionia ridotta. Il bersaglio e' rimpicciolito fino a un'altezza di 2,5 cm ed e' rinchiuso in una gemma o in un oggetto simile. La gemma lascia passare la luce normalmente (consentendo al bersaglio di vedere all'esterno e alle altre creature di vedere all'interno), ma nient'altro puo' attraversarla, nemmeno tramite teletrasporto o viaggi planari. La gemma non puo' essere intagliata o infranta finché l'incantesimo ha effetto. La componente speciale per questa versione dell'incantesimo e' una grossa gemma trasparente, come un corindone, un diamante o un rubino. Sepoltura. Il bersaglio e' sepolto nelle viscere della terra, in una sfera di forza magica sufficientemente grande da contenerlo. Nulla puo' attraversare la sfera e nessuna creatura puo' teletrasportarsi o usare un viaggio planare per entrare o uscire dalla sfera. La componente speciale per questa versione dell'incantesimo e' un piccolo globo di mithral. Sonno. Il bersaglio si addormenta e non puo' essere svegliato. La componente speciale per questa versione dell'incantesimo e' una raccolta di rare erbe soporifere. Terminare l'Incantesimo. Durante il lancio dell'incantesimo, in qualsiasi sua versione, l'incantatore puo' specificare una condizione che porra' termine all'incantesimo e liberera' il bersaglio. La condizione puo' essere specifica e complessa quanto l'incantatore desidera, ma il DM deve considerarla ragionevole e ritenere che abbia una certa probabilita' di verificarsi. Le condizioni possono basarsi sul nome, l'identita' o la divinita' di una creatura, ma devono basarsi su azioni o qualita' osservabili e non su concetti intangibili come il livello, la classe o i punti ferita. Un incantesimo dissolvi magie puo' terminare questo incantesimo solo se viene lanciato come incantesimo di 9° livello bersagliando la prigione o la componente speciale usata per crearla. L'incantatore puo' usare una determinata componente speciale soltanto per creare una prigione alla volta. Se lancia di nuovo l'incantesimo usando la stessa componente, il bersaglio del primo lancio viene immediatamente liberato dalla sua prigionia.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ritratto su pergamena o una statuetta che riproduce le fattezze del bersaglio e una componente speciale che varia in base alla versione dell'incantesimo che si desidera lanciare, del valore di almeno 500 mo per ogni Dado Vita del bersaglio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "imprigionare",
    "language": "it"
  },
  {
    "name": "Inaridire",
    "level": 4,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Una creatura entro gittata e che l'incantatore sia in grado di vedere e' investita da un'ondata di energia necromantica che ne prosciuga i fluidi corporei e la vitalita'. Il bersaglio deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 8d8 danni necrotici, mentre se lo supera, subisce soltanto la meta' di quei danni. Questo incantesimo non ha alcun effetto sui costrutti o sui non morti. Se l'incantatore bersaglia una creatura vegetale o un vegetale magico, tale bersaglio subisce svantaggio al tiro salvezza e l'incantesimo infligge il massimo dei danni. Se l'incantatore bersglia un vegetale non magico che non e' una creatura, come un albero o un arbusto, esso non effettua alcun tiro salvezza: avvizzisce e muore automaticamente.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 4°.",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "inaridire",
    "language": "it"
  },
  {
    "name": "Individuazione dei Pensieri",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (una moneta di rame)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Per la durata dell'incantesimo, l'incantatore puo' leggere i pensieri di certe creature. Quando lancia l'incantesimo e come sua azione in ogni turno finché l'incantesimo non termina, l'incantatore puo' concentrarsi su una qualsiasi creatura situata entro 9 metri da lui e che egli sia in grado di vedere. Se la creatura scelta ha un'Intelligenza pari o inferiore a 3 o non parla alcun linguaggio, non puo' essere influenzata dall'incantesimo. All'inizio l'incantatore apprende i pensieri superficiali della creatura (cio' a cui la creatura sta pensando in quel momento). Con un'azione, l'incantatore puo' trasferire la sua attenzione sui pensieri di un'altra creatura oppure tentare di sondare piu' a fondo la mente della stessa creatura. Se sonda piu' a fondo, il bersaglio deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, all'incantatore vengono rivelati i suoi ragionamenti (se ne fa), il suo stato emotivo e una presenza dominante nei suoi pensieri (qualcosa di cui si preoccupa, che ama o che odia). Se ha successo, l'incantesimo termina. In ogni caso, il bersaglio e' consapevole che l'incantatore sta sondando la sua mente: se l'incantatore non trasferisce la sua attenzione sui pensieri di un'altra creatura, la creatura puo' usare la sua azione nel proprio turno per effettuare una prova di Intelligenza contrapposta alla prova di Intelligenza dell'incantatore. Se ha successo, l'incantesimo termina. Le domande rivolte verbalmente alla creatura bersaglio plasmano naturalmente il corso dei suoi pensieri, quindi questo incantesimo e' particolarmente efficace nel corso di un interrogatorio. L'incantatore puo' anche usare questo incantesimo per individuare la presenza di creature pensanti che non e' in grado di vedere. Quando lancia l'incantesimo, o come sua azione nell'arco della durata, l'incantatore puo' cercare pensieri entro un raggio di 9 metri da sé. L'incantesimo puo' penetrare la maggior parte delle barriere, ma e' bloccato da 60 cm di pietra, 5 cm di metallo diverso dal piombo o una sottile lamina di piombo. L'incantatore non puo' individuare una creatura con un'Intelligenza pari o inferiore a 3, o che non parli alcun linguaggio. Una volta individuata la presenza di una creatura in questo modo, l'incantatore puo' leggere i suoi pensieri per il resto della durata nel modo sopra descritto, anche se non e' in grado di vederla; la creatura, tuttavia, deve comunque trovarsi entro gittata.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una moneta di rame",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "individuazione-dei-pensieri",
    "language": "it"
  },
  {
    "name": "Individuazione del Bene e del Male",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Senti la posizione di un'aberrazione, celestiale, elementale, fata, demone o non morto se si trova a meno di 9 metri da te. Se c'e' un luogo o un oggetto che e' stato magicamente consacrato o dissacrato entro 9 metri, puoi anche localizzarlo. Non sei in grado di percepire queste cose attraverso 30 cm di pietra, 1 pollice di metallo comune, un sottile foglio di piombo o 1 metro di legno o terra.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "individuazione-del-bene-e-del-male",
    "language": "it"
  },
  {
    "name": "Individuazione del Magico",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Per la durata dell'incantesimo, l'incantatore percepisce la presenza della magia entro 9 metri da lui. Se percepisce la magia in questo modo, puo' usare la sua azione per vedere una debole aura attorno a ogni creatura o oggetto visibile nell'area e che contenga magia, e apprende di che scuola di magia si tratta, se ne esiste una. L'incantesimo puo' penetrare la maggior parte delle barriere, ma e' bloccato da 30 cm di pietra, 2,5 cm di metallo comune, una sottile lamina di piombo o 90 cm di legno o terriccio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Paladino",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "individuazione-del-magico",
    "language": "it"
  },
  {
    "name": "Individuazione delle Malattie e dei Veleni",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (una foglia di tasso)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Se esistono o appaiono entro 9 metri, percepisci la presenza di veleni, creature velenose e malattie. Anche la loro posizione e il loro tipo diventano noti. Questo incantesimo e' bloccato da 30 cm di pietra, 1 pollice di metallo comune, un sottile foglio di piombo o 1 metro di legno o terra.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Paladino",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una foglia di tasso",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "individuazione-delle-malattie-e-dei-veleni",
    "language": "it"
  },
  {
    "name": "Infliggi Ferite",
    "level": 1,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Tocco",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantaneo",
    "description": "Effettua un attacco incantesimo corpo a corpo contro una creatura che puoi raggiungere. In caso di successo, il bersaglio subisce un danno necrotico di 3d10.",
    "atHigherLevels": "Quando lanci questa magia usando uno slot incantesimo di 2° livello o superiore, il danno aumenta di 1d10 per ogni livello di slot superiore al 1°.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "infliggi-ferite",
    "language": "it"
  },
  {
    "name": "Ingrandire/Ridurre",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 9 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (un pizzico di polvere di ferro)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "L'incantatore ingrandisce o riduce una creatura o un oggetto situato entro gittata e che egli sia in grado di vedere per la durata dell'incantesimo. L'incantatore deve scegliere una creatura o un oggetto che non sia indossato o trasportato. Se il bersaglio non e' consenziente, puo' effettuare un tiro salvezza su Costituzione. Se lo supera, l'incantesimo non ha effetto. Se il bersaglio e' una creatura, tutto cio' che essa indossa e trasporta cambia taglia assieme a lei. Ogni oggetto lasciato cadere da una creatura influenzata torna immediatamente alla sua taglia normale. Ingrandire. La taglia del bersaglio raddoppia in tutte le sue dimensioni e i suo peso aumenta di otto volte. Questa crescita aumenta la taglia della creatura di una categoria (da Media a Grande, per esempio). Se non c'e' abbastanza spazio per consentire al bersaglio di raddoppiare la sua taglia, la creatura o l'oggetto in questione sviluppa la massima taglia possibile nello spazio disponibile. Finché l'incantesimo non termina, il bersaglio dispone anche di vantaggio alle prove di Forza e ai tiri salvezza su Forza. Anche le armi del bersaglio crescono fino ad adattarsi alla nuova taglia. Finché queste armi sono ingrandite, gli attacchi effettuati dal bersaglio con queste armi infliggono 1d4 danni extra. Ridurre. La taglia del bersaglio si dimezza in tutte le dimensioni e il suo peso diventa un ottavo del peso normale. Questa riduzione diminuisce la taglia della creatura di una categoria (da Media a Piccola, per esempio). Finché l'incantesimo non termina, il bersaglio subisce svantaggio alle prove di Forza e ai tiri salvezza su Forza. Anche le armi del bersaglio si riducono fino ad adattarsi alla nuova taglia. Finché queste armi sono ridotte, gli attacchi effettuati dal bersaglio con queste armi infliggono 1d4 danni in meno (i danni non possono scendere a meno di 1).",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di polvere di ferro",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "ingrandireridurre",
    "language": "it"
  },
  {
    "name": "Insetto Gigante",
    "level": 4,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore trasforma un massimo di dieci millepiedi, tre ragni, cinque vespe o uno scorpione situati entro gittata in versioni giganti delle loro forme naturali per la durata dell'incantesimo. Un millepiedi diventa un millepiedi gigante, un ragno diventa un ragno gigante, una vespa diventa una vespa gigante e uno scorpione diventa uno scorpione gigante. Ogni creatura obbedisce ai comandi verbali dell'incantatore e in combattimento agisce al turno dell'incantatore durante ogni round. Il DM possiede le statistiche di queste creature e risolve le loro azioni e i loro movimenti. Una creatura rimane in questa forma gigante per la durata dell'incantesimo, finché non scende a 0 punti ferita o finché l'incantatore non usa un'azione per terminare l'effetto su di essa. Il DM potrebbe consentire all'incantatore di scegliere dei bersagli diversi. Per esempio, un'ape trasformata da questo incantesimo sara' una versione gigante che usera' le stesse caratteristiche di una vespa gigante.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "insetto-gigante",
    "language": "it"
  },
  {
    "name": "Interdizione alla Morte",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "8 ore",
    "description": "L'incantatore tocca una creatura e le conferisce una certa misura di protezione dalla morte. La prima volta in cui il bersaglio dovrebbe scendere a 0 punti ferita a seguito dei danni subiti, il bersaglio scende invece a 1 punto ferita e l'incantesimo termina. Se l'incantesimo ha ancora effetto quando il bersaglio e' soggetto a un effetto che lo ucciderebbe istantaneamente senza infliggere danni, quell'effetto e' invece negato contro il bersaglio e l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "interdizione-alla-morte",
    "language": "it"
  },
  {
    "name": "Interdizione alle Lame",
    "level": 0,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 round",
    "description": "l'incantatore protende la mano in avanti e traccia un simbolo di interdizione nell'aria. Fino alla fine del suo turno successivo, l'incantatore dispone di resistenza ai danni contundenti, perforanti e taglienti inferti dagli attacchi con le armi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "contundenti",
      "perforanti",
      "taglienti"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "interdizione-alle-lame",
    "language": "it"
  },
  {
    "name": "Intermittenza",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore tira un d20 alla fine di ogni suo turno per la durata dell'incantesimo. Con un risultato pari o superiore a 11, svanisce dal suo piano di esistenza attuale e compare sul Piano Etereo (se l'incantatore gia' si trovava su quel piano, l'incantesimo non funziona e il lancio va sprecato). All'inizio del turno successivo, e quando l'incantesimo termina se l'incantatore si trova sul Piano Etereo, l'incantatore torna su uno spazio libero a sua scelta, situato entro 3 metri dallo spazio da cui e' svanito e che egli sia in grado di vedere. Se nessuno spazio e' disponibile entro quella gittata, l'incantatore appare nello spazio libero piu' vicino (determinato casualmente se piu' spazi liberi si trovano a pari distanza). L'incantatore puo' terminare questo incantesimo con un'azione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d20"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "intermittenza",
    "language": "it"
  },
  {
    "name": "Intimorire Infernale",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 reazione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore punta l'indice contro la creatura che gli ha inferto danni e quella creatura e' momentaneamenteavviluppata da una cortina di fiamme infernali. La creatura deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 2d10 danni da fuoco, mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello osuperiore, i danni aumentano di 1d10 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "intimorire-infernale",
    "language": "it"
  },
  {
    "name": "Intralciare",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 27 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "Erbacce e rampicanti spuntano dal terreno in un quadrato con lato di 6 metri che parte da un punto situato entro gittata. Per la durata dell'incantesimo, questi vegetali trasformano l'area in terreno difficile. Una creatura situata nell'area quando l'incantatore lancia questo incantesimo deve superare un tiro salvezza su Forza, altrimenti e' trattenuta dai vegetali intralcianti finché l'incantesimo non termina. Una creatura trattenuta dai vegetali puo' usare la sua azione per effettuare una prova di Forza contro la CD del tiro salvezza dell'incantesimo. Se ha successo, si libera. Quando l'incantesimo termina, i vegetali evocati avvizziscono.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "intralciare",
    "language": "it"
  },
  {
    "name": "Inversione della Gravita'",
    "level": 7,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "30 metri",
    "components": [
      "V",
      " S",
      " M (una calamita e limatura di ferro)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Questo incantesimo inverte la gravita' all'interno di un cilindro del raggio di 15 metri e alto 30 metri, centrato su un punto situato entro gittata. Tutte le creature e gli oggetti che non sono in qualche modo ancorati al terreno all'interno dell'area cadono verso l'alto e arrivano in cima all'area quando l'incantesimo viene lanciato. Una creatura puo' effettuare un tiro salvezza su Destrezza per afferrare un oggetto ancorato entro portata, evitando in questo modo la caduta. Se un oggetto solido di qualche tipo (come per esempio un soffitto) viene urtato durante questa caduta, gli oggetti e le creature subiscono un impatto identico a quello che subirebbero durante una normale caduta verso il basso. Se un oggetto o una creatura arriva in cima all'area senza colpire niente, rimane lassu' a oscillare leggermente per la durata dell'incantesimo. Alla fine della durata, gli oggetti e le creature influenzate ricadono a terra.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una calamita e limatura di ferro",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "inversione-della-gravita-",
    "language": "it"
  },
  {
    "name": "Inviare",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Illimitata",
    "components": [
      "V",
      " S",
      " M (un pezzo di cavo di rame)"
    ],
    "duration": "1 round",
    "description": "L'incantatore invia un breve messaggio di massimo venticinque parole a una creatura che gli sia familiare. La creatura sente il messaggio nella sua mente, riconosce l'incantatore come colui che l'ha inviato e puo' rispondere immediatamente allo stesso modo. L'incantesimo consente alle creature con un punteggio di Intelligenza pari o superiore a 1 di capire il significato del messaggio. L'incantatore puo' inviare il messaggio a qualsiasi distanza e perfino sugli altri piani di esistenza, ma se il bersaglio si trova su un piano di esistenza diverso dal suo, c'e' una probabilita' del 5 per cento che il messaggio non arrivi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pezzo di cavo di rame",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "inviare",
    "language": "it"
  },
  {
    "name": "Invisibilita'",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un ciglio in uno strato di resina)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Una creatura toccata dall'incantatore diventa invisibile finché l'incantesimo non termina. Anche tutto cio' che il bersaglio indossa o trasporta diventa invisibile finché rimane sulla sua persona. L'incantesimo termina per un bersaglio quando quel bersaglio attacca o lancia un incantesimo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciglio in uno strato di resina",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "invisibilita-",
    "language": "it"
  },
  {
    "name": "Invisibilita' Superiore",
    "level": 4,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore o la creatura da lui toccata diventa invisibile finché l'incantesimo non termina. Anche tutto cio' che il bersaglio indossa o trasporta diventa invisibile finché rimane sulla sua persona.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "invisibilita--superiore",
    "language": "it"
  },
  {
    "name": "Invocare il Fulmine",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Una nube tempestosa a forma di un cilindro del raggio di 18 metri e alto 3 metri compare in un punto che l'incantatore sia in grado di vedere e situato a 30 metri direttamente sopra di lui. L'incantesimo fallisce se l'incantatore non e' in grado di vedere il punto in cui la nube tempestosa potrebbe comparire (per esempio, se si trova all'interno di una stanza che non e' in grado di contenere la nube). Quando l'incantatore lancia l'incantesimo, sceglie un punto entro gittata e che egli sia in grado di vedere. Una scarica di fulmini si propaga dalla nube fino a quel punto. Ogni creatura entro 1,5 metri da quel punto deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 3d10 danni da fulmine, mentre se lo supera, subisce soltanto la meta' di quei danni. A ogni suo turno finché l'incantesimo non termina, l'incantatore puo' usare la sua azione per invocare di nuovo il mulmine in questo modo, bersagliando lo stesso punto o un punto diverso. Se l'incantatore si trova all'esterno durante una tempesta quando lancia questo incantesimo, ottiene il controllo della tempesta esistente anziché crearne una nuova. In queste condizioni i danni dell'incantesimo aumentano di 1d10.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, i danni aumentano di 1d10 per ogni slot di livello superiore al 3°.",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fulmine"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "invocare-il-fulmine",
    "language": "it"
  },
  {
    "name": "Labirinto",
    "level": 8,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore esilia una creatura entro gittata e che egli sia in grado di vedere su un semipiano labirintico. Il bersaglio rimane laggiu' per la durata dell'incantesimo o finché non fugge dal labirinto. Il bersaglio puo' usare la sua azione per tentare di fuggire. Quando lo fa, effettua una prova di Intelligenza con CD 20. Se ha successo, riesce a fuggire e l'incantesimo termina (un minotauro o un demone goristro hano successo automaticamente). Quando l'incantesimo termina, il bersaglio ricompare nello spazio che ha lasciato o, se quello spazio e' occupato, nello spazio libero piu' vicino.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "labirinto",
    "language": "it"
  },
  {
    "name": "Lama Infuocata",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (una foglia di scotano)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore evoca una lama infuocata nella sua mano libera. La lama ha forma e dimensioni simili a quelle di una scimitarra e permane per la durata dell'incantesimo. Se l'incantatore la lascia andare, la lama scompare, ma puo' essere evocata di nuovo con un'azione bonus da parte dell'incantatore. L'incantatore puo' usare la sua azione per effettuare un attacco in mischia con questo incantesimo con la lama infuocata. Se colpisce, il bersaglio subisce 3d6 danni da fuoco. La lama infuocata proietta luce intensa entro un raggio di 3 metri e luce fioca per altri 3 metri.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, i danni aumentano di 1d6 per ogni due slot oltre il 2°.",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una foglia di scotano",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "lama-infuocata",
    "language": "it"
  },
  {
    "name": "Legame Planare",
    "level": 5,
    "school": "Abiurazione",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un gioiello del valore di almeno 1000 mo, che l'incantesimo consuma)"
    ],
    "duration": "24 ore",
    "description": "Con questo incantesimo, l'incantatore tenta di vincolare un celestiale, un elementale, un folletto o un immondo e di metterlo al suo servizio. La creatura deve trovarsi entro gittata per l'intero lancio dell'incantesimo. (Solitamente la creatura viene prima evocata al centro di un cerchio magico invertito per tenerlo intrappolato mentre questo incantesimo viene lanciato. ) Completato il lancio, il bersaglio deve effettuare un tiro salvezza su Carisma. Se lo fallisce, e' obbligato a servire l'incantatore per la durata dell'incantesimo. Se la creatura e' stata evocata o creata da un altro incantesimo, la durata di quell'incantesimo viene estesa per corrispondere alla durata di questo. Una creatura vincolata deve eseguire le istruzioni dell'incantatore al meglio delle sue capacita'. L'incantatore potrebbe ordinare alla creatura di accompagnarlo in un'avventura, di proteggere un luogo o di trasmettere un messaggio. La creatura obbedisce alla lettera alle sue istruzioni, ma se e' ostile nei confronti dell'incantatore lottera' per interpretare a modo suo le parole di quest'ultimo e perseguire i suoi obiettivi personali. Se la creatura porta a termine le istruzioni dell'incantatore prima che l'incantesimo termini, si reca da lui per riferirgli di cio' che ha fatto, se si trova sul suo stesso piano di esistenza. Se l'incantatore si trova su un piano di esistenza diverso, la creatura torna nel luogo in cui e' stata vincolata e vi rimane finché l'incantesimo non termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di un livello superiore, la durata aumenta a 10 giorni con uno slot di 6° livello, a 30 giorni con uno slot di 7° livello, a 180 giorni con uno slot di 8° livello e a un anno e un giorno con uno slot di 9° livello.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un gioiello del valore di almeno 1000 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "legame-planare",
    "language": "it"
  },
  {
    "name": "Legame Telepatico di Rary",
    "level": 5,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (pezzi di gusci d'uovo di due tipi di creature diverse)"
    ],
    "duration": "1 ora",
    "description": "L'incantatore stringe un legame telepatico con un massimo di otto creature consenzienti a sua scelta situate entro gittata, collegando fisicamente ogni creatura e tutte le altre per la durata dell'incantesimo. Le creature con un punteggo di Intelligenza pari o inferiore a 2 non sono influenzate da questo incantesimo. Finché l'incantesimo non termina, i bersagli possono comunicare telepaticamente attraverso il legame, a prescindere che abbiano un linguaggio in comune o meno. La comunicazione e' possibile attraverso qualsiasi distanza, ma non puo' estendersi ad altri piani di esistenza.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "pezzi di gusci d'uovo di due tipi di creature diverse",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "legame-telepatico-di-rary",
    "language": "it"
  },
  {
    "name": "Lentezza",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (una goccia di melassa)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore altera il tempo attorno a un massimo di sei creature a sua scelta all'interno di un cubo con spigolo di 12 metri situato entro gittata. Ogni bersaglio deve superare un tiro salvezza su Saggezza, altrimenti e' influenzato da questo incantesimo per la sua durata. Un bersaglio influenzato subisce una penalita' di -2 alla CA e ai tiri salvezza su Destrezza, non puo' usare reazioni e la sua velocita' e' dimezzata. Nel proprio turno, il bersaglio deve scegliere se usare un'azione o un'azione bonus, ma non entrambe. A prescindere dalle sue capacita' e oggetti magici, non puo' effettuare piu' di un attacco in mischia o a distanza durante il suo turno. Se la creatura tenta di lanciare un incantesimo con un tempo di lancio di 1 azione, deve tirare un d20. Con un risultato pari o superiore a 11, l'incantesimo non ha effetto prima del turno successivo della creatura e quest'ultima deve usare la propria azione di quel turno per completare l'incantesimo. Se non puo' farlo, l'incantesimo va sprecato. Una creatura influenzata da questo incantesimo effettua un altro tiro salvezza alla fine del suo turno. Se lo supera, l'effetto per lei termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia di melassa",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d20"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "lentezza",
    "language": "it"
  },
  {
    "name": "Levitazione",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un piccolo cappio di cuoio o un sottile cavo dorato piegato a forma di coppa con un lungo manico a un'estremità)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Una creatura o un oggetto a scelta dell'incantatore, situato entro gittata e che egli sia in grado di vedere, si solleva verticalmente fino a 6 metri e rimane sospeso lassu' per la durata dell'incantesimo. L'incantesimo puo' far levitare un bersaglio che pesa fino a 250 kg. Una creatura non consenziente che supera un tiro salvezza su Costituzione non subisce l'effetto dell'incantesimoIl bersaglio puo' muoversi soltanto spingendosi o aggrappandosi a un oggetto fisso o a una superficie entro portata (come per esempio una parete o un soffitto), che gli permette di muoversi come se stesse scalando quella superficie. L'incantatore puo' variare l'altitudine del bersaglio di un massimo di 6 metri in ogni direzione nel proprio turno. Se il bersaglio e' l'incantatore stesso, egli puo' muoversi su o giu' come parte del suo movimento. Altrimenti puo' usare la sua azione per muovere il bersaglio, che deve rimanere entro gittata. Quando l'incantesimo termina, il bersaglio scende dolcemente fluttuando fino a terra, se era ancora sospeso.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un piccolo cappio di cuoio o un sottile cavo dorato piegato a forma di coppa con un lungo manico a un'estremità",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "levitazione",
    "language": "it"
  },
  {
    "name": "Liberta' di Movimento",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (una cinghia di cuoio legata attorno al braccio o a un'appendice simile)"
    ],
    "duration": "1 ora",
    "description": "L'incantatore tocca una creatura consenziente. Per la durata dell'incantesimo, il movimento del bersaglio non e' influenzato dal terreno difficile, e gli incantesimi e gli altri effetti magici non possono ridurre la velocita' del bersaglio e non possono renderlo paralizzato o trattenuto. Il bersaglio puo' inoltre spendere 1,5 metri di movimento per sfuggire automaticamente alle costrizioni non magiche, come un paio di manette o una creatura che lo abbia afferrato. Infine, se il bersaglio si trova sott'acqua, non subisce penalita' al suo movimento e ai suoi attacchi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una cinghia di cuoio legata attorno al braccio o a un'appendice simile",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "liberta--di-movimento",
    "language": "it"
  },
  {
    "name": "Linguaggi",
    "level": 3,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " M (un piccolo modellino in argilla di una ziggurat)"
    ],
    "duration": "1 ora",
    "description": "Questo incantesimo garantisce ad una creatura toccata dall'incantatore l'abilita' di comprendere e parlare un linguaggio che sente. Inoltre, quando il bersaglio parla, ogni creatura che conosca almeno un linguaggio e che possa sentire il bersaglio e' in grado di comprendere cio' che esso pronuncia.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un piccolo modellino in argilla di una ziggurat",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "linguaggi",
    "language": "it"
  },
  {
    "name": "Localizza Animali o Vegetali",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V",
      " S",
      " M (un ciuffo di pelo strappato a un segugio)"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore descrive o nomina un tipo specifico di bestia o vegetale. Concentrandosi sulla voce della natura che echeggia attorno a lui, apprende la direzione e la distanza fino allacreatura o al vegetale di quel tipo piu' vicino entro 7,5 km, se ne e' presente almeno uno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di pelo strappato a un segugio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "localizza-animali-o-vegetali",
    "language": "it"
  },
  {
    "name": "Localizza Creatura",
    "level": 4,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un ciuffo di pelo strappato a un segugio)"
    ],
    "duration": "Concentrazione,, fino a 1 ora",
    "description": "L'incantatore descrive o nomina una creatura a lui familiare. Percepisce la direzione dell'ubicazione di quella creatura, purché essa si trovi entro 300 metri da lui. Se la creatura e' in movimento, l'incantatore sa in che direzione si muove. L'incantesimo puo' localizzare una creatura specifica nota all'incantatore, o la creatura piu' vicina di un tipo specifico (come per esempio un umano o un unicorno), purché l'incantatore abbia visto tale creatura da vicino (entro 9 metri) almeno una volta. Se la creatura descritta o nominata dall'incantatore ha una forma diversa, per esempio se si trova sotto l'effetto di un incantesimo Metamorfosi, questo incantesimo non localizza la creatura. Questo incantesimo non puo' localizzare una creatura se un corso d'acqua largo almeno 3 metri blocca il percorso diretto tra l'incantatore e la creatura.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Paladino",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di pelo strappato a un segugio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "localizza-creatura",
    "language": "it"
  },
  {
    "name": "Localizza Oggetto",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V",
      " S",
      " M (un rametto biforcuto)"
    ],
    "duration": "Durata: Concentrazione, fino a 10 minuti",
    "description": "L'incantatore descrive o nomina un oggetto a lui familiare. Percepisce la direzione dell'ubicazione di quell'oggetto purché esso si trovi entro 300 metri da lui. Se l'oggetto e' in movimento, l'incantatore sa in che direzione di muove. L'incantesimo puo' localizzare un oggetto specifico noto all'incantatore, purché l'incantatore abbia visto tale oggetto da vicino (entro 9 metri) almeno una volta. In alternativa, l'incantesimo puo' localizzare l'oggetto piu' vicino di un tipo particolare, come un certo tipo di veste, gioiello, mobile, strumento o arma. Questo incantesimo non puo' localizzare un oggetto se una cortina di piombo di qualsiasi spessore, anche una sottile lamina, blocca il percorso diretto tra l'incantatore e l'oggetto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Paladino",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un rametto biforcuto",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "localizza-oggetto",
    "language": "it"
  },
  {
    "name": "Loquacita'",
    "level": 8,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "1 ora",
    "description": "Finché l'incantesimo non termina, quando l'incantatore effettua una prova di Carisma, puo' sostituire il risultato del tiro con un 15. Inoltre, a prescindere da cio' che dice, le magie in grado di determinare se un bersaglio dice o meno la verita' indicheranno che cio' che l'incantatore sta dicendo e' la verita'.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "loquacita-",
    "language": "it"
  },
  {
    "name": "Luce",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " M (una lucciola o del muschio fosforescente)"
    ],
    "duration": "1 ora",
    "description": "L'incantatore tocca un oggetto non piu' grande di 3 metri in ogni dimensione. Finché l'incantesimo non termina, l'oggetto proietta luce intensa entro un raggio di 6 metri e luce fioca per altri 6 metri. La luce puo' essere del colore desiderato dall'incantatore. Coprire completamente l'oggetto con qualcosa di opaco blocca la luce. L'incantesimo termina se l'incantatore lo lancia di nuovo o lo interrompe con un'azione. Se l'incantatore bersaglia un oggetto impugnato o posseduto da una creatura ostile, quella creatura deve superare un tiro salvezza su Destrezza per evitare l'incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una lucciola o del muschio fosforescente",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "luce",
    "language": "it"
  },
  {
    "name": "Luce Diurna",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 ora",
    "description": "Una sfera di luce del raggio di 18 metri si diffonde da un punto situato entro gittata scelto dall'incantatore. La sfera e' pervasa da luce intensa e proietta luce fioca per altri 18 metri. Se il punto scelto dall'incantatore si trova su un oggetto che egli sta impugnando o che non e' indossato o trasportato da nessuno, la luce si diffonde dall'oggetto e si muove assieme a esso. Coprire completamente la fonte di luce con un oggetto opaco, come una scodella o un elmo, blocca la luce. Se una parte dell'area di questo incantesimo si sovrappone a un'area di oscurita' creata da un incantesimo di 3° livello o inferiore, l'incantesimo che ha creato l'oscurita' e' dissolto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Paladino",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "luce-diurna",
    "language": "it"
  },
  {
    "name": "Luci Danzanti",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di fosforo, di legno di faggio o una lucciola)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea fino a quattro luci delle dimensioni di una torcia, facendole apparire come lanterne, torce o globi luminosi che fluttuano nell'aria per la durata dell'incantesimo. L'incantatore puo' anche fondere le quattro luci in un'unica forma luminosa vagamente umanoide di taglia Media. Qualunque sia la forma scelta, ogni luce proietta luce fioca entro un raggio di 3 metri. Come azione bonus nel suo turno, l'incantatore puo' muovere le luci di un massimo di 18 metri fino a un nuovo punto entro gittata. Ogni luce deve trovarsi entro 6 metri da un'altra luce creata da questo incantesimo; una luce si spegne se esce dalla gittata dell'incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di fosforo, di legno di faggio o una lucciola",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "luci-danzanti",
    "language": "it"
  },
  {
    "name": "Luminescenza",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Ogni oggetto contenuto in un cubo con spigolo di 6 metri entro gittata viene evidenziato da un alone di luce blu, verde o viola (a scelta dell'incantatore). Ogni creatura situata entro l'area quando l'incantesimo viene lanciato, viene a sua volta evidenziata dall'alone di luce se fallisce un tiro salvezza su Destrezza. Per la durata dell'incantesimo, gli oggetti e le creature influenzate proiettano luce fioca entro un raggio di 3 metri. Ogni tiro per colpire contro una creatura o un oggetto influenzato dispone di vantaggio se l'attaccante e' in grado di vederlo, e la creatura o l'oggetto influenzato non trae beneficio dal fatto di essere invisibile.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "luminescenza",
    "language": "it"
  },
  {
    "name": "Mani Brucianti",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore (cono di 4,5 metri)",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore apre le mani, punta i pollici l'uno contro l'altro e dalla punta delle sue dita protese si propaga un sottile velo di fiamme. Ogni creatura entro un cono di 4,5 metri deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 3d6 danni da fuoco, mentre se lo supera, subisce soltanto la meta' di quei danni. Il fuoco incendia ogni oggetto infiammabile nell'area che non sia indossato o trasportato.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "mani-brucianti",
    "language": "it"
  },
  {
    "name": "Mano di Bigby",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un guscio d'uovo e un guanto di pelle di serpente)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea una mano di forza scintillante e trasparente di taglia Grande in uno spazio libero entro gittata e che egli sia in grado di vedere. La mano permane per la durata dell'incantesimo e si muove a comando dell'incantatore, imitando i movimenti della sua mano. La mano e' un oggetto con:Quando l'incantatore lancia l'incantesimo e come azione bonus nei suoi turni successivi, puo' muovere la mano fino a un massimo di 18 metri e poi causare uno degli effetti seguenti a essa associati:",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, i danni dell'opzione della mano stritolatrice aumentano di 2d6 e quelli di pugno serrato aumentano di 2d8 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un guscio d'uovo e un guanto di pelle di serpente",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "mano-di-bigby",
    "language": "it"
  },
  {
    "name": "Mano Magica",
    "level": 0,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 9 m",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: 1 minuto",
    "description": "Una mano spettrale fluttuante appare in un punto a scelta dell'incantatore situato entro gittata. La mano permane per la durata dell'incantesimo o finché l'incantatore non la congeda con un'azione. La mano svanisce se si trova a piu' di 9 m dall'incantatore o se quest'ultimo lancia di nuovo questo incantesimo.  L'incantatore puo' usare la sua azione per controllare la mano. Puo' usarla per maneggiare un oggetto, aprire una porta o un contenitore che non sia chiuso a chiave, estrarre o riporre un oggetto da un contenitore aperto o versare il contenuto di una fiala. Puo' muovere la mano di un massimo di 9 m ogni volta che la usa. La mano non puo' attaccare, attivare oggetti magici o trasportare piu' di 5 kg.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "mano-magica",
    "language": "it"
  },
  {
    "name": "Manto del Crociato",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Dall'incantatore si irradia un'aura del raggio di 9 metri che infonde coraggio nelle creature amiche. Finché l'incantesimo non termina, l'aura si muove assieme all'incantatore ed e' centrata su di lui. Ogni creatura non ostile situata entro l'aura (incluso l'incantatore) infligge 1d4 danni radiosi extra quando colpisce con un attacco con un'arma.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "manto-del-crociato",
    "language": "it"
  },
  {
    "name": "Marchio del Cacciatore",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore sceglie una creatura entro gittata e che egli sia in grado di vedere e la marchia misticamente come sua preda. Finche' l'incantesimo non termina, l'incantatore infligge 1d6 danni extra al bersaglio ogni volta che lo colpisce con un attacco con un'arma e dispone vantaggio ad ogni prova di Saggezza (Percezione) o Saggezza (Sopravvivenza) effettuata per trovarlo. Se il bersaglio scende a 0 punti ferita prima che questo incantesimo termini l'incantatore puo' usare un'azione bonus in un suo turno successivo per marchiare una nuova creatura.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o 4° livello, puo' mantenere una concentrazione sull'incantesimo fino ad un massimo di 8 ore. Quando usa uno slot di 5° livello o superiore, puo' mantenere una concentrazione sull'incantesimo fino ad un massimo di 24 ore.",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "marchio-del-cacciatore",
    "language": "it"
  },
  {
    "name": "Messaggio",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di un filo di rame)"
    ],
    "duration": "1 round",
    "description": "L'incantatore punta l'indice verso una creatura entro gittata e sussurra un messaggio, il bersaglio (e soltanto il bersaglio) sente il messaggio e puo' rispondere con un sussurro che soltanto l'incantatore puo' udire. L'incantatore puo' lanciare questo incantesimo attraverso gli oggetti solidi, se ha familiarita' con il bersaglio e sa che si trova oltre la barriera. Il silenzio magico, 30 cm di pietra, 2,5 cm di metallo comune, una sottile lamina di piombo o 90 cm di legno bloccano l'incantesimo. l'incantesimo non deve necessariamente seguire una linea retta e puo' svilupparsi liberamente oltre gli angoli e attraverso le aperture.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di un filo di rame",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "messaggio",
    "language": "it"
  },
  {
    "name": "Metamorfosi",
    "level": 4,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (il bozzolo di un bruco)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Questo incantesimo impartisce una nuova forma a una creatura entro gittata e che l'incantatore sia in grado di vedere. Una creatura non consenziente deve effettuare un tiro salvezza su Saggezza per evitare l'effetto. L'incantesimo non ha effetto su un mutaforma o su una creatura con 0 punti ferita. La trasformazione permane per la durata dell'incantesimo o finché il bersaglio non scenda a 0 punti ferita o non muoia. La nuova forma puo' essere quella di qualsiasi bestia il cui grado di sfida sia pari o inferiore a quello del bersaglio (o al livello del bersaglio, se esso non possiede un grado di sfida). Le statistiche di gioco del bersaglio, inclusi i punteggi di caratteristica mentali, vengono sostituite dalle statistiche della bestia scelta. Il bersaglio mantiene il suo allineamento e la sua personalita'. Il bersaglio assume i punti ferita della sua nuova forma. Quando torna alla sua forma normale, torna al numero di punti ferita che possedeva prima della trasformazione. Se riassume la sua forma normale per essere sceso a 0 punti ferita, ogni eventuale danno in ecceso si trasferisce alla sua forma normale. Fintanto che i danni in eccesso non portano la forma normale della creatura a 0 punti ferita, essa non cade priva di sensi. Le azioni della creatura sono limitate a quelle che la natura della sua nuova forma le consente di effettuare: non puo' parlare, lanciare incantesimi o effettuare qualsiasi altra azione che richieda l'uso delle mani o della parola. L'equipaggiamento del bersaglio si fonde nella nuova forma. La creatura non puo' attivare, usare o impugnare gli oggetti del suo equipaggiamento, né trarne benefici in altri modi.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "il bozzolo di un bruco",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "metamorfosi",
    "language": "it"
  },
  {
    "name": "Metamorfosi Pura",
    "level": 9,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una goccia di mercurio, una sfera di resina e uno sbuffo di fumo)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore sceglie una creatura o un oggetto non magico situato entro gittata e che egli sia in grado di vedere e trasforma la creatura in una creatura diversa o in un oggetto, oppure trasforma l'oggetto in una creatura (l'oggetto non deve essere indossato o trasportato da un'altra creatura). La trasformazione permane per la durata dell'incantesimo, o finché il bersaglio non scende a O punti ferita o non muore. Se l'incantatore si concentra su questo incantesimo per l'intera durata, la trasformazione permane finché non viene dissolta. Questo incantesimo non ha effetto su un mutaforma o su una creatura con O punti ferita. Una creatura non consenziente puo' effettuare un tiro salvezza su Saggezza. Se lo supera, non e' influenzata da questo incantesimo. Creatura in Creatura. Se l'incantatore trasforma una creatura in un altro tipo di creatura, la nuova forma puo' essere di qualsiasi tipo a scelta dell'incantatore, purché il suo grado di sfida sia pari o inferiore a quello del bersaglio (o del suo livello, se il bersaglio non possiede un grado di sfida). Le statistiche di gioco del bersaglio, inclusi i punteggi di caratteristica mentali, vengono sostituite dalle statistiche della nuova forma. Il bersaglio mantiene il suo allineamento e la sua personalita'. Il bersaglio assume i punti ferita della sua nuova forma. Quando torna alla sua forma normale, torna al numero di punti ferita che possedeva prima della trasformazione. Se riassume la sua forma normale per essere sceso a O punti ferita, ogni eventuale danno in eccesso si trasferisce alla sua forma normale. Fintanto che i danni in eccesso non portano la forma normale della creatura a O punti ferita, essa non cade priva di sensi. Le azioni della creatura sono limitate a quelle che la natura della sua nuova forma le consente di effettuare: non puo' parlare, lanciare incantesimi o effettuare qualsiasi altra azione che richieda l'uso delle mani o della parola, a meno che la sua nuova forma non sia in grado di compiere tali azioni. L'equipaggiamento del bersaglio si fonde nella nuova forma. La creatura non puo' attivare, usare o impugnare gli oggetti del suo equipaggiamento, né trarne benefici in altri modi. Oggetto In Creatura. L'incantatore puo' trasformare un oggetto in una qualsiasi creatura, fintanto che la taglia della creatura non e' superiore alla taglia dell'oggetto e il grado di sfida della creatura e' pari o inferiore a 9. La creatura e' amichevole nei confronti dell'incantatore e dei suoi compagni e agisce a ogni turno dell'incantatore, che decide quale azione effettua e come si muove. È il DM a possedere le sue statistiche e a risolvere le sue azioni e il suo movimento. Se l'incantesimo diventa permanente, l'incantatore non controlla piu' la creatura, che potrebbe rimanere amichevole o meno nei suoi confronti, in base a come e' stata trattata. Creatura In Oggetto. Se l'incantatore trasforma una creatura in oggetto, tutto cio' che la creatura trasporta e indossa si fonde in quella forma. Le statistiche della creatura diventano quelle dell'oggetto e la creatura non ricordera' nulla del tempo trascorso in questa forma quando l'incantesimo sara' terminato ed essa tornera' alla sua forma normale",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia di mercurio, una sfera di resina e uno sbuffo di fumo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "metamorfosi-pura",
    "language": "it"
  },
  {
    "name": "Miraggio Arcano",
    "level": 7,
    "school": "Illusione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "a vista",
    "components": [
      "V",
      "S"
    ],
    "duration": "10 giorni",
    "description": "·Tempo di lancio: 10 minuti·Gittata: a vista·Componenti: V,S·Durata: 10 giorniFai si' che un pezzo di terreno a gittata, in un’area quadrata fino a 1,5 chilometri, appaia, risuoni e odori come qualche altro tipo di terreno. La conformazione generale del terreno rimane tuttavia la stessa. Campi aperti o una strada possono essere trasformati in un acquitrino, colline, un crepaccio o qualche altro tipo di terreno difficile o invalicabile. Un laghetto puo' essere trasformato in una radura erbosa, un precipizio in una lieve pendenza, un burrone cosparso di rocce in una strada ampia e liscia. Allo stesso modo, puoi modificare l’aspetto delle strutture, o aggiungerne dove non ve ne sono. L’incantesimo non camuffa, occulta né aggiunge creature.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "miraggio-arcano",
    "language": "it"
  },
  {
    "name": "Modificare Memoria",
    "level": 5,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tenta di alterare i ricordi di un'altra creatura che egli sia in grado di vedere, che dovra' effettuare un tiro salvezza su Saggezza. Se l'incantatore sta combattendo contro la creatura, essa dispone di vantaggio al tiro salvezza. Se il bersaglio fallisce il tiro salvezza, diventa affascinato dall'incantatore per la durata dell'incantesimo. Il bersaglio affascinato e' incapacitato e inconsapevole di cio' che accade attorno a lui, ma puo' ancora udire l'incantatore. Se subisce danni o se e' bersagliato da un altro incantesimo, questo incantesimo termina e nessun ricordo del bersaglio viene modificato. L'incantatore puo' eliminare permanentemente tutti i ricordi dell'evento, consentire al bersaglio di ricordare l'evento con perfetta lucidita' e in ogni dettaglio, alterare il ricordo di alcuni dettagli dell'evento o creare il ricordo di un evento diverso. L'incantatore deve parlare con il bersaglio per descrivere in che modo i suoi ricordi vengono alterati e il bersaglio deve essere in grado di capire il linguaggio usato dall'incantatore affinché i ricordi modificati si radichino nella sua mente. La mente del bersaglio riempie le eventuali lacune presenti nella descrizione dell'incantatore. Se l'incantesimo termina prima che l'incantatore abbia finito di descrivere i ricordi modificati, i ricordi della creatura non subiscono alcuna alterazione. Altrimenti, i ricordi modificati si radicano nella mente del bersaglio quando l'incantesimo termina. Un ricordo modificato non influenza necessariamente il comportamento di una creatura, specialmente se il ricordo contraddice le inclinazioni naturali, l'allineamento o le convinzioni della creatura. Un ricordo modificato illogicamente, come per esempio il ricordo di quanto la creatura ami immergersi nell'acido, viene ignorato e probabilmente bollato come un brutto sogno. Il DM potrebbe ritenere che un ricordo modificato sia troppo insensato per influenzare la creatura in modo significativo. Un incantesimo Rimuovi Maledizione o Ristorare Superiore lanciato sul bersaglio ripristina i veri ricordi della creatura.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, puo' alterare i ricordi del bersaglio relativi a un evento risalente fino a 7 giorni fa (6° livello), 30 giorni fa (7° livello), 1 anno fa (8° livello) o a un qualsiasi momento del suo passato (9° livello).",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "acido"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "modificare-memoria",
    "language": "it"
  },
  {
    "name": "Morte Apparente",
    "level": 3,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (un pizzico di terriccio prelevato da un cimitero)"
    ],
    "duration": "1 ora",
    "description": "L'incantatore tocca una creatura consenziente, ponendola in uno stato catatonico indistinguibile dalla morte. Per la durata dell'incantesimo, o finché l'incantatore non usa un'azione per toccare il bersaglio e terminarel'incantesimo, il bersaglio appare morto a ogni ispezione esterna e agli incantesimi usati per determinare il suostatus. Il bersaglio e' accecato e incapacitato e la sua velocita' scende a O. Il bersaglio dispone di resistenza a tuttii danni tranne i danni psichici. Se il bersaglio e' ammalato o avvelenato quando l'incantatore lancia l'incantesimo, o sediventa ammalalo o avvelenato finché si trova sotto l'effetto dell'incantesimo, la malattia e il veleno non hanno effettofinché l'incantesimo non termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di terriccio prelevato da un cimitero",
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "morte-apparente",
    "language": "it"
  },
  {
    "name": "Movimenti del Ragno",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (una goccia di bitume e un ragno)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Finché l'incantesimo non termina, una creatura consenziente toccata dall'incantatore ottiene la capacita' di muoversi verticalmente e orizzontalmente sulle pareti e a testa in giu' sui soffitti, mantenendo le mani libere. Il bersaglio ottiene inoltre una velocita' di scalare pari alla sua velocita' base sul terreno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una goccia di bitume e un ragno",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "movimenti-del-ragno",
    "language": "it"
  },
  {
    "name": "Muovere il Terreno",
    "level": 6,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (una lama di ferro e un sacchetto contenente un misto di terre: argilla, terriccio e sabbia)"
    ],
    "duration": "Concentrazione, fino a 2 ore",
    "description": "L'incantatore sceglie un'area di terreno grande al massimo 12 metri per lato e situata entro gittata. Puo' modellare l'argilla, il terriccio o la sabbia entro l'area nella maniera che preferisce per la durata dell'incantesimo. L'incantatore puo' aumentare o ridurre l'elevazione del terreno, creare o riempire una fossa, erigere o spianare una parete, innalzare una colonna. L'estensione di tali cambiamenti non puo' superare la meta' della dimensione piu' grande dell'area. Quindi, se influenza un quadrato con lato di 12 metri, puo' creare una colonna alta fino a 6 metri, aumentare o ridurre l'elevazione del terreno di un massimo di 6 metri, scavare una fossa della profondita' massima di 6 metri e cosi' via. Servono 10 minuti prima che queste alterazioni siano completate. Alla fine di ogni 10 minuti trascorsi a concentrarsi sull'incantesimo, l'incantatore puo' scegliere una nuova area di terreno da influenzare. Dal momento che la trasformazione del terreno si completa gradualmente, le creature nell'area solitamente non restano intrappolate o ferite dal movimento del terreno. Questo incantesimo non puo' manipolare la pietra naturale o le costruzioni in pietra. Le rocce e le strutture si sposteranno per adattarsi al nuovo terreno. Se l'incantatore modella il terreno in un modo che renderebbe la struttura instabile, quella struttura potrebbe crollare. Analogamente questo incantesimo non influenza la crescita vegetale. La terra spostata sposta con sé ogni vegetale presente.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una lama di ferro e un sacchetto contenente un misto di terre: argilla, terriccio e sabbia",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "muovere-il-terreno",
    "language": "it"
  },
  {
    "name": "Muro di Forza",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di polvere ricavato dalla distruzione di una gemma trasparente)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Un muro invisibile di forza si materializza in un punto a scelta dell'incantatore situato entro gittata. Il muro appare nell'orientamento che l'incantatore desidera, come barriera orizzontale, verticale o inclinata. Puo' fluttuare nell'aria o poggiare su una superficie solida. L'incantatore puo' modellarlo in una semisfera o in una sfera del raggio massimo di 3 metri, o come una superficie piatta composta di dieci pannelli quadrati con lato di 3 metri l'uno. Ogni pannello deve essere contiguo a un altro pannello. In qualsiasi forma, il muro ha uno spessore di 0,5 cm e permane per la durata dell'incantesimo. Se il muro passa attraverso lo spazio di una creatura quando appare, la creatura viene spinta da un lato del muro a scelta dell'incantatore. Nulla puo' attraversare fisicamente il muro, che e' immune a tutti i danni e non puo' essere dissolto tramite Dissolvi Magie. Un incantesimo Disintegrazione, tuttavia, distrugge il muro istantaneamente. Il muro si estende anche sul Piano Etereo, bloccando i viaggi eterei che lo attraversano.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di polvere ricavato dalla distruzione di una gemma trasparente",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "muro-di-forza",
    "language": "it"
  },
  {
    "name": "Muro di Fuoco",
    "level": 4,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di fosforo)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea un muro di fuoco su una superficie solida situata entro gittata. Il muro puo' essere lungo fino a 18 metri, alto 6 metri e spesso 30 cm, oppure puo' essere un muro circolare del diametro massimo di 6 metri, alto 6 metri e spesso 30 cm. Il muro e' opaco e permane per la durata dell'incantesimo. Quando il muro appare, ogni creatura entro la sua area deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 5d8 danni da fuoco, mentre se lo supera, subisce soltanto la meta' di quei danni. Un lato del muro, scelto dall'incantatore al momento del lancio di questo incantesimo, infligge 5d8 danni da fuoco a ogni creatura che termina il suo turno entro 3 metri da quel lato o all'interno del muro. Una creatura subisce gli stessi danni quando entra nel muro per la prima volta in un turno o vi termina il proprio turno. L'altro lato del muro non infligge danni.",
    "atHigherLevels": "Quando L'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 4°.",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di fosforo",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "muro-di-fuoco",
    "language": "it"
  },
  {
    "name": "Muro di Ghiaccio",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di quarzo)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore crea un muro di ghiaccio su una superficie solida situata entro gittata formando una semisfera o una sfera del raggio massimo di 3 metri o una superficie piatta composta da dieci pannelli quadrati con lato di 3 metri l'uno. Ogni pannello deve essere contiguo a un altro pannello. In qualsiasi forma, il muro e' spesso 30 cm e permane per la durata dell'incantesimo. Se il muro passa attraverso lo spazio di una creatura quando appare, la creatura entro la sua area viene spinta da un lato del muro e deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 10d6 danni da freddo, mentre se lo supera, subisce soltanto la meta' di quei danni. Il muro e' un oggetto che puo' essere danneggiato e quindi infranto, possiede:Nello spazio occupato da una sezione distrutta resta solo una cortina d'aria gelida. Se una creatura attraversa la cortina d'aria gelida per la prima volta in un turno, deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 5d6 danni da freddo, mentre se lo supera, subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, i danni che il muro infligge quando compare aumentano di 2d6 e i danni subiti da chi passa attraverso la cortina d'aria gelida aumentano di 1d6 per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di quarzo",
    "damageTypes": [
      "freddo"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "muro-di-ghiaccio",
    "language": "it"
  },
  {
    "name": "Muro di Pietra",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un piccolo pezzo di granito)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Un muro non magico di solida pietra si materializza partendo da un punto a scelta dell'incantatore situato entro gittata. Il muro e' spesso 15 cm e composto da dieci pannelli quadrati con lato di 3 metri l'uno. Ogni pannello deve essere contiguo ad almeno un altro pannello. In alternativa, l'incantatore puo' creare dei pannelli di 3 metri per 6 metri dello spessore di soli 7,5 cm. Se il muro attraversa lo spazio di una creatura nel momento in cui compare, quella creatura viene spinta da un lato del muro (a scelta dell'incantatore). Se una creatura sarebbe circondata su tutti i lati dal muro (o dal muro e da un'altra superficie solida), puo' effettuare un tiro salvezza su Destrezza. Se lo supera, puo' usare la sua reazione per muoversi fino alla sua velocita' nel tentativo di non rimanere intrappolata dal muro. Il muro puo' avere la forma desiderata dall'incantatore, ma non puo' occupare lo stesso spazio di una creatura o di un oggetto. Non e' necessario che il muro sia verticale o poggi su fondamenta solide. Deve pero' fondersi ed essere solidamente sorretto da una massa di pietra gia' esistente. Quindi e' possibile usare questo incantesimo per creare una rampa o un ponte che attraversi un baratroSe l'incantatore crea un'arcata di lunghezza superiore a 6 metri, deve dimezzare le dimensioni di ogni pannello per creare dei sostegni. Puo' rozzamente modellare il muro per creare feritoie, spalti e cosi' via. Il muro e' un oggetto fatto di pietra che puo' essere danneggiato e quindi sfondato. Ogni pannello ha CA 15 e 30 punti ferita per ogni 2,5 cm di spessore. Quasndo un pannello scende a 0 punti ferita e' distrutto e potrebbe provocare anche il crollo di altri pannelli, a discrezione del DM. Se l'incantatore mantiene la concentrazione su questo incantesimo epr l'intera durata, il muro diventa permanente e non puo' essere dissolto. Altrimenti, il muro scompare quando l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un piccolo pezzo di granito",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "muro-di-pietra",
    "language": "it"
  },
  {
    "name": "Muro di Spine",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (una manciata di spine)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore crea un fitto muro di rovi, resistente, flessibile ed erto di spine affilate. Il muro appare su una superficie solida entro gittata e permane per la durata dell'incantesimo. Il muro puo' essere lungo fino a 18 metri, alto 3 metri e spesso 1,5 metri, oppure puo' essere un muro circolare del diametro di 6 metri, alto fino a 6 metri e spesso 1,5 metri. Il muro blocca la linea di vista. Quando il muro appare, ogni creatura entro la sua area deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 7d8 danni perforanti, mentre se lo supera, subisce soltanto la meta' di quei danni. Una creatura puo' muoversi attraverso il muro, anche se lentamente e dolorosamente. Per ogni 30 cm di muro che attraversa, la creatura deve spendere 120 cm di movimento. Inoltre, la prima volta che una creatura entra nel muro in un turno o vi termina il proprio turno, deve effetuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 7d8 danni taglienti, mentre se lo supera, subisce solo al meta' di quei danni.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, entrambi i tipi di danno aumentano di 1d8 per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una manciata di spine",
    "damageTypes": [
      "perforanti",
      "taglienti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "muro-di-spine",
    "language": "it"
  },
  {
    "name": "Muro di Vento",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (un minuscolo ventaglio e una piuma di origini esotiche)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Un muro di vento forte si solleva dal terreno in un punto a scelta dell'incantatore situato entro gittata. Il muro puo' essere lungo fino a 15 metri, alto 4,5 metri e spesso 30 cm. L'incantatore puo' modellare il muro nel modo che preferisce, purché formi un percorso continuo lungo il terreno. Il muro permane per la durata dell'incantesimo. Quando il muro appare, ogni creatura entro la sua area deve effettuare un tiro salvezza su Forza. Se lo fallisce, subisce 3d8 danni contundenti, mentre se lo supera, subisce soltanto la meta' di quei danni. Il vento forte tiene lontana la nebbia, il fumo  e gli altri gas. Le creature o gli oggetti volanti di taglia Piccola o inferiore non possono passare attraverso il muro. I materiali leggeri e non fissati in qualche modo volano verso l'alto una volta portati all'interno del muro. Le frecce, i quadrelli e gli altri proiettili ordinari lanciati ai bersagli dietro il muro vengono deviati verso l'alto e mancano automaticamente (i macigni scagliati dai giganti o dalle macchine d'assedio e altri proiettili simili non sono influenzati dal muro). Le creature in forma gassosa non possono attraversare il muro.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un minuscolo ventaglio e una piuma di origini esotiche",
    "damageTypes": [
      "contundenti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "muro-di-vento",
    "language": "it"
  },
  {
    "name": "Muro Prismatico",
    "level": 9,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "10 minuti",
    "description": "Un piano di luce dai numerosi colori scintillanti forma un muro opaco verticale (che puo' misurare fino a 27 metri di lunghezza, 9 metri di altezza e 2,5 cm di spessore), centrato su un punto entro gittata e che l'incantatore sia in grado di vedere. In alternativa, l'incantatore puo' modellare il muro in una sfera del diametro massimo di 9 metri centrata su un punto a sua scelta entro gittata. Il muro rimane al suo posto per la durata dell'incantesimo. Se l'incantatore posiziona il muro in modo che passi attraverso uno spazio occupato da una creatura l'incantesimo fallisce e sia l'azione dell'incantatore che il suo slot incantesimo vanno sprecati. Il muro emana luce intensa entro un raggio di 30 metri e luce fioca per altri 30 metri. L'incantatore e le creature da lui designate al momento del lancio dell'incantesimo possono passare attraverso il muro o rimanervi accanto senza subire danni. Se un'altra creatura in grado di vedere il muro giunge entro 6 metri da esso o vi comincia il proprio turno, deve superare un tiro salvezza su Costituzione, altrimenti e' accecata per 1 minuto. Il muro e' composto da sette strati, ognuno di un colore diverso. Quando una creatura tenta di protendersi oltre il muro o di attraversarlo, lo fa di uno strato alla volta, fino ad attraversare tutti gli strati del muro. Quando si protende o attraversa ogni strato, deve effettuare un tiro salvezza su Destrezza, altrimenti sara' influenzata dalle proprieta' di quello strato, come descritto di seguito. Il muro puo' essere distrutto, anche in questo caso uno strato alla volta, procedendo in ordine dal rosso al viola, tramite un modo specifico per ogni strato. Quando uno strato e' distrutto, resta distrutto per la durata dell'incantesimo. Un incantesimo Campo Anti-Magia non ha alcun effetto sul muro e Dissolvi Magie puo' influenzare solo lo strato viola.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione,Destrezza"
    ],
    "urlFriendlyName": "muro-prismatico",
    "language": "it"
  },
  {
    "name": "Nube di Nebbia",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore crea una sfera di nebbia del raggio di 6 metri centrata su un punto entro gittata. La sfera si diffonde oltre gli angoli e la sua area risulta pesantemente oscurata. La nebbia permane per la durata dell'incantesimo o finché un vento moderato o superiore (almeno 15 km all'ora) non la disperde.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, il raggio della sfera di nebbia aumenta di 6 metri per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Druido",
      "Mago",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "nube-di-nebbia",
    "language": "it"
  },
  {
    "name": "Nube di Pugnali",
    "level": 2,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (una scheggia di vetro)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore riempie l'aria di pugnali turbinanti in un cubo con spigolo di 1,5 metri, centrato su un punto a sua scelta entro gittata. Una creatura subisce 4d4 danni taglienti quando entra nell'area dell'incantesimo per la prima volta in un turno o inizia il proprio turno al suo interno. Ai Livelli Superiori: Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni aumentano di 2d4 per ogni slot di livello superiore al 2°.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una scheggia di vetro",
    "damageTypes": [
      "taglienti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "nube-di-pugnali",
    "language": "it"
  },
  {
    "name": "Nube Incendiaria",
    "level": 8,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "45 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Una nube turbinante di fumo mista a un nugolo di tizzoni incandescenti appare in una sfera del raggio di 6 metri centrata su un punto entro gittata. La nube si diffonde oltre gli angoli ed e' pesantemente oscurata. Permane per la durata dell'incantesimo o finché un vento moderato o superiore (almeno 15 km all'ora) non la disperde. Quando la nube appare, ogni creatura al suo interno deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 10d8 danni da fuoco, mentre se lo supera, subisce soltanto la meta' di quei danni. Una creatura deve effettuare questo tiro salvezza anche quando entra nell'area dell'incantesimo per la prima volta in un turno o vi termina il proprio turno. La nube si muove di 3 metri allontanandosi direttamente dall'incantatore, in una direzione a scelta di quest'ultimo all'inizio di ogni suo turno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "nube-incendiaria",
    "language": "it"
  },
  {
    "name": "Nube Maleodorante",
    "level": 3,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (un uovo marcio o alcune foglie di cavolfiore)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea una sfera del raggio di 6 metri composta di gas nauseante giallastro, centrata su un punto situato entro gittata. La nube si diffonde oltre gli angoli e la sua area e' pesantemente oscurata. La nube permante nell'area per la durata dell'incantesimo. Ogni creatura situata completamente all'interno della nube all'inizio del suo turno deve effettuare un tiro salvezza su Costituzione contro veleno. Se lo fallisce, spende la sua azione di quel turno a vomitare in preda al dolore. Le creature che non hanno bisogno di respirare o sono immuni al veleno superano automaticamente questo tiro salvezza. Un vento moderato (almeno 15 km all'ora) disperde la nube dopo 4 round. Un vento forte (almeno 30 km all'ora) la disperde dopo un round.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un uovo marcio o alcune foglie di cavolfiore",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "nube-maleodorante",
    "language": "it"
  },
  {
    "name": "Nube Mortale",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore crea una sfera di velenosa nebbia giallo-verdastra del raggio di 6 metri, centrata su un punto a sua scelta entro gittata. La nebbia si diffonde oltre gli angoli e permane per la durata dell'incantesimo o finché un vento forte non la disperde, terminando l'incantesimo. La sua aera e' pesantemente oscurata. Quando una creatura entra nell'area dell'incantesimo per la prima volta in un turno o inizia il proprio turno al suo interno, deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 5d8 danni da veleno, mentre se lo supera, subisce soltanto la meta' di quei danni. Le creature sono influenzate dall'incantesimo anche se trattengono il respiro o non hanno bisogno di respirare. La nebbia si muove allontanandosi di 3 metri dall'incantatore all'inizio di ogni turno di quest'ultimo, strisciando lungo il terreno. I vapori sono piu' pesanti dell'aria e rimangono al livello del terreno; possono persino scendere nelle aperture.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "nube-mortale",
    "language": "it"
  },
  {
    "name": "Occhio Arcano",
    "level": 4,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un ciuffo di pelo di pipistrello)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore crea un occhio magico invisibile entro gittata che fluttua nell'aria per la durata dell'incantesimo. L'incantatore riceve mentalmente una serie di informazioni visive dall'occhio, che e' dotato di visione normale e scurovisione fino a 9 metri. L'occhio puo' guardare in ogni direzione. Con un'azione, l'incantatore puo' muovere l'occhio di 9 metri in qualsiasi direzione. Non c'e' limite alla distanza di cui l'occhio puo' allontanarsi dall'incantatore, ma esso non puo' entrare su un altro piano di esistenza. Una barriera solida blocca il movimento dell'occhio, che pero' puo' passare attraverso un'apertura del diametro minimo di 2,5 cm.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un ciuffo di pelo di pipistrello",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "occhio-arcano",
    "language": "it"
  },
  {
    "name": "Onda Distruttiva",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore (raggio di 9 metri)",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore colpisce il terreno, generando un'ondata di energia divina che si diffonde da lui. Ogni creatura scelta dall'incantatore e situata entro 9 metri deve superare un tiro salvezza su Costituzione, altrimenti subisce 5d6 danni radiosi o necrotici (a scelta dell'incantatore) e cade a terra prona. Se una creatura supera il tiro salvezza, subisce solo meta' di quei danni e non cade a terra prona.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi",
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "onda-distruttiva",
    "language": "it"
  },
  {
    "name": "Onda Tonante",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore (cubo con spigolo di 4,5 metri)",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un'ondata di energia tonante si propaga dall'incantatore. Ogni creatura entro un cubo con spigolo di 4,5 metri originato dall'incantatore deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 2d8 danni da tuono e viene spinta di 3 metri piu' lontana dall'incantatore, mentre se lo supera, subisce soltanto la meta' di quei danni e non viene spinta. Inoltre, gli oggetti non fissati e completamente situati all'interno dell'area di effetto vengono automaticamente spinti 3 metri piu' lontani dall'incantatore a seguito dell'effetto dell'incantesimo. L'incantesimo emette un rombo tonante udibile fino a 90 metri di distanza.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello osuperiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "onda-tonante",
    "language": "it"
  },
  {
    "name": "Oscurita'",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " M (pelo di pipistrello e una goccia di pece o un pezzo di carbone)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore sceglie un punto situato entro gittata da cui si diffonde un'oscurita' magica che riempie una sfera del raggio di 4,5 metri per la durata dell'incantesimo. L'oscurita' si diffonde oltre gli angoli. Una creatura dotata di scurovisione non e' in grado di vedere attraverso questa oscurita' e le luci non magiche non possono illuminarla. Se il punto scelto dall'incantatore si trova su un oggetto che egli sta impugnando o che non e' indossato o trasportato da nessuno, l'oscurita' si diffonde dall'oggetto e si muove assieme a esso. Coprire completamente la fonte dell'oscurita' con un oggetto opaco, come una scodella o un elmo, blocca l'oscurita'. Se una parte dell'area di questo incantesimo si sovrappone a un'area di luce creata da un incantesimo di 2° livello o inferiore, l'incantesimo che ha creato la luce e' dissolto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "pelo di pipistrello e una goccia di pece o un pezzo di carbone",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "oscurita-",
    "language": "it"
  },
  {
    "name": "Palla di Fuoco",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (una piccola sfera di sterco di pipistrello e zolfo)"
    ],
    "duration": "Istantanea",
    "description": "Una scia di luce parte dall'indice dell'incantatore e sfreccia fino a un punto a sua scelta entro gittata, dove detona con un profondo boato generando un'esplosione di fiamme. Ogni creatura situata entro una sfera del raggio di 6 metri centrata su quel punto deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 8d6 danni da fuoco, mentre se lo supera, subisce soltanto la meta' di quei danni. Il fuoco si diffonde oltre gli angoli e incendia ogni oggetto infiammabile nell'area che non sia indossato o trasportato.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 3°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola sfera di sterco di pipistrello e zolfo",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "palla-di-fuoco",
    "language": "it"
  },
  {
    "name": "Palla di Fuoco Ritardata",
    "level": 7,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (una piccola sfera di sterco di pipistrello e zolfo)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Un raggio di luce gialla si sprigiona dal dito indice dell'incantatore per condensarsi in un punto a sua scelta situato entro gittata, fino a formare una perla scintillante per la durata dell'incantesimo. Quando l'incantesimo termina perché la concentrazione dell'incantatore e' stata interrotta o perché l'incantatore ha deciso di terminarlo, la perla deflagra con un cupo boato in un'esplosione di fiamme che si diffonde oltre gli angoli. Ogni creatura entro un raggio di 6 metri centrato su quel punto deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce danni da fuoco pari al totale dei danni accumulati, mentre se lo supera, subisce soltanto la meta' di quei danni. I danni base dell'incantesimo sono pari a 12d6. Se alla fine del turno dell'incantatore la perla non e' ancora detonata, i danni aumentano di 1d6. Se la perla scintillante viene toccata prima che l'intervallo termini, la creatura che la tocca deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, l'incantesimo termina immediatamente e la perla deflagra in un'esplosione di fiamme, mentre se lo supera, puo' scagliare la perla fino a una distanza di 12 metri. Quando la perla colpisce una creatura o un oggetto solido, l'incantesimo termina e la perla esplode. Il fuoco danneggia gli oggetti nell'area e incendia gli oggetti infiammabili che non sono indossati o trasportati.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 8° livello o superiore, i danni base aumentano di 1d6 per ogni slot di livello superiore al 7°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola sfera di sterco di pipistrello e zolfo",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "palla-di-fuoco-ritardata",
    "language": "it"
  },
  {
    "name": "Parlare con gli Animali",
    "level": 1,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "10 minuti",
    "description": "L'incantatore ottiene la capacita' di comprendere le bestie e comunicare verbalmente con loro per la durata dell'incantesimo. Le conoscenze e la consapevolezza di molte bestie sono limitate alla loro intelligenza, ma l'incantatore puo' apprendere da loro quanto meno alcune informazioni sui luoghi o sui mostri nelle vicinanze, o su cio' che esse sono in grado di percepire o hanno percepito nell'ultimo giorno. L'incantatore potrebbe anche persuadere una bestia a fargli un piccolo favore, a discrezione del DM.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parlare-con-gli-animali",
    "language": "it"
  },
  {
    "name": "Parlare con i Morti",
    "level": 3,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S",
      " M (incenso bruciato)"
    ],
    "duration": "10 minuti",
    "description": "L'incantatore conferisce una pavenza di vita e di intelligenza a un cadavere a sua scelta situato entro gittata, permettendogli di rispondere alle domande che egli gli pone. Il cadavere deve avere ancora una bocca e non deve essere un non morto. L'incantesimo fallisce se il cadavere e' gia' stato il bersaglio di questo incantesimo negli ultimi 10 giorni. Finché l'incantesimo non termina, l'incantatore puo' porre al cadavere un massimo di cinque domande. Il cadavere sa solo quello che sapeva in vita, inclusi i linguaggi che conosceva. Le risposte sono generalmente brevi, criptiche o ripetitive e il cadavere non e' obbligato in alcun modo a fornire risposte sincere se l'incantatore gli e' ostile o se lo riconosce come nemico. L'incantesimo non riporta l'anima della creatura nel suo corpo, ma soltanto lo spirito animante. Quindi il cadavere non puo' apprendere nuove informazioni, non conosce nulla di cio' che e' accaduto dopo la sua morte e non puo' speculare sugli eventi futuri.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "incenso bruciato",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parlare-con-i-morti",
    "language": "it"
  },
  {
    "name": "Parlare con i Vegetali",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Tempo di Lancio: 1 azione",
    "components": [
      "Gittata: Personale (raggio di 9 metri)"
    ],
    "duration": "Componenti: V, S",
    "description": "Infondi i vegetali entro 9 metri da te di capacita' senziente e di limitata mobilita', dandole la capacita' di comunicare con te ed eseguire dei semplici comandi. Puoi interrogare i vegetali in merito a eventi avvenuti nell’ultimo giorno nell’area dell’incantesimo, ottenendo informazioni sulle creature di passaggio, il clima e altro. Puoi anche trasformare il terreno difficile prodotto dalla crescita dei vegetali (come cespugli e fitto sottobosco) in terreno ordinario per la durata dell’incantesimo. Oppure puoi trasformare del terreno normale in cui siano presenti dei vegetali in terreno difficile, che rimane per la durata dell’incantesimo facendo si', per esempio, che rampicanti e rami rallentino gli inseguitori. A discrezione del GM i vegetali potrebbero svolgere anche altri compiti per tuo conto. L’incantesimo non permette ai vegetali di sradicarsi e muoversi, ma possono muovere liberamente rami, steli e gambi. Se una creatura vegetale si trova nell’area, puoi comunicare con essa come se parlaste lo stesso linguaggio, ma non ottieni alcuna capacita' magica per influenzarla. Questo incantesimo puo' far si' che i vegetali creati dall’incantesimo intralciare rilascino una creatura intralciata.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parlare-con-i-vegetali",
    "language": "it"
  },
  {
    "name": "Parola del Potere Guarire",
    "level": 9,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un'onda di energia curativa investe la creatura toccata dall'incantatore. Il bersaglio recupera tutti i suoi punti ferita. Se la creatura e' affascinata, paralizzata, spaventata o stordita, quella condizione termina. Se la creatura e' prona, puo' usare la sua reazione per rialzarsi. Questo incantesimo non ha effetto sui costrutti o sui non morti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parola-del-potere-guarire",
    "language": "it"
  },
  {
    "name": "Parola del Potere Stordire",
    "level": 8,
    "school": "Ammaliamento",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore pronuncia una parola del potere che puo' sopraffare la mente di una creatura entro gittata e che egli sia in grado di vedere, lasciandola in uno stato confusionale. Se il bersaglio possiede 150 punti ferita o meno, e' stordito. Altrimenti, l'incantesimo non ha effetto. Il bersaglio stordito deve effettuare un tiro salvezza su Costituzione alla fine di ogni suo turno. Se lo supera, l'effetto di stordimento termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "parola-del-potere-stordire",
    "language": "it"
  },
  {
    "name": "Parola del Potere Uccidere",
    "level": 9,
    "school": "Ammaliamento",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore pronuncia una parola del potere che puo' uccidere istantaneamente una creatura entro gittata e cheegli sia in grado di vedere. Se la creatura scelta possiede 100 punti ferita o meno, muore. Altrimenti, l'incantesimonon ha effetto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parola-del-potere-uccidere",
    "language": "it"
  },
  {
    "name": "Parola del Ritiro",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "1,5 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore e un massimo di cinque creature consenzienti entro 1,5 metri da lui si teletrasportano istantaneamente in un santuario designato in precedenza. L'incantatore e le creature che si teletrasportano con lui compaiono nello spazio libero piu' vicino al punto designato quando egli ha preparato il suo santuario (vedi sotto). Se lancia questo incantesimo prima di avere preparato un santuario, l'incantesimo non ha effetto. L'incantatore deve designare un santuario lanciando questo incantesimo all'interno di un luogo dedicato alla sua divinita' o fortemente legato a essa, come per esempio un tempio. Se tenta di lanciare l'incantesimo in questo modo in un'area che non e' dedicata alla sua divinita', l'incantesimo non ha effetto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parola-del-ritiro",
    "language": "it"
  },
  {
    "name": "Parola Divina",
    "level": 7,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore pronuncia una parola divina, pervasa dal potere che plasmo' il mondo all'alba della creazione, scegliendo un qualsiasi numero di creature entro gittata e che egli sia in grado di vedere. Ogni creatura che e' in grado di sentire l'incantatore deve effettuare un tiro salvezza su Carisma. Se lo fallisce, subisce un effetto basato sui suoi punti ferita attuali:A prescindere dai suoi punti ferita attuali, un celestiale, un elementale, un folletto o un immondo che fallisce il suo tiro salvezza viene respinto sul suo piano di origine (se non si trova gia' laggiu') e non puo' fare ritorno al piano attuale dell'incantatore per 24 ore in alcun modo ad eccezione di un incantesimo Desiderio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "parola-divina",
    "language": "it"
  },
  {
    "name": "Parola Guaritrice",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "Una creatura scelta dall'incantatore entro gittata e che egli sia in grado di vedere recupera un ammontare di punti ferita pari a 1d4 + il modificatore di caratteristica da incantatore. Questo incantesimo non ha effetto sui costrutti o sui non morti.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, l'ammontare di guarigione aumenta di 1d4 punti ferita per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parola-guaritrice",
    "language": "it"
  },
  {
    "name": "Parola Guaritrice di Massa",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "Finche' pronunci parole di cura, fino a sei creature di tua scelta che puoi vedere entro gittata riacquistano punti ferita pari a 1d4 + il tuo modificatore di spellcasting. Questo incantesimo non ha effetto su non morti o costrutti.",
    "atHigherLevels": "Quando lanci questa magia usando uno slot incantesimo di 4° livello o superiore, la guarigione aumenta di 1d4 per ogni livello di slot superiore al 3°.",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "parola-guaritrice-di-massa",
    "language": "it"
  },
  {
    "name": "Passapareti",
    "level": 5,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di semi di sesamo)"
    ],
    "duration": "1 ora",
    "description": "Un passaggio si apre in un punto scelto dall'incantatore su una superficie di legno, di pietra o di intonaco e che egli sia in grado di vedere (come per esempio una parete, un soffitto o un pavimento) entro gittata. Il pasaggio permane per la durata dell'incantesimo. L'incantatore decide le dimensioni dell'apertura, che puo' essere al massimo larga 1,5 metri, alta 2,4 metri e profonda 6 metri. Il passaggio non genera alcuna instabilita' nella struttura che lo circonda. Quando l'apertura scompare, ogni creatura o oggetto ancora all'interno del passaggio creato dall'incantesimo viene espulso senza subire danni nello spazio libero' piu' vicino alla superficie in cui l'incantesimo e' stato lanciato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di semi di sesamo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "passapareti",
    "language": "it"
  },
  {
    "name": "Passare Senza Tracce",
    "level": 2,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (cenere di una foglia di vischio bruciata e un rametto di abete)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore e' avvolto da un velo d'ombra e di silenzio che impedisce a lui e ai suoi compagni di essere individuati. Per la durata dell'incantesimo, ogni creatura da lui scelta e situata entro 9 metri da lui (incluso sé stesso) ottiene un bonus di +10 alle prove di Destrezza (Furtivita') e le sue tracce sono impossibili da seguire se non tramite mezzi magici. Una creatura che riceve questo bonus non lascia impronte o altre tracce del suo passaggio",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "cenere di una foglia di vischio bruciata e un rametto di abete",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "passare-senza-tracce",
    "language": "it"
  },
  {
    "name": "Passo Velato",
    "level": 2,
    "school": "Evocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore e' avvolto per un istante da una foschia argentata e si teletrasporta di un massimo di 9 metri fino a uno spazio libero che egli sia in grado di vedere.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "passo-velato",
    "language": "it"
  },
  {
    "name": "Passo Veloce",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un pizzico di terriccio)"
    ],
    "duration": "1 ora",
    "description": "L'incantatore tocca una creatura, la cui velocita' aumenta di 3 metri finché l'incantesimo non termina. Ai Livelli Superiori: Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, l'incantatore puo' bersagliare una creatura aggiuntiva per ogni slot di livello superiore al 1°.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di terriccio",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "passo-veloce",
    "language": "it"
  },
  {
    "name": "Paura",
    "level": 3,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore (cono di 9 metri)",
    "components": [
      "Componenti: V",
      " S",
      " M (una piuma bianca o un cuore di pollo)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "L'incantatore proietta un'immagine illusoria delle peggiori paure della creatura. Ogni creatura entro un cono di 9 metri deve superare un tiro salvezza su Saggezza, altrimenti lascia cadere cio' che tiene in mano e diventa spaventata per la durata dell'incantesimo. Finche' e' spaventata da questo incantesimo, una creatura deve effettuare l'azione di Scatto e muoversi per allontanarsi dall'incantatore lungo il percorso piu' sicuro possibile ad ogni suo turno, a meno che non ci sia alcun posto dove andare. Se la creatura termina il so turno in un luogo dove non possiede la linea di vista fino all'incantatore, puo' effettuare un tiro salvezza su Saggezza. Se lo supera, l'incantesimo termina per lei.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piuma bianca o un cuore di pollo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "paura",
    "language": "it"
  },
  {
    "name": "Pelle Coriacea",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un frammento di corteccia di quercia)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore tocca una creatura consenziente. Finché l'incantesimo non termina, la pelle del bersaglio assume un aspetto ruvido simile alla corteccia e la sua CA non puo' essere inferiore a 16, a prescindere dal tipo di armatura che esso indossa.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di corteccia di quercia",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "pelle-coriacea",
    "language": "it"
  },
  {
    "name": "Pelle di Pietra",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (polvere di diamante del valore di 100 mo, che l'incantatore consuma)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Questo incantesimo rende la carne di una creatura consenziente toccata dall'incantatore dura come la pietra. Finché l'incantesimo non termina, il bersaglio ottiene resistenza ai danni non magici contundenti, perforanti e taglienti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "polvere di diamante del valore di 100 mo, che l'incantatore consuma",
    "damageTypes": [
      "contundenti",
      "perforanti",
      "taglienti"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "pelle-di-pietra",
    "language": "it"
  },
  {
    "name": "Percezione delle Bestie",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore tocca una bestia consenziente. Per la durata dell'incantesimo, puo' usare la sua azione per vedere attraverso gli occhi della bestia e sentire cio' che essa sente, e continuera' a farlo finché non usa la propria azione per tornare ai suoi sensi normali. Finché percepisce il mondo attraverso i sensi della bestia, l'incantatore ottiene i benefici di qualsiasi senso speciale posseduto da quella creatura, ma resta accecato e assordato nei confronti di cio' che accade attorno a lui.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "percezione-delle-bestie",
    "language": "it"
  },
  {
    "name": "Piaga degli Insetti",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "90 metri",
    "components": [
      "V",
      " S",
      " M (alcuni granelli di zucchero, alcuni chicchi di grano e un pezzetto di grasso animale)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Uno sciame di locuste fameliche riempie una sfera del raggio di 6 metri centrata su un punto a scelta dell'incantatore entro gittata. La sfera si diffonde oltre gli angoli, permane per la durata dell'incantesimo e la sua area e' leggermente oscurata. L'area della sfera e' considerata terreno difficile. Quando la sfera compare, ogni creatura al suo interno deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 4d10 danni perforanti, mentre se lo supera subisce soltanto la meta' di quei danni. Una creatura deve effettuare questo tiro salvezza anche quando entra nell'area dell'incantesimo per la prima volta in un turno o vi termina il proprio turno.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 6° livello o superiore, i danni aumentano di 1d10 per ogni slot di livello superiore al 5°.",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "alcuni granelli di zucchero, alcuni chicchi di grano e un pezzetto di grasso animale",
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "piaga-degli-insetti",
    "language": "it"
  },
  {
    "name": "Porta Dimensionale",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "150 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore si teletrasporta dal suo luogo attuale a un qualsiasi altro punto entro gittata. Arriva esattamente nel punto desiderato, che puo' trattarsi di un luogo che e' in grado di vedere o uno che e' in grado di descrivere dichiarandone la distanza e la direzione, come per esempio \"60 metri in linea retta verso il basso\" o \"verso nordovest, a un'angolazione ascendente di 45 gradi per 90 metri\". L'incantatore puo' portare con sé degli oggetti, purché il loro peso non superi quello che egli e' in grado di trasportare. Puo' inoltre portare con sé una creatura consenziente di taglia pari o inferiore alla sua, che trasporti equipaggiamento che non superi la sua capacita' di trasporto. La creatura deve trovarsi entro 1,5 metri dall'incantatore quando questi lancia l'incantesimo. Se l'incantatore dovesse arrivare in un luogo gia' occupato da un oggetto o da una creatura, sia l'incantatore che ogni creatura che viaggia assieme a lui subiscono 4d6 danni da forza ciascuno e l'incantesimo di teletrasporto fallisce.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "porta-dimensionale",
    "language": "it"
  },
  {
    "name": "Portale",
    "level": 9,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (diamanti del valore di 5000 mo)"
    ],
    "duration": "Concentrazione, fino ad 1 minuto",
    "description": "Crei un portale in uno spazio non occupato che puoi vedere che porta in una posizione precisa su un piano diverso di esistenza. Il portale e' un'apertura circolare da 1,5 a 6 metri di diametro. L'incantatore puo' orientare il portale in qualsiasi direzione scelga. Il portale permane per tutta la durata. Il portale ha una parte anteriore ed una posteriore, ma e' possibile attraversarlo solo dalla parte anteriore. Tutto cio' che si muove attraverso di esso viene istantaneamente trasportato sull'altro piano, apparendo nello spazio libero piu' vicino. Le regole del piano possono impedire l'apertura dei portali in loro presenza o in qualsiasi punto del loro dominio. Quando lanci questa magia, puoi dire il nome di una creatura specifica e verra' tirata nello spazio non occupato piu' vicino a te. ☀Se quella creatura si trova su un piano diverso da quello in cui ti trovi, il portale si apre nelle immediate vicinanze della creatura nominata e pesca la creatura attraverso lo spazio non occupato piu' vicino sul tuo lato del portale. Non ottieni alcun potere speciale sulla creatura ed e' libero di agire come desiderato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "diamanti del valore di 5000 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "portale",
    "language": "it"
  },
  {
    "name": "Portale Arcano",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "150 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore crea dei portali di teletrasporto collegati che rimangono aperti per la durata dell'incantesimo. L'incantatore sceglie due punti sul terreno che sia in grado di vedere: un punto entro 3 metri da lui e un punto entro 150 metri da lui. Un portale circolare, del diametro di 3 metri, si apre su ognuno dei punti scelti. Se il portale si aprirebbe in uno spazio occupato da una creatura, l'incantesimo fallisce e il lancio e' perduto. I portali sono anelli bidimensionali scintillanti al cui interno si agita una coltre di nebbia; fluttuano a pochi centimetri dal suolo e sono perpendicolari al terreno nei punti scelti dall'incantatore. Un anello e' visibile soltanto da un lato (a scelta dell'incantatore), che e' il lato che funziona come portale. Qualsiasi creatura o oggetto che entra nel portale esce dall'altro portale come se i due fossero adiacenti l'uno all'altro. Passare attraverso un portale dal lato che non e' un portale non produce alcun effetto. La nebbia che riempie ogni portale e' opaca e blocca la visione attraverso di esso. Nel proprio turno, l'incantatore puo' ruotare gli anelli come azione bonus in modo che il lato attivo si orienti in una direzione diversa.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "portale-arcano",
    "language": "it"
  },
  {
    "name": "Preghiera di Guarigione",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "Fino a sei creature scelte dall'incantatore, situate entro gittata e che egli sia in grado di vedere, recuperano un ammontare di punti ferita a testa pari a 2d8 + il modificatore di caratteristica da incantatore. Questo incantesimo non ha effetto su costrutti o sui non morti. Ai Livelli Successivi. Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, la guarigione aumenta di 1d8 per ogni slot di livello superiore al 2°.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "preghiera-di-guarigione",
    "language": "it"
  },
  {
    "name": "Presagio",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (bastoncini, ossa o amuleti analoghi ricoperti di segni e del valore di almeno 25 mo)"
    ],
    "duration": "Istantanea",
    "description": "Il DM sceglie tra i seguenti presagi possibili:L'incantesimo non prende in considerazione quelle potenziali circostanze che potrebbero alterare l'esito, come per esempio il lancio di incantesimi aggiuntivi o la perdita o l'acquisizione di un compagno. Se l'incantatore lancia l'incantesimo due o piu' volte prima di completare il suo riposo lungo successivo, esiste una probabilita' cumulativa del 25 per cento per ogni lancio dopo il primo di ottenere un responso casuale. Il DM effettua questo tiro in segreto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "bastoncini, ossa o amuleti analoghi ricoperti di segni e del valore di almeno 25 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "presagio",
    "language": "it"
  },
  {
    "name": "Prestidigitazione",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Raggio: 3 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Fino a 1 ora",
    "description": "Questo incantesimo e' un trucco magico che gli incantatori novizi usano per fare pratica. L'incantatore crea uno degli effetti magici seguenti entro gittata:Se l'incantatore lancia questo incantesimo piu' volte puo' tenere attivi fino a tre dei suoi effetti non istantanei contemporaneamente, e puo' congedare ognuno di questi effetti con un'azione",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "prestidigitazione",
    "language": "it"
  },
  {
    "name": "Previsione",
    "level": 9,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (una piuma di colibrì)"
    ],
    "duration": "8 ore",
    "description": "L'incantatore tocca una creatura consenziente e le conferisce una capacita' limitata di prevedere il futuro prossimo. Per la durata dell'incantesimo, il bersaglio non puo' essere sorpreso e dispone di vantaggio ai tiri per colpire, alle prove di caratteristica e ai tiri salvezza. Inoltre, le altre creature subiscono svantaggio ai tiri per colpire contro il bersaglio per la durata dell'incantesimo. Questo incantesimo termina immediatamente se l'incantatore lo lancia di nuovo prima che la sua durata termini.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piuma di colibrì",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "previsione",
    "language": "it"
  },
  {
    "name": "Produrre Fiamma",
    "level": 0,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "10 minuti",
    "description": "Una fiamma tremolante compare nella mano dell'incantatore. La fiamma permane per la durata dell'incantesimo e non infligge danni né all'incantatore né al suo equipaggiamento. La fiamma proietta luce intensa entro un raggio di 3 metri e luce fioca per altri 3 metri. L'incantesimo termina se l'incantatore lo interrompe con un'azione o se lo lancia di nuovo. L'incantatore puo' anche attaccare con la fiamma, ponendo termine all'incantesimo. Quando l'incantatore lancia questo incantesimo, o usando un'azione in un turno successivo, puo' scagliare la fiamma contro una creatura situata entro 9 metri da lui. Effettua un attacco a distanza con questo incantesimo. Se colpisce, il bersaglio subisce 1d8 danni da fuoco. I danni di questo incantesimo aumentano di 1d8 quando l'incantatore arriva al 5° livello (2d8), 11° livello (3d8) e 17° livello (4d8).",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "produrre-fiamma",
    "language": "it"
  },
  {
    "name": "Proibizione",
    "level": 6,
    "school": "Abiurazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (uno spruzzo d'acqua santa, incenso raro e polvere di rubino del valore di almeno 1.000 mo)"
    ],
    "duration": "1 giorno",
    "description": "L'incantatore crea un'interdizione ai viaggi magici che protegge un'area di terreno quadrata con lato di 200 metri fino a un'altezza di 9 metri. Per la durata dell'incantesimo, le creature non possono teletrasportarsi in quell'area o entrarvi usando portali come quelli creati dall'incantesimo Portale. L'incantesimo isola l'area dai viaggi planari, quindi impedisce alle creature di accedere all'area tramite il Piano Astrale, il Piano Etereo, la Selva Fatata, la Coltre Oscura o l'incantesimo Spostamento Planare. L'incantesimo inoltre infligge danni ai tipi di creature scelti dall'incantatore al momento del lancio. L'incantatore sceglie uno o piu' tipi di creature tra celestiali, elementali, folletti, immondi e non morti. Quando una delle creature scelte entra nell'area dell'incantesimo per la prima volta o vi inizia il proprio turno, subisce 5d10 radiosi o necrotici (a scelta dell'incantatore al momento del lancio dell'incantesimo). Quando l'incantatore lancia questo incantesimo, puo' designare una parola d'ordine. Una creatura che pronuncia la parola d'ordine quando entra nell'area non subisce danni dell'incantesimo. L'area dell'incantesimo non puo' sovrapporsi all'area di un altro incantesimo proibizione. Se l'incantatore lancia proibizione ogni giorno nello stesso luogo per 30 giorni, l'incantesimo permane finché non viene dissolto, e le componenti materiali vengono consumate al momento dell'ultimo lancio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "uno spruzzo d'acqua santa, incenso raro e polvere di rubino del valore di almeno 1.000 mo",
    "damageTypes": [
      "radiosi",
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "proibizione",
    "language": "it"
  },
  {
    "name": "Proiezione Astrale",
    "level": 9,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S",
      " M (per ogni creatura influenzata da questo incantesimo, l'incantatore deve fornire un giacinto del valore di almeno 1.000 mo e un lingotto d'argento finemente decorato del valore di almeno 100 mo, entrambi consumati dall'incantesimo)"
    ],
    "duration": "Speciale",
    "description": "L'incantatore e fino a un massimo di otto creature consenzienti entro gittata proiettano i loro corpi astrali sul Piano Astrale (l'incantesimo fallisce e il lancio e' sprecato se l'incantatore si trova gia' su quel piano). Il corpo materiale che l'incantatore si lascia indietro cade privo di sensi ed entra in uno stato di animazione sospesa; non ha bisogno di cibo o di aria e non invecchia. Il corpo astrale dell'incantatore assomiglia alla sua forma mortale in quasi ogni modo, replicandone le statistiche di gioco e le proprieta'. La differenza principale consiste nell'aggiunta di un cordone argentato che parte dalle sue scapole e fluttua alle sue spalle, diventando invisibile dopo circa 30 cm. Questo cordone tiene ancorato l'incantatore al suo corpo materiale. Fintanto che il cordone rimane intatto, l'incantatore e' in grado di trovare la via del ritorno. Se il cordone viene reciso (cosa che accade quando un effetto lo dichiara specificatamente), l'anima e il corpo dell'incantatore si separano e l'incantatore muore sul colpo. La forma astrale dell'incantatore puo' viaggiare liberamente per il Piano Astrale e puo' passare attraverso i portali di quel piano che conducono a qualsiasi altro piano. Se l'incantatore si sposta su un nuovo piano o torna sul piano dove si trovava quando aveva lanciato questo incantesimo, il suo corpo e le sue proprieta' vengono trasportati lungo il cordone argentato, consentendo all'incantatore di rientrare nel suo corpo nel momento in cui accede al nuovo piano. La forma astrale dell'incantatore e' un'incarnazione separata. Qualsiasi danno o altro effetto che si applichi a essa non ha effetto sul suo corpo fisico e non persiste quando la forma astrale vi fa ritorno. L'incantesimo permane per l'incantatore e i suoi compagni fino a quando l'incantatore usa la sua azione per terminarlo. Quando l'incantesimo termina, la creatura influenzata fa ritorno al suo corpo fisico e si sveglia. L'incantesimo potrebbe terminare prematuramente per l'incantatore o uno dei suoi compagni. Un incantesimo Dissolvi Magie usato con successo contro una forma astrale o un corpo fisico termina l'incantesimo per quella creatura. Se il corpo originale o la forma astrale di una creatura scende a 0 punti ferita, l'incantesimo termina per quella creatura. Se l'incantesimo termina e il cordone argentato e' intatto, il cordone trascina la forma astrale della creatura all'interno del suo corpo, cosa che pone fine allo stato di animazione sospesa. Se l'incantatore fa ritorno al suo corpo prematuramente, i suoi compagni rimangono nelle loro forme astrali e devono trovare da soli il modo di rientrare nei loro corpi, solitamente scendendo a 0 punti ferita.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "per ogni creatura influenzata da questo incantesimo, l'incantatore deve fornire un giacinto del valore di almeno 1.000 mo e un lingotto d'argento finemente decorato del valore di almeno 100 mo, entrambi consumati dall'incantesimo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "proiezione-astrale",
    "language": "it"
  },
  {
    "name": "Protezione dai Veleni",
    "level": 2,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: contatto",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: 1 ora",
    "description": "Un veleno di cui conosci il nome, o uno casuale, viene neutralizzato da una creatura che ne e' afflitta. Finché l'incantesimo dura, il beneficiario ha vantaggio nel resistere ai veleni e guadagna resistenza ai danni da veleno",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Paladino",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "protezione-dai-veleni",
    "language": "it"
  },
  {
    "name": "Protezione dal Bene e dal Male",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (acqua santa o polvere d'argento e di ferro che l'incantesimo consuma)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Finché l'incantesimo non termina, una creatura consenziente toccata dall'incantatore e' protetta da certi tipi di creature: aberrazioni, celestiali, elementali, folletti, immondi e non morti. La protezione conferisce vari benefici. Le creature di quei tipi subiscono svantaggio ai tiri per colpire contro il bersaglio. Inoltre il bersaglio non puo' essere affascinato, posseduto o spaventato da una di quelle creature. Se il bersaglio e' gia' affascinato, posseduto o spaventato dispone vantaggio al nuovo tiro salvezza contro l'effetto rilevante.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Paladino",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "acqua santa o polvere d'argento e di ferro che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "protezione-dal-bene-e-dal-male",
    "language": "it"
  },
  {
    "name": "Protezione dall’Energia",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "Per la durata dell'incantesimo, una creatura consenziente toccata dall'incantatore dispone di resistenza a un tipo di danni scelto dall'incantatore:\r\nacido\r\nfreddo\r\nfulmine\r\nfuoco\r\ntuono",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Mago",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "acido",
      "freddo",
      "fuoco",
      "fulmine",
      "tuono"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "protezione-dallenergia",
    "language": "it"
  },
  {
    "name": "Punizione Accecante",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un attacco con un'arma da mischia entro la durata di questo incantesimo, l'arma in questione emette un lampo di luce intensa e l'attacco infligge 3d8 danni radiosi extra al bersaglio. Inoltre, il bersaglio deve superare un tiro salvezza su Costituzione, altrimenti rimarra' accecato finché l'incantesimo non termina. Una creatura accecata da questo incantesimo effettua un altro tiro salvezza su Costituzione alla fine di ogni suo turno. Se lo supera, non e' piu' accecata.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "punizione-accecante",
    "language": "it"
  },
  {
    "name": "Punizione Collerica",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce con un attacco con un'arma da mischia entro la durata di questo incantesimo, infligge 1d6 danni psichici extra. Inoltre, se il bersaglio e' una creatura, deve superare un tiro salvezza su Saggezza, altrimenti sara' spaventato dall'incantatore finché l'incantesimo non termina. Con un'azione, la creatura puo' effettuare una prova di Saggezza contro la CD del tiro salvezza dell'incantesimo per rafforzare la sua determinazione e terminare questo incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "punizione-collerica",
    "language": "it"
  },
  {
    "name": "Punizione Demoralizzante",
    "level": 4,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un attacco con un'arma da mischia entro la durata di questo incantesimo, la sua arma penetra sia il corpo che la mente, e l'attacco infligge 4d6 danni psichici extra al bersaglio, che deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, subisce svantaggio ai tiri per colpire e alle prove di caratteristica e non puo' effettuare reazioni fino alla fine del proprio turno successivo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "punizione-demoralizzante",
    "language": "it"
  },
  {
    "name": "Punizione Esiliante",
    "level": 5,
    "school": "Abiurazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un attacco con un'arma entro la durata di questo incantesimo, la sua arma crepita di energia e l'attacco infligge 5d10 danni da fora extra al bersaglio. Inoltre, se questo attaco riduce il bersaglio a 50 punti ferita o meno, lo esilia. Se il bersaglio e' originario di un piano di esistenza diverso da quello in cui l'incantatore si trova, il bersaglio scompare e ritorna sul suo piano natio. Se il bersaglio e' originario del piano in cui l'incantatore si trova, esso svanisce in un semipiano innocuo. Finché si trova laggiu', il bersaglio e' incapacitato. Rimane li' finché l'incantesimo non termina, nel qual caso ricompare nello spazio che aveva lasciato o nello spazio libero piu' vicino se quello spazio e' occupato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "punizione-esiliante",
    "language": "it"
  },
  {
    "name": "Punizione Incandescente",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un attacco con un'arma da mischia entro la durata di questo incantesimo, l'arma diventa incandescente e l'attacco infligge 1d6 danni da fuoco extra al bersaglio, oltre che incendiarlo. All'inizio di ogni suo turno finché l'incantesimo non termina, il bersaglio deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 1d6 danni da fuoco, mentre se lo supera, l'incantesimo termina. Se il bersaglio o una creatura situata entro 1,5 metri da lui usa un'azione per estinguere le fiamme, o se qualche altro effetto sopprime le fiamme (per esempio se il bersaglio viene immerso nell'acqua), l'incantesimo termina.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni extra iniziali inferti dall'attacco aumentano di 1d6 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "punizione-incandescente",
    "language": "it"
  },
  {
    "name": "Punizione Marchiante",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un attacco con un'arma entro la durata di questo incantesimo, l'arma risplende di un bagliore astrale al momento di colpire. L'attacco infligge 2d6 danni radiosi extra al bersaglio, che diventa visibile se e' invisibile, proietta luce fioca in un raggio di 1,5 metri attorno a sé, e non puo' diventare invisibile finché l'incantesimo non terimna.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni extra aumentano di 1d6 per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "radiosi"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "punizione-marchiante",
    "language": "it"
  },
  {
    "name": "Punizione Tonante",
    "level": 1,
    "school": "Invocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce con un attacco con un'arma da mischia entro la durata di questo incantesimo, la sua arma vibra di un rombo di tuono udibile entro 90 metri e l'attacco infligge 2d6 danni da tuono extra al bersaglio. Inoltre, se il bersaglio e' una creatura, deve superare un tiro salvezza su Forza, altrimenti e' spinto 3 metri piu' lontano dall'incantatore e buttato a terra prono.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "punizione-tonante",
    "language": "it"
  },
  {
    "name": "Purificare Cibo e Acqua",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": true,
    "range": "3 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Cibo e bevande non magici all'interno di una sfera avente come raggio 1,5 metri sono resi privi di veleno e malattia.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "purificare-cibo-e-acqua",
    "language": "it"
  },
  {
    "name": "Raffica di Spine",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "La prossima volta che l'incantatore colpisce una creatura con un'arma a distanza entro la durata di questo incantesimo, una raffica di spine si sprigiona dalla sua arma a distanza o dalle sue munizioni. In aggiunta al normale effetto dell'attacco, il bersaglio e ogni creatura entro 1,5 metri da esso devono effettuare un tiro salvezza su Destrezza. Chi lo fallisce subisce 1d10 danni perforanti, mentre chi lo supera subisce soltanto la meta' di quei danni.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d10 per ogni slot di livello superiore al 1° (fino a un massimo di 6d10).",
    "availableClasses": [
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "raffica-di-spine",
    "language": "it"
  },
  {
    "name": "Raggio di Affaticamento",
    "level": 2,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, massimo 1 minuto",
    "description": "Un fascio nero di energia debilitante parte dal tuo dito diretto contro una creatura a gittata. Effettua un attacco a distanza con incantesimo contro il bersaglio. Se colpisci, il bersaglio infliggera' la meta' dei danni con gli attacchi con arma che usano la Forza fino al termine dell’incantesimo. Al termine di ciascun turno del bersaglio, questi puo' effettuare un tiro salvezza su Costituzione contro l’incantesimo. Se lo supera, l’incantesimo ha termine.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "raggio-di-affaticamento",
    "language": "it"
  },
  {
    "name": "Raggio di Gelo",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un raggio gelido di luce azzurra e biancastra sfreccia verso una creatura entro gittata. L'incantatore effettua un attacco a distanza con questo incantesimo contro il bersaglio. Se lo colpisce, il bersaglio subisce 1d8 danni da freddo e la sua velocita' e' ridotta di 3 metri fino all'inizio del turno successivo dell'incantatore. I danni di questo incantesimo aumentano di 1d8 quando l'incantatore arriva al 5° livello (2d8), 11° livello (3d8) e 17° livello (4d8).",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "freddo"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "raggio-di-gelo",
    "language": "it"
  },
  {
    "name": "Raggio di Infermita'",
    "level": 1,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un raggio di nauseante energia verdastra sfreccia verso una creatura entro gittata. L'incantatore effettua un attacco a distanza con questo incantesimo contro il bersaglio. Se lo colpisce, il bersaglio subisce 2d8 danni da veleno e deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, e' avvelenato fino alla fine del turno successivo dell'incantatore.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "raggio-di-infermita-",
    "language": "it"
  },
  {
    "name": "Raggio Rovente",
    "level": 2,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore crea tre raggi di fuoco e li scaglia contro uno o piu' bersagli entro gittata. L'incantatore effettua un attacco a distanza con questo incantesimo per ogni raggio. Se colpisce, il bersaglio subisce 2d6 danni da fuoco.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, crea un raggio aggiuntivo per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "raggio-rovente",
    "language": "it"
  },
  {
    "name": "Ragnatela",
    "level": 2,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di ragnatela comune)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore evoca una massa di spessi e viscosi filamenti di ragnatela in un punto a sua scelta situato entro gittata. Le ragnatele riempiono un cubo con spigolo di 6 metri generato da quel punto per la durata dell'incantesimo. Le ragnatele sono terreno difficile e la loro area e' considerata leggermente oscurata. Se le ragnatele non sono ancorate tra due masse solide (per esempio pareti o alberi) o stese su un pavimento, un muro o un soffitto, collassano su sé stesse e l'incantesimo termina all'inizio del turno successivo dell'incantatore. Le ragnatele stese su una superficie piatta hanno una profondita' di 1,5 metri. Ogni creatura che inizia il suo turno nelle ragnatele o che vi entra durante il proprio turno deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, la creatura e' trattenuta fintanto che rimante tra le ragnatele o finché non si libera spezzandole. Una creatura trattenuta dalle ragnatele puo' usare la sua azione per effettuare una prova di Forza contro la CD del tiro salvezza dell'incantesimo. Se ha successo, non e' piu' trattenuta. Le ragnatele sono infiammabili. Un cubo di ragnatele con spigolo di 1,5 metri brucia in 1 round, infliggendo 2d4 danni da fuoco a ogni creatura che inizi il suo turno tra le fiamme.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di ragnatela comune",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "ragnatela",
    "language": "it"
  },
  {
    "name": "Rampicante Afferrante",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore evoca un rampicante che spunta dal terreno in uno spazio libero entro gittata e che egli sia in grado di vedere. Quando lancia questo incantesimo, l'incantatore puo' ordinare al rampicante di avvinghiarsi a una creatura situata entro 9 metri da esso e che l'incantatore sia in grado di vedere. Quella creatura deve superare un tiro salvezza su Destrezza, altrimenti viene tirata di 6 metri direttamente verso il rampicante. Finché l'incantesimo non termina, l'incantatore puo' ordinare al rampicante di avvinghiare la stessa creatura o un'altra creatura come azione bonus a ogni suo turno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "rampicante-afferrante",
    "language": "it"
  },
  {
    "name": "Randello Incantato",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (vischio, una foglia di trifoglio, e un randello o un bastone ferrato)"
    ],
    "duration": "1 minuto",
    "description": "Il legno di un randello o di un bastone ferrato impugnato dall'incantatore e' pervaso dal potere della natura. Per la durata dell’incantesimo, l'incantatore puo' usare la sua caratteristica da incantatore anziché la Forza per i tiri per colpire e i tiri per i danni effettuati negli attacchi in mischia usando quell'arma; inoltre, i danni dell’arma diventano un d8. L’arma diventa magica, se gia' non lo era. L’incantesimo termina se l'incantatore lo lancia di nuovo o se lascia andare l’arma.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "vischio, una foglia di trifoglio, e un randello o un bastone ferrato",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "randello-incantato",
    "language": "it"
  },
  {
    "name": "Reggia Meravigliosa di Mordenkainen",
    "level": 7,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "90 metri",
    "components": [
      "V",
      " S",
      " M (un portale in miniatura scolpito in avorio, un frammento di marmo lucido, un cucchiaino d'argento; ognuno di questi oggetti deve avere un valore di almeno 5 mo)"
    ],
    "duration": "24 ore",
    "description": "L'incantatore evoca entro gittata una dimora extradimensionale che permane per la durata dell'incantesimo. L'incantatore sceglie l'ubicazione dell'entrata, che risplende di un debole bagliore di luce ed e' larga 1,5 metri e alta 3 metri. L'incantatore e ogni creatura da lui designata al momento del lancio dell'incantesimo possono entrare nella dimora extradimensionale fintanto che il portale resta aperto.  L'incantatore puo' aprire o chiudere il portale se si trova entro 9 metri da esso.  Finché e' chiuso, il portale e' invisibile. Oltre il portale si trova uno sfarzoso atrio circondato da numerose stanze.  L'atmosfera e' fresca, pulita e accogliente.  L'incantatore puo' definire la planimetria della dimora come preferisce, ma lo spazio occupato non puo' superare 50 cubi con spigolo di 3 metri ciascuno. La dimora e' arredata e decorata in base ai desideri dell'incantatore.  Contiene cibo a sufficienza da servire un banchetto di 9 portate per un massimo di 100 persone. Un personale di 100 servitori semitrasparenti si prende cura di tutti coloro che entrano nella dimora.  L'incantatore decide l'aspetto e la tenuta di questi servitori, che obbediscono a ogni suo ordine. Ogni servitore puo' eseguire qualsiasi compito che un normale servitore umano sarebbe in grado di eseguire, ma non puo' attaccare o effettuare qualsiasi altra azione che ferirebbe in modo diretto un'altra creatura.  Quindi i servitori possono portare oggetti, pulire, riparare, ripiegare abiti, accendere fuochi, servire pietanze, versare vino e cosl via. I servitori possono recarsi in qualsiasi punto della dimora ma non possono uscirne.  I mobili e gli altri oggetti creati da questo incantesimo si dissolvono in fumo se rimossi dalla dimora. Quando l'incantesimo termina, tutte le creature all'interno dello spazio extradimensionale vengono espulse negli spazi liberi piu' vicini all'entrata.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un portale in miniatura scolpito in avorio, un frammento di marmo lucido, un cucchiaino d'argento; ognuno di questi oggetti deve avere un valore di almeno 5 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "reggia-meravigliosa-di-mordenkainen",
    "language": "it"
  },
  {
    "name": "Regressione Mentale",
    "level": 8,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata:45 metri",
    "components": [
      "V",
      " S",
      " M (una manciata di sfere di argilla, cristallo, vetro o minerali)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore assale la mente di una creatura entro gittata che egli sia in grado di vedere, nel tentativo di infrangere il suo intelletto e la sua personalita'. Il bersaglio subisce 4d6 danni psichici e deve effettuare un tiro salvezza su Intelligenza. Se lo fallisce, i suoi punteggi di Intelligenza e di Carisma diventano 1. Il bersaglio non puo' lanciare incantesimi, attivare oggetti magici, capire linguaggi o comunicare in alcun modo intelligibile. La creatura e' in grado tuttavia di identificare i suoi amici, seguirli, e perfino proteggerli. Alla fine di ogni 30 giorni, la creatura puo' ripetere il tiro salvezza contro questo incantesimo. Se lo supera, l'incantesimo termina. Anche gli incantesimi Desiderio, Guarigione o Ristorare superiore possono terminare questo incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una manciata di sfere di argilla, cristallo, vetro o minerali",
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Intelligenza"
    ],
    "urlFriendlyName": "regressione-mentale",
    "language": "it"
  },
  {
    "name": "Reincarnazione",
    "level": 5,
    "school": "Trasmutazione",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (oli e unguenti rari del valore di almeno 1.000 mo, che l’incantesimo consuma)"
    ],
    "duration": "Durata: Istantanea",
    "description": "L'incantatore tocca un umanoide morto o una parte di un umanoide morto. Purché la creatura non sia morta da piu' di 10 giorni, l'incantesimo forma un nuovo corpo adulto per quell'umanoide e poi richiama la sua anima all'interno di quel corpo. Se l'anima del bersaglio non e' consenziente o libera di tornare, l'incantesimo fallisce. L'incantesimo produce un nuovo corpo in cui la creatura possa vivere, cosa che probabilmente costringe la creatura a cambiare razza. Il DM tira un d100 e consulta la tabella seguente per determinare quale forma assume la creatura quando torna in vita; in alternativa, il DM puo' scegliere la forma. La creatura reincarnata ricorda la sua vita e le sue esperienze passate. Conserva le capacita' che possedeva nella sua forma originale, ma sostituisce la razza originale con quella nuova e cambia i tratti razziali di conseguenza.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "oli e unguenti rari del valore di almeno 1.000 mo, che l’incantesimo consuma",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "reincarnazione",
    "language": "it"
  },
  {
    "name": "Resistenza",
    "level": 0,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (un mantello in miniatura)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tocca una creatura consenziente. Per una volta prima che l'incantesimo termini, il bersaglio puo' tirare un d4 e aggiungere il risultato ottenuto ad un tiro salvezza a sua scelta. Puo' tirare il dado prima o dopo avere effettuato il tiro salvezza. Dopodiché l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un mantello in miniatura",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "resistenza",
    "language": "it"
  },
  {
    "name": "Respirare sott’Acqua",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 9 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (un piccolo giunco e una paglia)"
    ],
    "duration": "Durata: 24 ore",
    "description": "Questo incantesimo conferisce ad un massimo di dieci creature consenzienti entro gittata e che l'incantatore sia in grado di vedere la capacita' di respirare sott'acqua finché l'incantesimo non termina. Le creature influenzate conservano anche la loro normale modalita' di respirazione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un piccolo giunco e una paglia",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "respirare-sottacqua",
    "language": "it"
  },
  {
    "name": "Resurrezione",
    "level": 7,
    "school": "Necromanzia",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: contatto",
    "components": [
      "Componenti: V",
      " S",
      "M (1000 mo di diamanti che verranno consumati)"
    ],
    "duration": "Durata: Istantaneo",
    "description": "Toccando una creatura morta da non piu' di un secolo, di morte naturale, e che non sia un non-morto. Qualora la sua anima fosse consenziente, il bersaglio torna in vita con tutti i suoi punti ferita. L'incantesimo neutralizza ogni veleno e cura ogni malattia comune. Ma non puo' curare malattie di origine magica e maledizioni. L'incantesimo inoltre, rimargina ogni ferita mortale e ripristina ogni parte mancate del corpo. Tornare dai morti e' un esperienza estenuante. Il bersaglio riceve un -4 a tutti i tiri per colpire, tiri salvezza e tiri di abilita'. Ogni volta che si finisce un riposo lungo , la penalita' si riduce di 1 fino a svanireSe il bersaglio e' rimasto morto per piu' di un anno, non puo' lanciare incantesimi, e riceve svantaggio a tutti i tiri per colpire, tiri abilita' e tiri salvezza fino alla fine di un riposo lungo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "1000 mo di diamanti che verranno consumati",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "resurrezione",
    "language": "it"
  },
  {
    "name": "Resurrezione Pura",
    "level": 9,
    "school": "Necromanzia",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (Acqua santa, 25000 mo in diamanti che verranno consumati)"
    ],
    "duration": "Durata: Istantaneo",
    "description": "L'incantatore tocca una creatura che e' morta da non piu' di 200 anni e che e' morta per qualsiasi motivo tranne la vecchiaia. Se l'anima della creatura e' libera e disponibile, viene ripristinata con tutti i suoi punti ferita. Questo incantesimo chiude tutte le ferite, neutralizza ogni veleno, cura tutte le malattie e toglie qualsiasi maledizione. L'incantesimo sostituisce gli organi e gli arti danneggiati o mancanti. Se la creatura era non morta, viene ripristinata nella sua forma non-non-morta. L'incantesimo puo' fornire un nuovo corpo se l'originale non esiste piu', nel qual caso l'incantatore deve pronunciare il nome della creatura. La creatura appare in uno spazio non occupato che l'incantatore sceglie entro 3 metri da esso.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "Acqua santa, 25000 mo in diamanti che verranno consumati",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "resurrezione-pura",
    "language": "it"
  },
  {
    "name": "Rianimare Morti",
    "level": 5,
    "school": "Necromanzia",
    "castingTime": "1 ora",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un diamante del valore di almeno 500 mo, che l'incantesimo consuma)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore riporta in vita una creatura morta da lui toccata, purché non sia morta da piu' di 10 giorni. Se l'anima della creatura e' consenziente ed e' libera di riunirsi al corpo, la creatura torna in vita con 1 punto ferita. Questo incantesimo neutralizza inoltre qualsiasi veleno e cura le malattie non magiche che influenzavano la creatura al momento della morte. Tuttavia, questo incantesimo non rimuove le malattie magiche, le maledizioni e le altre afflizioni analoghe; se non vengono rimossi prima del lancio dell'incantesimo, il bersaglio ne sara' afflitto quando tornera' in vita. Questo incantesimo non puo' riportare in vita una creatura non morta. Questo incantesimo richiude tutte le ferite mortali, ma non ripristina le parti del corpo mancanti. Se una creatura e' priva di parti del corpo o di organi essenziali per la sua sopravvivenza (come per esempio la testa), l'incantesimo fallisce automaticamente. Il ritorno dalla morte e' una vera e propria ordalia. Il bersaglio subisce una penalita' di -4 a tutti i tiri per colpire, ai tiri salvezza e alle prove di caratteristica. Ogni volta che il bersaglio completa un riposo lungo, la penalita' viene ridotta di 1 finché non sparisce del tutto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un diamante del valore di almeno 500 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "rianimare-morti",
    "language": "it"
  },
  {
    "name": "Rigenerazione",
    "level": 7,
    "school": "Trasmutazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (una ruota della preghiera e acqua santa)"
    ],
    "duration": "Durata: 1 ora",
    "description": "L'incantatore tocca una creatura e amplifica le sue capacita' curative naturali. Il bersaglio recupera 4d8+15 punti ferita. Per la durata dell'incantesimo, il bersaglio recupera 1 punto ferita all'inizio di ogni suo turno (10 punti ferita al minuto). Se al bersaglio sono state recise parti del corpo (dita, gambe, coda e cosi' via) quelle parti vengono rigenerate dopo 2 minuti. Se l'incantatore e' in possesso della parte recisa e l'appoggia al moncherino, l'incantesimo riunisce istantaneamente l'arto reciso al moncherino.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una ruota della preghiera e acqua santa",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "rigenerazione",
    "language": "it"
  },
  {
    "name": "Rimuovi Maledizione",
    "level": 3,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Al tocco dell'incantatore, tutte le maledizioni che affliggono una creatura o un oggetto terminano. Se l'oggetto e' un oggetto magico maledetto, la sua maledizione rimane, ma l'incantesimo spezza la sintonia del suo proprietario con quell'oggetto, consentendogli di rimuoverlo o di scartarlo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago",
      "Paladino",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "rimuovi-maledizione",
    "language": "it"
  },
  {
    "name": "Rinascita",
    "level": 3,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (diamanti del valore di 300 mo, che l'incantesimo consuma)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore tocca una creatura morta entro l'ultimo minuto. Quella creatura torna in vita con 1 punto ferita. Questo incantesimo non puo' riportare in vita una creatura morta di vecchiaia e non puo' ripristinare le eventuali parti del corpo mancanti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "diamanti del valore di 300 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "rinascita",
    "language": "it"
  },
  {
    "name": "Riparare",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (due calamite)"
    ],
    "duration": "Istantanea",
    "description": "Questo incantesimo ripara una singola crepa o uno squarcio in un oggetto toccato dall'incantatore, come l'anello spezzato di una catena, due meta' di una chiave spezzata, un mantello strappato o un otre forato. Fintanto che la crepa o lo squarcio non e' piu' grande di 30 cm in ogni dimensione, l'incantatore lo ripara senza lasciare traccia del danno precedente. Questo incantesimo puo' fisicamente riparare un oggetto magico o un costrutto, ma non puo' ripristinare la magia in un oggetto del genere.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "due calamite",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "riparare",
    "language": "it"
  },
  {
    "name": "Riposo Inviolato",
    "level": 2,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (del sale e del rame sugli occhi del cadavere)"
    ],
    "duration": "Durata: 10 giorni",
    "description": "Il beneficiario e' protetto dalla decomposizione e non puo' trasformarsi in un non-morto. Inoltre l'incantesimo estende il limite per rianimare un cadavere utilizzando l'incantesimo Rianimare Morti (da 7 a 10 giorni).",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "del sale e del rame sugli occhi del cadavere",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "riposo-inviolato",
    "language": "it"
  },
  {
    "name": "Risata Incontenibile di Tasha",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una manciata di briciole e una piuma da agitare in aria)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Una creatura a scelta dell'incantatore, situata entro gittata e che egli sia in grado di vedere, percepisce ogni cosa come esilarante ed e' scossa da una spasmodica risata se questo incantesimo la influenza. Il bersaglio deve superare un tiro salvezza su Saggezza, altrimenti cade a terra prono, diventa incapacitato e non e' in grado di rialzarsi per la durata dell'incantesimo. Una creatura con un punteggio di intelligenza pari o inferiore a 4 non e' influenzata dall'incantesimo. Alla fine di ogni suo turno e ogni volta che subisce danni, il bersaglio puo' effettuare un altro tiro salvezza su Saggezza. Il bersaglio dispone di vantaggio al tiro salvezza se esso e' innescato dai danni. In caso di successo, l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una manciata di briciole e una piuma da agitare in aria",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "risata-incontenibile-di-tasha",
    "language": "it"
  },
  {
    "name": "Riscaldare il Metallo",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 18 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (un pezzo di ferro e una fiamma)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 minuto",
    "description": "L'incantatore sceglie un oggetto artificiale di metallo, come un'arma di metallo o un'armatura di metallo media o pesante, situato entro gittata e che egli sia in grado di vedere, e fa in modo che quell'oggetto diventi incandescente. Ogni creatura a contatto fisico con l'oggetto subisce 2d8 danni da fuoco quando l'incantesimo viene lanciato. Finché l'incantesimo non termina, l'incantatore puo' usare un'azione bonus a ogni suo turno successivo per infliggere di nuovo quei danni. Se una creatura indossa o impugna l'oggetto e ne subisce i danni, quella creatura deve superare un tiro salvezza su Costituzione o lasciare cadere l'oggetto, se puo' farlo. Se non lascia cadere l'oggetto, subisce svantaggio ai tiri per colpire e alle prove di caratteristica fino all'inizio del turno successivo dell'incantatore.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni aumentano di 1d8 per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Bardo",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pezzo di ferro e una fiamma",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "riscaldare-il-metallo",
    "language": "it"
  },
  {
    "name": "Ristorare Inferiore",
    "level": 2,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore tocca una creatura e puo' porre termine a una malattia o una condizione che lo affligge tra accecato, assordato, avvelenato o paralizzato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Paladino",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "ristorare-inferiore",
    "language": "it"
  },
  {
    "name": "Ristorare Superiore",
    "level": 5,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (polvere di diamante del valore di almeno 100 mo, che l'incantatore consuma)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore infonde energia positiva in una creatura toccata per disfare un effetto debilitante. L'incantatore puo' ridurre di uno il livello di indebolimento del bersaglio o terminare uno degli effetti seguenti su di esso:\r\nUn effetto che ha affascinato o pietrificato il bersaglio;\r\nUna maledizione, inclusa la sintonia del bersaglio con un oggetto magico maledetto;\r\nUna qualsiasi riduzione di un punteggio di caratteristica del bersaglio;\r\nUn effetto che riduce il massimo dei punti ferita del bersaglio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "polvere di diamante del valore di almeno 100 mo, che l'incantatore consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "ristorare-superiore",
    "language": "it"
  },
  {
    "name": "Risveglio",
    "level": 5,
    "school": "Trasmutazione",
    "castingTime": "8 ore",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (un'agata del valore di almeno 1.000 mo, che l'incantesimo consuma)"
    ],
    "duration": "Durata: Istantanea",
    "description": "Dopo avere trascorso il tempo di lancio a tracciare un percorso magico su una pietra preziosa, l'incantatore tocca una bestia o un vegetale di taglia Enorme o inferiore. Il bersaglio deve essere privo di un punteggio di Intelligenza o avere Intelligenza pari o inferiore a 3. Il bersaglio ottiene Intelligenza pari a 10 e la capacita' di parlare un linguaggio noto all'incantatore. Se il bersaglio e' un vegetale, ottiene la capacita' di muovere i suoi rami, radici, liane, rampicanti e cosi' via e sviluppa sensi simili a quelli degli umani. Il DM sceglie le statistiche appropriate al vegetale risvegliato, come per esempio nel caso di un cespuglio o di un albero risvegliato. La bestia o il vegetale risvegliato e' affascinato dall'incantatore per 30 giorni o finché l'incantatore o i suoi compagni non lo danneggiano in qualche modo. Quando la condizione di affascinato termina, la creatura risvegliata sceglie se rimanere amichevole o meno nei confronti dell'incantatore, in base a come e' stata trattata quando era affascinata.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un'agata del valore di almeno 1.000 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "risveglio",
    "language": "it"
  },
  {
    "name": "Ritirata Rapida",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Questo incantesimo consente all'incantatore di muoversi a una velocita' straordinaria. Quando lancia questo incantesimo, e poi come azione bonus a ogni suo turno finché l'incantesimo non termina, l'incantatore puo' effettuare l'azione Scatto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "ritirata-rapida",
    "language": "it"
  },
  {
    "name": "Saltare",
    "level": 1,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (la zampa posteriore di una cavalletta)"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore tocca una creatura. La distanza coperta dai salti di quella creatura e' triplicata finché l'incantesimo non termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "la zampa posteriore di una cavalletta",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "saltare",
    "language": "it"
  },
  {
    "name": "Salvare i Morenti",
    "level": 0,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore tocca una creatura vivente a 0 punti ferita. Quella creatura diventa stabile. Questo incantesimo non ha effetto sui costrutti o sui non morti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "salvare-i-morenti",
    "language": "it"
  },
  {
    "name": "Santificare",
    "level": 5,
    "school": "Invocazione",
    "castingTime": "24 ore",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (erbe, oli e incenso del valore di almeno 1.000 mo, che l'incantesimo consuma)"
    ],
    "duration": "Finché non viene dissolto",
    "description": "L'incantatore tocca un punto e infonde un flusso di potere sacro (o sacrilego) in un'area del raggio massimo di 18 metri. L'incantatore fallisce se il raggio include gia' un'area sotto l'effetto di un incantesimo Santificare. L'area influenzata e' soggetta agli effetti seguenti. Per prima cosa, celestiali, elementali, folletti, immondi e non morti non possono entrare nell'area e non possono affascinare, spaventare o possedere le creature all'interno dell'area. Ogni creatura affascinata, spaventata o posseduta da una creatura del genere non e' piu' affascinata, spaventata e posseduta una volta entrata nell'area. L'incantatore puo' escludere uno o piu' tipi di creature da questo effetto. Secondariamente, l'incantatore puo' vincolare un effetto extra all'area, scegliendolo dalla lista sottostante o usando un effetto offerto dal DM. Alcuni effetti si applicano alle creature nell'area; l'incantatore puo' designare se si applica a tutte le creature, alle creature che seguono un capo o una divinita' specifica o alle creature di un tipo specifico, come gli orchi o i troll. Quando una creatura che sarebbe influenzata entra nell'area dell'incantesimo per la prima volta in un turno o vi inizia il proprio turno, puo' effettuare un tiro salvezza su Carisma. Se lo supera, ignora l'effetto extra finché non esce dall'area. Coraggio. Le creature influenzate non possono essere spaventate finché si trovano nell'area. Eterno Riposo. I corpi senza vita sepolti nell'area non possono essere trasformati in non morti. Interferenza Extradimensionale. Le creature influenzate non possono muoversi o viaggiare usando il teletrasporto o mezzi extradimensionali o interplanari. Linguaggi. Le creature influenzate possono comunicare con qualsiasi altra creatura nell'area, anche se non condividono un linguaggio comune. Luce Diurna. L'area e' pervasa di luce intensa. L'oscurita' magica creata dagli incantesimi di livello inferiore rispetto allo slot usato dall'incantatore per lanciare questo incantesimo non possono sopprimere la luce. Oscurita'. L'area si riempie di oscurita'. La luce normale, nonché la luce magica creata dagli incantesimi di livello inferiore rispetto allo slot usato dall'incantatore per lanciare questo incantesimo non possono illuminare l'area. Paura. Le creature influenzate sono spaventate finché si trovano nell'area. Protezione dall'Energia. Le creature influenzate entro l'area ottengono resistenza a un tipo di danno a scelta dell'incantatore, ad eccezione dei danni contundenti, perforanti o taglienti. Silenzio. Nessun suono puo' provenire dall'interno dell'area e nessun suono esterno puo' penetrare al suo interno. Vulnerabilita' all'Energia. Le creature influenzate entro l'area ottengono vulnerabilita' a un tipo di danno a scelta dell'incantatore, ad eccezione dei danni contundenti, perforanti o taglienti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "erbe, oli e incenso del valore di almeno 1.000 mo, che l'incantesimo consuma",
    "damageTypes": [
      "contundenti",
      "perforanti",
      "taglienti"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "santificare",
    "language": "it"
  },
  {
    "name": "Santuario",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (uno specchietto d'argento)"
    ],
    "duration": "1 minuto",
    "description": "L'incantatore protegge una creatura situata entro gittata dagli attacchi. Finché l'incantesimo non termina, ogni creatura che bersaglia la creatura protetta con un attacco o un incantesimo che infligge danni deve prima effettuare un tiro salvezza su Saggezza. Se lo fallisce, deve scegliere un nuovo bersaglio o perdere l'attacco. Questo incantesimo non protegge la creatura bersaglio dagli effetti ad area come l'esplosione di una Palla di Fuoco. Se la creatura protetta effettua un attacco o lancia un incantesimo che influenza una creatura nemica, questo incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "uno specchietto d'argento",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "santuario",
    "language": "it"
  },
  {
    "name": "Santuario Privato di Mordenkainen",
    "level": 4,
    "school": "Abiurazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "36 metri",
    "components": [
      "V",
      " S",
      " M (una sottile lamina di piombo, un pezzo di vetro opaco, un pezzo di cotone o di stoffa e un crisolito polverizzato)"
    ],
    "duration": "24 ore",
    "description": "L'incantatore rende un'area entro gittata magicamente sicura. L'area in questione e' un cubo le cui dimensioni possono variare da uno spigolo minimo di 1,5 metri a uno spigolo massimo di 30 metri. L'incantesimo permane per tutta la sua durata o finché l'incantatore non usa un'azione per interromperlo. Quando lancia l'incantesimo, l'incantatore decide che tipo di sicurezza esso fornisce, scegliendo una o piu' delle proprieta' seguenti:Lanciando ogni giorno questo incantesimo nello stesso punto per un anno si rende questo effetto permanente.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, puo' aumentare le dimensioni dello spigolo del cubo di 30 metri per ogni slot incantesimo superiore al 4°. Quindi un incantatore puo' proteggere un cubo con spigolo lungo fino a 60 metri usando uno slot incantesimo di 5° livello.",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una sottile lamina di piombo, un pezzo di vetro opaco, un pezzo di cotone o di stoffa e un crisolito polverizzato",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "santuario-privato-di-mordenkainen",
    "language": "it"
  },
  {
    "name": "Scagliare Maledizione",
    "level": 3,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore tocca una creatura che deve superare un tiro salvezza su Saggezza per non essere maledetta per la durata dell'incantesimo. Quando l'incantatore lancia questo incantesimo, sceglie la natura della maledizione tra le opzioni seguenti:Un incantesimo Rimuovi Maledizione pone fine a questo effetto. A discrezione del DM, l'incantatore puo' scegliere un effetto alternativo per la maledizione, che pero' non dovrebbe risultare piu' potente di quelli descritti sopra. Il DM ha l'ultima parola su tali effetti della maledizione.",
    "atHigherLevels": "Se l'incantatore lancia questo incantesimo usando uno slot incantesimo di 4° livello o superiore, la durata diventa concentrazione, fino a 10 minuti.Se usa uno slot incantesimo di 5° livello o superiore, la durata diventa 8 ore.Se usa uno slot incantesimo di 7° livello o superiore, la durata e' 24 ore.Se usa uno slot incantesimo di 9° livello o superiore, l'incantesimo dura finché non viene dissolto.L'uso di uno slot incantesimo di 5° livello o superiore conferisce una durata che non richiede concentrazione.",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "scagliare-maledizione",
    "language": "it"
  },
  {
    "name": "Scassinare",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore sceglie un oggetto entro gittata e che egli sia in grado di vedere. Puo' trattarsi di una porta, uno scrigno, un forziere, un paio di manette, un lucchetto o un altro oggetto dotato di un mezzo normale o magico per impedire l'accesso. Un bersaglio tenuto chiuso da una serratura magica, incastrato o sbarrato cessa di essere tale. Se l'oggetto e' protetto da piu' serrature, soltanto una di esse viene sbloccata. Se l'incantatore sceglie un bersaglio tenuto chiuso da Serratura Arcana, quell'incantesimo e' soppresso per 10 minuti, un periodo in cui puo' essere aperto e chiuso normalmente. Quando l'incantatore lancia l'incantesimo, l'oggetto emette un forte rumore simile al bussare, udibile fino a una distanza di 90 metri.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scassinare",
    "language": "it"
  },
  {
    "name": "Sciame di Meteore",
    "level": 9,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "1,5 km",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Globi rocciosi infuocati precipitano a terra in quattro punti diversi situati entro gittata e che l'incantatore sia in grado di vedere. Ogni creatura situata entro una sfera del raggio di 12 metri centrata su ogni punto scelto dall'incantatore deve effettuare un tiro salvezza su Destrezza. La sfera si diffonde oltre gli angoli. Se una creatura fallisce il tiro salvezza, subisce 20d6 danni da fuoco e 20d6 danni contundenti, mentre se lo supera, subisce soltanto la meta' di quei danni. Una creatura entro l'area di piu' esplosioni infuocate ne subisce l'effetto una volta sola. L'incantesimo infligge danni ad oggetti nell'area e incendia gli oggetti infiammabili che non sono indossati o trasportati.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "contundenti",
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "sciame-di-meteore",
    "language": "it"
  },
  {
    "name": "Scolpire Pietra",
    "level": 4,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (argilla duttile, che deve essere plasmata nella forma dell'oggetto desiderato)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore tocca un oggetto di pietra di taglia Media o inferiore o una sezione di pietra che non deve essere piu' grande di 1,5 metri in ogni dimensione e lo modella nella forma che desidera. Potrebbe per esempio modellare una grossa roccia per realizzare un'arma, un idolo o un forziere, o aprire un piccolo passaggio lungo una parete, purché quella parete non sia spessa piu' di 1,5 metri. Potrebbe anche modellare una porta di pietra o i suoi stipiti per sigillare la porta. L'oggetto creato dall'incantatore puo' avere un massimo di due cardini e un coperchio, ma non puo' essere dotato di meccanismi piu' raffinati.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "argilla duttile, che deve essere plasmata nella forma dell'oggetto desiderato",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scolpire-pietra",
    "language": "it"
  },
  {
    "name": "Scopri il Percorso",
    "level": 6,
    "school": "Divinazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V",
      " S",
      " M (una serie di strumenti da divinazione, come ossa, bastoncini d'avorio, carte, denti o incisioni runiche, del valore di 100 mo e un oggetto proveniente dal luogo che si desidera trovare)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 giorno",
    "description": "Questo incantesimo consente all'incantatore di scoprire il percorso fisico piu' breve e diretto verso un determinato luogo fisso che gli sia familiare e che si trovi su suo stesso piano di esistenza. Se l'incantatore nomina una destinazione su un altro piano di esistenza, una destinazione che si muove (come ad esempio una fortezza mobile) o una destinazione troppo generica (come per esempio la tana di un drago verde), l'incantesimo fallisce. Per la durata dell'incantesimo, fintato che l'incantatore si trova sullo stesso piano di esistenza della destinazione, egli sa quanto al destinazione e' lontana e in che direzione si trova. Mentre viaggia verso quella destinazione, ogni volta che gli si presentano piu' sentieri tra cui scegliere lungo il cammino, l'incantatore determina automaticamente il sentiero piu' breve e piu' diretto (ma non necessariamente il piu' sicuro) che lo portera' a destinazione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una serie di strumenti da divinazione, come ossa, bastoncini d'avorio, carte, denti o incisioni runiche, del valore di 100 mo e un oggetto proveniente dal luogo che si desidera trovare",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scopri-il-percorso",
    "language": "it"
  },
  {
    "name": "Scopri Trappole",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "36 m",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore percepisce la presenza di ogni trappola entro gittata ed entro linea di vista. Ai fini di questo incantesimo, per trappola si intende ogni cosa che infliggerebbe un effetto improvviso o inaspettato considerato dannoso o indesiderabile dall'incantatore, e specificamente inteso come tale dal suo creatore. Quindi questo incantesimo sarebbe in grado di individuare un'area sotto l'effetto di un incantesimo allarme, un glifo di interdizione o una fossa ad apertura meccanica, ma non rivelerebbe un cedimento naturale nel pavimento, un soffitto instabile o un buco nascosto nel terreno. Questo incantesimo rivela semplicemente che una trappola e' presente. L'incantatore non apprende l'ubicazione di ogni trappola, ma solo la natura generale del pericolo posto dalla trappola che percepisce.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scopri-trappole",
    "language": "it"
  },
  {
    "name": "Scrigno Segreto di Leomund",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (uno scrigno di fattura pregiata che misura 90 x 60 x 60 cm, fatto di materiali rari del valore di almeno 5.000 mo, e una riproduzione Minuscola fatta degli stessi meteriali e del valore di almeno 50 mo)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore nasconde uno scrigno e tutti i suoi contenuti sul Piano Etereo. Deve toccare lo scrigno e la riproduzione in miniatura che funge da componente materiale dell'incantesimo. Lo scrigno puo' contenere fino a 90 x 60 x 60 cm di materiale non vivente. Finché lo scrigno rimane sul Piano Etereo, l'incantatore puo' usare un'azione e toccare la riproduzione per richiamare a sé lo scrigno, che appare a terra, in uno spazio libero entro 1,5 metri dall'incantatore. L'incatatore puo' rimandare lo scrigno sul Piano Etereo usando un'azione e toccando sia lo scrigno che la riproduzione. Dopo 60 giorni si applica una probabilita' cumulativa del 5 per cento al giorno che l'effetto dell'incantesimo termini. Questo effetto termina se l'incantatore lancia questo incantesimo di nuovo, se la riproduzione piu' piccola del forziere viene distrutta o se l'incantatore sceglie di terminare l'incantesimo con un'azione. Se lo scrigno piu' grande si trova sul Piano Etereo quando l'incantesimo termina, e' perduto irrimediabilmente.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "uno scrigno di fattura pregiata che misura 90 x 60 x 60 cm, fatto di materiali rari del valore di almeno 5.000 mo, e una riproduzione Minuscola fatta degli stessi meteriali e del valore di almeno 50 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scrigno-segreto-di-leomund",
    "language": "it"
  },
  {
    "name": "Scritto Illusorio",
    "level": 1,
    "school": "Illusione",
    "castingTime": "1 minuto",
    "ritual": true,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: S",
      " M (inchiostro a base di piombo del valore di almeno 10 mo",
      " che l'incantesimo consuma)"
    ],
    "duration": "Durata: 10 giorni",
    "description": "Agli occhi dell'incantatore e di ogni creatura da lui designata al momento del lancio dell'incantesimo, lo scritto appare normale, stilato con la calligrafia dell'incantatore e trasmette il significato che l'incantatore intendeva trasmettere quando ha scritto il testo. Agli occhi di tutti gli altri, il messaggio appare come se fosse stato scritto in un linguaggio magico o ignoto, impossibile da decifrare. In alternativa, l'incantatore puo' fare in modo che il messaggio appaia come qualcosa di completamente diverso, stilato in una calligrafia e in un linguaggio diverso, che deve pero' trattarsi di un linguaggio da lui conosciuto. Una creatura dotata di vista pura puo' leggere il messaggio nascosto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "inchiostro a base di piombo del valore di almeno 10 mo che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scritto-illusorio",
    "language": "it"
  },
  {
    "name": "Scrutare",
    "level": 5,
    "school": "Divinazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un focus del valore di almeno 1.000 mo, come una sfera di cristallo, uno specchio d'argento o un bacile pieno di acqua santa)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore puo' vedere e udire una particolare creatura a sua scelta situata sul suo stesso piano di esistenza. Il bersaglio deve effettuare un tiro salvezza su Saggezza, modificato dalla conoscenza e dal tipo di legame che l'incantatore ha nei confronti del bersaglio. Se il bersaglio sa che l'incantatore sta lanciando questo incantesimo, puo' fallire il tiro salvezza volontariamente se desidera essere osservato. tiro salvezzatiro salvezzaIn caso di tiro salvezza superato, il bersaglio non e' influenzato e l'incantatore non puo' piu' usare questo incantesimo contro di lui per 24 ore. In caso di tiro salvezza fallito, l'incantesimo crea un sensore invisibile entro 3 metri dal bersaglio. L'incantatore puo' vedere e sentire attraverso il sensore come se si trovasse sul posto. Il sensore si muove assieme al bersaglio, rimanendo entro 3 metri da esso per la durata dell'incantesimo. Una creatura in grado di vedere gli oggetti invisibili vede il sensore come un globo luminoso delle dimensioni approssimative di un pugno umano. Anziché bersagliare una creatura, l'incantatore puo' scegliere un luogo che abbia gia' visto in precedenza come bersaglio di questo incantesimo. Quando lo fa, il sensore appare in quel luogo e non si muove.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Druido",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un focus del valore di almeno 1.000 mo, come una sfera di cristallo, uno specchio d'argento o un bacile pieno di acqua santa",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "scrutare",
    "language": "it"
  },
  {
    "name": "Scudo",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 reazione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 round",
    "description": "Una barriera di forza magica invisibile si materializza e protegge l'incantatore. Fino all'inizio del prossimo turno successivo, l'incantatore ottiene un bonus +5 alla CA da applicare anche all'attacco innescante e non subisce danni da Dardo Incantato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scudo",
    "language": "it"
  },
  {
    "name": "Scudo della Fede",
    "level": 1,
    "school": "Abiurazione",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (una piccola pergamena su cui sia stato scritto un frammento di un testo sacro)"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "Un campo di energia scintillante si materializza attorno a una creatura scelta dall'incantatore entro gittata, conferendole un bonus di +2 alla CA per la durata dell'incantesimo.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola pergamena su cui sia stato scritto un frammento di un testo sacro",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scudo-della-fede",
    "language": "it"
  },
  {
    "name": "Scudo di Fuoco",
    "level": 4,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un frammento di zolfo o una lucciola)"
    ],
    "duration": "10 minuti",
    "description": "Per la durata dell'incantesimo il corpo dell'incantatore e' avvolto da un sottile alone di fiamme spettrali che proiettano luce intensa entro un raggio di 3 metri e luce fioca per altri 3 metri. L'incantatore puo' terminare l'incantesimo prematuramente usando un'azione. Le fiamme conferiscono all'incantatore uno scudo ardente o uno scudo gelido, a sua scelta. Lo scudo ardente gli conferisce resistenza ai danni da freddo mentre lo scudo gelido gli conferisce resistenza ai danni da fuoco. Inoltre, ogni volta che una creatura entro 1,5 metri dall'incantatore lo colpisce con un attacco in mischia, dallo scudo si sprigiona una fiammata. L'attaccante subisce 2d8 danni da fuoco nel caso di uno scudo ardente o 2d8 danni da freddo nel caso di uno scudo gelido.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di zolfo o una lucciola",
    "damageTypes": [
      "freddo",
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scudo-di-fuoco",
    "language": "it"
  },
  {
    "name": "Scurovisione",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (un pizzico di carota essiccata o un'agata)"
    ],
    "duration": "Durata: 8 ore",
    "description": "L'incantatore tocca una creatura consenziente per conferirle la capacita' di vedere nell'oscurita'. Per la durata dell'incantesimo, quella creatura e' dotata di scurovisione fino a 18 metri.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Ranger",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di carota essiccata o un'agata",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "scurovisione",
    "language": "it"
  },
  {
    "name": "Segugio Fedele di Mordenkainen",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (un fischietto d'argento, un pezzo d'osso e un filo)"
    ],
    "duration": "8 ore",
    "description": "L'incantatore evoca un cane da guardia fantasma in uno spazio libero entro gittata e che egli sia in grado di vedere. Il segugio rimarra' in quel punto per la durata dell'incantesimo, finché l'incantatore non lo congeda con un'azione o finché non si allontana a piu' di 30 metri dal segugio. Il segugio e' invisibile a tutte le creature tranne l'incantatore e non puo' essere danneggiato. QUando una creatura di taglia Piccola o superiore giunge entro 9 metri da esso senza pronunciare la parola d'ordine specificata dall'incantatore al momento del lancio dell'incantesimo, il segugio inizia a latrare a piena voce. Il segugio vede le creature invisibili, puo' vedere il Piano Etereo e ignora le illusioni. All'inizio di ogni turno dell'incantatore, il segugio tenta di mordere una creatura situata entro 1,5 metri da lui e che sia ostile all'incantatore. Il bonus di attacco del segugio e' pari al modificatore di caratteristica da incantatore + il bonus di competenza dell'incantatore. Se colpisce, infligge 4d8 danni perforanti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un fischietto d'argento, un pezzo d'osso e un filo",
    "damageTypes": [
      "perforanti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "segugio-fedele-di-mordenkainen",
    "language": "it"
  },
  {
    "name": "Sembrare",
    "level": 5,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "8 ore",
    "description": "Questo incantesimo consente all'incantatore di alterare l'aspetto di un qualsiasi numero di creature entro gittata e che egli sia in grado di vedere, impartendo a ognuna di esse un nuovo aspetto illusorio. Un bersaglio non consenziente puo' effettuare un tiro salvezza su Carisma. Se lo supera, non e' influenzato da questo incantesimo. Questo incantesimo camuffa l'aspetto fisico oltre agli abiti, l'armatura, le armi e l'equipaggiamento. Ogni creatura puo' apparire 30 cm piu' alta o piu' basse e apparire magra, grassa o di corporatura normale. Non e' possibile cambiare il tipo di corpo, quindi ogni creatura deve adottare una forma che usi la stessa disposizione basilare degli arti. I cambiamenti apportati da questo incantesimo non passano il vaglio di un'ispezione fisica. Per esempio, se l'incantatore usa questo incantesimo per aggiungere un cappello sulla testa di una creatura, gli oggetti passerebbero attraverso il cappello e chiunque tocchi la creatura non sentirebbe nulla o toccherebbe la sua testa e i capelli. Se l'incantatore usa questo incantesimo per fare apparire la creatura piu' magra rispetto alla realta', quando qualcuno protende la mano per toccarla, urta la creatura quando la sua manon e' apparentemente ancora a mezzaria. Una creatura puo' usare la sua azione per ispezionare un bersaglio ed effettuare una prova di Intelligenza (Indagare) contro la CD del tiro salvezza dell'incantesimo. Se ha successo, capisce che il bersaglio e' camuffato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "sembrare",
    "language": "it"
  },
  {
    "name": "Semipiano",
    "level": 8,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "S"
    ],
    "duration": "1 ora",
    "description": "L'incantatore crea una porta d'ombra su una superficie solida e piatta, situata entro gittata e che egli sia in grado di vedere. La porta e' abbastanza grande da consentire alle creature Medie di attraversarla senza difficolta'. Quando e' aperta, la porta conduce a un semipiano che appare come una stanza vuota fatta di legno o di pietra che misura 9 metri in ogni dimensione. Quando l'incantesimo termina, la porta scompare e ogni creatura o oggetto che si trovavano all'interno del semipiano vi rimangono intrappolati, in quanto la porta scompare anche sul lato opposto. Ogni volta che l'incantatore lancia questo incantesimo, puo' creare un nuovo semipiano o fare in modo che la porta d'ombra si colleghi a un semipiano da lui creato con un precedente lancio di questo incantesimo. Inoltre, se l'incantatore conosce la natura e i contenuti di un semipiano creato dal lancio di questo incantesimo da parte di un'altra creatura, puo' fare in modo che la porta d'ombra si colleghi invece a quel semipiano.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "semipiano",
    "language": "it"
  },
  {
    "name": "Serratura Arcana",
    "level": 2,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (polvere d'oro del valore di almeno 25 mo, che l'incantesimo consuma)"
    ],
    "duration": "Finché non viene dissolto",
    "description": "L'incantatore tocca una porta, una finestra,, un portale, un forziere o un altro punto di accesso chiuso, che diventa chiuso a chiave. L'incantatore e le creature da lui designate al momento del lancio dell'incantesimo possono aprire l'oggetto normalmente. L'incantatore puo' anche stabilire una parola d'ordine che, una volta pronunciata entro 1,5 metri dall'oggetto, sopprime l'incantesimo per 1 minuto. Altrimenti l'oggetto e' impenetrabile finché non viene rotto o finché l'incantesimo non viene dissolto o soppresso. Lanciare Scassinare sull'oggetto sopprime la serratura arcana per 10 minuti. Finché e' influenzato da questo incantesimo, l'oggetto e' piu' difficile da rompere o da aprire a viva forza; la CD per romperlo o per scassinare le eventuali serrature presenti aumenta di 10.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "polvere d'oro del valore di almeno 25 mo, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "serratura-arcana",
    "language": "it"
  },
  {
    "name": "Servitore Inosservato",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": false,
    "range": "Gittata: 18 metri",
    "components": [
      "Componenti: V",
      " S",
      " M (un filo di spago e un pezzo di legno)"
    ],
    "duration": "Durata: 1 ora",
    "description": "Questo incantesimo crea una forza invisibile, amorfa e priva di volonta' propria che svolge i compiti piu' semplici su ordine dell'incantatore finché l'incantesimo non termina. Il servitore si materializza sul terreno, in uno spazio libero entro gittata. Possiede CA 10, 1 punto ferita, una Forza pari a 2 e non puo' attaccare. Se scende a 0 punti ferita, l'incantesimo termina. Una volta in ogni suo turno, come azione bonus, l'incantatore puo' ordinare mentalmente al servitore di muoversi fino a 4,5 metri e di interagire con un oggetto. Il servitore puo' effettuare compiti semplici come portare oggetti, pulire, riparare, ripiegare abiti, accendere fuochi, servire pietanze, versare vino e cosi' via. Una volta impartito l'ordine, il servitore svolge il compito al meglio delle sue capacita' finché non lo porta a termine, poi attende il comando successivo dell'incantatore. Se l'incantatore ordina al servitore di svolgere un compito che lo porterebbe a piu' di 18 metri da lui, l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un filo di spago e un pezzo di legno",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "servitore-inosservato",
    "language": "it"
  },
  {
    "name": "Sfera Congelante di Otiluke",
    "level": 6,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "90 metri",
    "components": [
      "V",
      " S",
      " M (una piccola sfera di cristallo)"
    ],
    "duration": "Istantanea",
    "description": "Un globo ghiacciato carico di energia fredda parte dalla punta delle dita dell'incantatore e sfreccia verso un punto a sua scelta situato entro gittata, dove esplode in una sfera del raggio di 18 metri. Ogni creatura entro l'area deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 10d6 danni da freddo, mentre se lo supera, subisce soltanto la meta' di quei danni. Se il globo colpisce una massa d'acqua o un liquido composto principalmente d'acqua (questo non include le creature basate sull'acqua), congela quel liquido fino a una profondita' di 15 cm su un'area quadrata con lato di 9 metri. Questo strato di ghiaccio dura 1 minuto. Le creature che stavano nuotando sulla superficie dell'acqua gelata sono intrappolate nel ghiaccio. Una creatura puo' usare un'azione per effettuare una prova di Forza contro la CD del tiro salvezza dell'incantesimo per liberarsi. L'incantatore puo' trattenersi dallo scagliare il globo quando completa l'incantesimo, se lo desidera. Un picolo globo grande all'incirca quanto una pietra da fionda e freddo al tatto compare nella sua mano. In qualsiasi momento, l'incantatore o una creatura a cui egli ponga il globo puo' lanciarlo (entro una gittata di 12 metri) o scagliarlo con una fionda (entro la normale gittata della fionda). Il globo si frantuma all'impatto, con lo stesso effetto del normale lancio dell'incantesimo. L'incantatore puo' anche poggiare il globo a terra senza frantumarlo. Dopo 1 minuto se il globo non e' gia' stato frantumato, esplode.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 6°.",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola sfera di cristallo",
    "damageTypes": [
      "freddo"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "sfera-congelante-di-otiluke",
    "language": "it"
  },
  {
    "name": "Sfera Elastica di Otiluke",
    "level": 4,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una semisfera di cristallo trasparente e una semisfera corrispondente di resina)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Una sfera di forza scintillante racchiude una creatura o un oggetto di taglia Grande o inferiore entro gittata. Una creatura non consenziente deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, e' rinchiusa nella sfera per la durata dell'incantesimo. Nulla puo' attraversare la barriera in entrata e in uscita (oggetti fisici, energia o altri effetti magici), ma una creatura all'interno della sfera puo' respirare liberamente. La sfera e' immune a tutti i danni e una creatura o un oggetto all'interno non puo' essere danneggiato dagli attacchi o dagli effetti che hanno origine all'esterno; analogamente, una creatura all'interno della sfera non puo' danneggiare nulla all'esterno. La sfera non ha peso ed e' grande quanto basta da contenere la creatura o l'oggetto al suo interno. Una creatura rinchiusa puo' usare la sua azione per spingere la sfera dall'interno e farla rotolare a meta' della propria velocita'. Analogamente, la sfera puo' essere sollevata e mossa dalle altre creature. Un incantesimo Disintegrazione che bersaglia la sfera la distrugge senza danneggiare cio' che essa contiene.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una semisfera di cristallo trasparente e una semisfera corrispondente di resina",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "sfera-elastica-di-otiluke",
    "language": "it"
  },
  {
    "name": "Sfera Infuocata",
    "level": 2,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di sego, un pizzico di zolfo e una manciata di polvere di ferro)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Una sfera di fuoco del diametro di 1,5 metri appare in uno spazio libero a scelta dell'incantatore, situato entro gittata, dove permane per la durata dell'incantesimo. Ogni creatura che termina il suo turno entro 1,5 metri dalla sfera deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 2d6 danni da fuoco, mentre se lo supera, subisce soltanto la meta' di quei danni. Con un'azione bonus, l'incantatore puo' muovere la sfera di un massimo di 9 metri. Se urta una creatura con la sfera, quella creatura deve effettuare il tiro salvezza contro i danni della sfera e la sfera non puo' muoversi ulteriormente per quel turno. Quando l'incantatore muove la sfera, puo' dirigerla oltre le barriere alte fino a 1,5 metri e farla saltare oltre le fosse larghe fino a 3 metri. La sfera incendia gli oggetti infiammabili che non sono indossati e trasportati e proietta luce intensa entro un raggio di 6 metri e luce fioca per altri 6 metri.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 2°.",
    "availableClasses": [
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di sego, un pizzico di zolfo e una manciata di polvere di ferro",
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "sfera-infuocata",
    "language": "it"
  },
  {
    "name": "Sfocatura",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Il corpo dell'incantatore diventa sfocato, instabile e ondeggiante agli occhi di tutti coloro che sono in grado di vederlo. Per la durata dell'incantesimo, tutte le creature subiscono svantaggio ai tiri per colpire contro di lui. Un attaccante e' immune a questo effetto se non si affida alla vista, per esempio se e' dotato di vista cieca o se e' in grado di vedere attraverso le illusioni, per esempio tramite vista pura.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "sfocatura",
    "language": "it"
  },
  {
    "name": "Sguardo Penetrante",
    "level": 6,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuti",
    "description": "Per la durata dell'incantesimo, gli occhi dell'incantatore diventano neri, vacui e pervasi da una sinistra energia. Una creatura a sua scelta entro 18 metri da lui e che egli sia in grado di vedere deve superare un tiro salvezza su Saggezza, altrimenti e' influenzata da uno degli effetti seguenti a scelta dell'incantatore per la durata dell'incantesimo. In ogni suo turno, finché l'incantesimo non termina, l'incantatore puo' usare la sua azione perbersagliare un'altra creatura, ma non puo' bersagliare di nuovo una creatura che abbia superato un tiro salvezza contro questo lancio di sguardo penetrante. Addormentato. Il bersaglio cade privo di sensi. Si sveglia se subisce danni o se un'altra creatura usa la sua azione per risvegliarlo scuotendolo. In Preda al Panico. Il bersaglio e' spaventato dall'incantatore. In ogni suo turno, la creatura spaventata deve effettuare l'azione di Scatto e muoversi per allontanarsi dall'incantatore lungo il percorso piu' breve e piu' sicuro possibile, a meno che non ci sia alcun luogo dove andare. Se il bersaglio si muove fino a un luogo lontano almeno 18 metri dall'incantatore in cui non e' piu' in grado di vederlo, questo effetto termina. Nauseato. Il bersaglio subisce svantaggio ai tiri per colpire e alle prove di caratteristica. Alla fine di ogni suo turno, puo' effettuare un altro tiro salvezza su Saggezza. Se lo supera, l'effetto termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "sguardo-penetrante",
    "language": "it"
  },
  {
    "name": "Silenzio",
    "level": 2,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": true,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore genera una sfera del raggio di 6 metri centrata su un punto a sua scelta situato entro gittata. Per la durata dell'incantesimo, nessun suono puo' essere creato all'interno di quella sfera o attraversarla. Ogni creatura o oggetto interamente all'interno della sfera e' immune ai danni da tuono e ogni creatura interamente all'interno della sfera e' assordata. All'interno dell'area e' impossibile lanciare un incantesimo che includa una componente verbale.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "tuono"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "silenzio",
    "language": "it"
  },
  {
    "name": "Simbolo",
    "level": 7,
    "school": "Abiurazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Tocco",
    "components": [
      "Componenti: V",
      " S",
      " M (Mercurio, fosforo, 1000 mo di polvere di opali e diamanti che verranno consumati)"
    ],
    "duration": "Durata: Fino alla dissoluzione/innesco",
    "description": "Inscrivendo un glifo su una superficie o all'interno di un oggetto che puo' essere chiuso. Puo' coprire un area non piu' grande di 3 metri di diametro. Se la superficie o l'oggetto viene mossa per piu' di 3 metri dal luogo in cui l'incantesimo e' stato lanciato, quest'ultimo termina senza essere innescato. Sarai tu a decidere in che modo innescare il glifo. Una volta innescato, l'incantesimo termina. E' inoltre possibile specificare determinate caratteristiche d'innesco cosi' che l'incantesimo si attivi secondo particolari circostanze o caratteristiche fisiche, tipo di creatura o allineamento. E'possibile anche specificare caratteristiche che NON innescano il glifoIl glifo e' quasi invisibile e richiede un tiro di Investigazione per essere trovatoQuando il glifo viene inscritto, scegli una delle opzioni sottostanti. Una volta innescato, il glifo risplende in una sfera di raggio 18 metri per 10 minuti, dopodiché l'incantesimo termina. Ogni creatura nella sfera nel momento in cui il glifo viene attivato, che entra nella sfera o che termina il suo turno al suo interno, ne subisce le conseguenze\r\nMorte: Ogni bersaglio deve effettuare un tiro salvezza sulla Costituzione o subire 10d10 danni necrotici nel caso fallisca, o la meta' nel caso riesca\r\nDiscordia: Ogni bersaglio deve effettuare un tiro salvezza sulla Costituzione. Nel caso fallisca, il bersaglio non puo' comunicare in modo sensato e ha svantaggio su tiri per colpire e tiri abilita' per 1 minuto\r\nPaura: Ogni bersaglio deve effettuare un tiro salvezza sulla Saggezza o divenire spaventata per 1 minuto. Mentre sono spaventare ,le creature devo lasciar cadere qualsiasi cosa stessero impugnando ,e muoversi di almeno 9 metri lontano dal glifo ad ogni loro turno. \r\nDisperazione: Ogni bersaglio deve effettuare un tiro salvezza sul Carisma. Nel caso fallisca, il bersaglio non puo' attaccare in nessun modo alcuna creatura per 1 minuto. \r\nPazzia: Ogni bersaglio deve effettuare un tiro salvezza sull'Intelligenza. Nel caso falliscano, i bersagli non posso fare azioni, comprendere cosa gli viene detto, leggere, parlare correttamente, e devono vagare a caso per 1 minuto. \r\nDolore: Ogni bersaglio deve effettuare un tiro salvezza sulla Costituzione o divenire incapacitato per 1 minuto\r\nSonno: Ogni bersaglio deve effettuare un tiro salvezza sulla saggezza o cadere a terra svenuto per 10 minuti. La creatura si risveglia nel caso subisca danni o se qualcuno usi un'azione per fare cio'\r\nStordimento:  Ogni bersaglio deve effettuare un tiro salvezza sulla Saggezza, nel caso fallisca diviene stordita per 1 minuto",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "Mercurio, fosforo, 1000 mo di polvere di opali e diamanti che verranno consumati",
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "simbolo",
    "language": "it"
  },
  {
    "name": "Simulacro",
    "level": 7,
    "school": "Illusione",
    "castingTime": "12 ore",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (neve o ghiaccio sufficienti a effettuare una copia a grandezza naturale della creatura da duplicare; una ciocca di capelli, un'unghia tagliata o un altro pezzo del corpo della creatura da collocare in mezzo al ghiaccio o alla neve, polvere di rubino del valore di 1.500 mo da spruzzare sul duplicato, che l'incantesimo consuma)"
    ],
    "duration": "Finché non viene dissolto",
    "description": "L'incantatore realizza un duplicato illusorio di una bestia o di un umanoide che deve rimanere entro gittata per tutto il lancio dell'incantesimo. Il duplicato e' una creatura parzialmente reale fatta di ghiaccio o di neve che puo' effettuare azioni ed essere influenzata come una creatura normale. Ha lo stesso aspetto dell'originale, ma possiede la meta' del suo massimo dei punti ferita e viene formata priva di equipaggiamento. Il simulacro e' amichevole nei confronti dell'incantatore e delle creature da lui designate. Obbedisce ai comandi vocali dell'incantatore, si muove e agisce in ottemperanza ai suoi desideri e in combattimente agisce nel turno dell'incantatore. Il simulacro non e' in grado di apprendere o di diventare pi potente, quindi non aumenta mai di livello, le sue caratteristiche non aumentano e non puo' recuparare gli slot incantesimo spesi. Se il simulacro subisce danni, l'incantatore puo' ripararlo in un laboratorio alchemico usando minerali ed erbe rare del valore di 100 mo per ogni punto ferita che esso recupera. Il simulacro permane finché non scende a 0 punti ferita, nel qual caso si ritrasforma in neve e si scioglie istantaneamente. Se l'incantatore lancia di nuovo questo incantesimo, il duplicato attualmente attivo da lui creato viene istantaneamente distrutto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "neve o ghiaccio sufficienti a effettuare una copia a grandezza naturale della creatura da duplicare; una ciocca di capelli, un'unghia tagliata o un altro pezzo del corpo della creatura da collocare in mezzo al ghiaccio o alla neve, polvere di rubino del valore di 1.500 mo da spruzzare sul duplicato, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "simulacro",
    "language": "it"
  },
  {
    "name": "Sogno",
    "level": 5,
    "school": "Illusione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": false,
    "range": "Speciale",
    "components": [
      "V",
      " S",
      " M (una manciata di sabbia, una goccia d'inchiostro o una penna strappata da un uccello che dorme)"
    ],
    "duration": "8 ore",
    "description": "Questo incantesimo modella i sogni di una creatura. L'incantatore sceglie una creatura che conosce come bersaglio. La creatura bersaglio deve trovarsi sullo stesso piano di esistenza dell'incantatore. Le creature che non dormono, come gli elfi, non possono essere contattate da questo incantesimo. L'incantatore, o una creatura consenziente da lui toccata, entra in uno stato di trance e funge da messaggero. Finché e' in trance, il messaggero percepisce l'ambiente circostante ma non e' in grado di intraprendere azioni o di muoversi. Se il bersaglio e' addormentato, il messaggero appare nei suoi sogni e puo' conversare con lui fintanto che esso continua a dormire, per tutta la durata dell'incantesimo. Il messaggero puo' anche modellare l'ambiente del sogno, creando paesaggi, oggetto e altre immagini. Il messaggero puo' emergere dalla trance in ogni momento terminando l'effetto dell'incantesimo prematuramente. Il bersaglio ricorda il sogno alla perfezione quando si risveglia. Se il bersaglio e' sveglio quando l'incantatore lancia l'incantesimo, il mesaggero lo appprende e puo' scegliere se porre fine alla trance (e all'incantesimo) o aspettare che si addormenti, nel qual caso il messaggero appare nei sogni del bersaglio. L'incantatore puo' fare in modo che il messaggero appaia mostruoso e terrificante agli occhi del bersaglio. Se lo fa, il messaggero puo' trasmettere un messaggio di un massimo di dieci parole; il bersaglio deve quindi effettuare un tiro salvezza su Saggezza. Se lo fallisce, l'eco di un'allucinazione mostruosa genera un incubo che permane per la durata del sonno del bersaglio e gli impedisce di trarre qualsiasi beneficio da quel riposo. Inoltre, quando il bersaglio si sveglia,, subisce 3d6 danni psichici. Se l'incantatore possiede una parte del corpo, una ciocca di capelli, un'unghia tagliata o una parte analoga del corpo del bersaglio, il bersaglio subisce svantaggio al suo tiro salvezza.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una manciata di sabbia, una goccia d'inchiostro o una penna strappata da un uccello che dorme",
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "sogno",
    "language": "it"
  },
  {
    "name": "Sonno",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di sabbia finissima, petali di rosa o un grillo)"
    ],
    "duration": "1 minuto",
    "description": "Questo incantesimo fa in modo che le creature siano vittime di un sonno magico. L'incantatore tira 5d8; il totale ottenuto e' l'ammontare di creature in punti ferita che questo incantesimo puo' influenzare. Le creature entro 6 metri da un punto a scelta dell'incantatore situato entro gittata sono influenzate in ordine crescente dei loro punti ferita (ignorando le creature prive di sensi). A partire dalla creatura che possiede meno punti ferita attuali, ogni creatura influenzata da questo incantesimo cade priva di sensi finché l'incantesimo non termina, il dormiente non subisce danni o qualcuno non usa un'azione per scuotere o schiaffeggiare il dormiente per svegliarlo. Si sottraggono i punti ferita di ogni creatura dal totale prima di passare alla creatura con l'ammontare immediatamente superiore di punti ferita. I punti ferita di una creatura devono essere pari o inferiori al totale rimanente affinché quella creatura possa essere influenzata. Le creature non morte e quelle immuni all'essere affascinate non sono influenzate da questo incantesimo.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, tira 2d8 aggiuntivi per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di sabbia finissima, petali di rosa o un grillo",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "sonno",
    "language": "it"
  },
  {
    "name": "Sortilegio",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione bonus",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: 27 m",
    "components": [
      "Componenti: V",
      " S",
      " M (l'occhio pietrificato di un girino)"
    ],
    "duration": "Durata: Concentrazione, fino a 1 ora",
    "description": "L'incantatore scaglia una maledizione su una creatura entro gittata e che egli sia in grado di vedere. Finché l'incantesimo non termina, l'incantatore infligge 1d6 danni necrotici extra al bersaglio ogni volta che lo colpisce con un attacco. Inoltre, quando l'incantatore lancia l'incantesimo, sceglie una caratteristica. Il bersaglio subisce svantaggio alle prove di caratteristica effettuate con la caratteristica scelta. Se il bersaglio scende a 0 punti ferita prima che questo incantesimo termini, l'incantatore puo' usare un'azione bonus in un suo turno successivo per maledire una nuova creatura. Un incantesimo rimuovi maledizione lanciato sul bersaglio termina questo incantesimo prematuramente.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 3° o 4° livello, puo' mantenere la concentrazione sull'incantesimo fino a un massimo di 8 ore. Quando usa uno slot incantesimo di 5° livello o superiore, puo' mantenere la concentrazione sull'incantesimo fino a un massimo di 24 ore.",
    "availableClasses": [
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "l'occhio pietrificato di un girino",
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "sortilegio",
    "language": "it"
  },
  {
    "name": "Spada di Mordenkainen",
    "level": 7,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (una spada di platino in miniatura dall'impugnatura e dal pomolo di rame e di zinco, del valore di 250 mo)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea un piano di forza a forma di spada che fluttua entro gittata e permane per la durata dell'incantesimo. Quando la spada appare, l'incantatore effettua un attacco in mischia con questo incantesimo contro un bersaglio a sua scelta situato entro 1,5 metri dalla spada. Se lo colpisce, il bersaglio subisce 3d10 danni da forza. Finché l'incantesimo non termina, l'incantatore puo' usare un'azione bonus a ogni suo turno per muovere la spada di un massimo di 6 metri ino a un punto che egli sia in grado di vedere e ripetere questo attacco contro lo stesso bersaglio o un bersaglio diverso.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una spada di platino in miniatura dall'impugnatura e dal pomolo di rame e di zinco, del valore di 250 mo",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "spada-di-mordenkainen",
    "language": "it"
  },
  {
    "name": "Spostamento Planare",
    "level": 7,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (una bacchetta di metallo biforcuta armonizzata al piano di destinazione da 250 mo)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore e un massimo di otto creature consenzienti che si tengono per mano formando un cerchio vengono trasportati su un piano di esistenza diverso. L'incantatore puo' specificare la destinazione o averne una vaga descrizione, per poi apparire nel luogo esatto o nelle sue vicinanze, a discrezione del DM. In alternativa, se l'incantatore conosce la sequenza dei simboli di un cerchio di teletrasporto su un altro piano, l'incantesimo lo conduce nel punto esatto. Nel caso il cerchio sia troppo piccolo per contenere tutte le creature, esse appaiono nello spazio libero piu' vicinoL'incantesimo puo' essere utilizzato per bandire una creatura non consenziente su un altro piano di esistenza. In questo caso e' necessario effettuare in tiro per colpire con un'arma corpo a corpo sulla creatura. L'incantatore sceglie una creatura entro la sua portata ed effettua un attacco in mischia con questo incantesimo contro di essa. Se colpisce, la creatura deve effettuare un tiro salvezza su Carisma. Se lo fallisce, viene trasportata in un luogo casuale sul piano di esistenza specificato dall'incantatore. Una creatura trasportata in questo modo dovra' trovare da sola il modo di tornare sul piano di esistenza attuale dell'incantatore.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una bacchetta di metallo biforcuta armonizzata al piano di destinazione da 250 mo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "spostamento-planare",
    "language": "it"
  },
  {
    "name": "Spruzzo Colorato",
    "level": 1,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Incantatore (cono di 4,5 metri)",
    "components": [
      "Componenti: V",
      " S",
      " M (un pizzico di sabbia o di polvere colorata di rosso, giallo e blu)"
    ],
    "duration": "Durata: 1 round",
    "description": "Dalla mano dell'incantatore si sprigiona un lampo abbagliante di luce multicolore. L'incantatore tira 6d10; il totale indica l'ammontare di creature in punti ferita che questo incantesimo puo' influenzare. Le creature situate entro un cono di 4,5 metri che ha origine dall'incantatore sono influenzate in ordine crescente basato sui loro punti ferita attuali (ignorando le creature prive di sensi e quelle che non sono in grado di vedere). A partire dalla creatura che possiede meno punti ferita attuali, ogni creatura influenzata da questo incantesimo e' accecata finché l'incantesimo non termina. Si sottraggono i punti ferita di ogni creatura dal totale prima di passare alla creatura con l'ammontare immediatamente superiore di punti ferita. I punti ferita di una creatura devono essere pari o inferiori al totale rimanente affinché quella creatura possa essere influenzata.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, tira 2d10 aggiuntivi per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di sabbia o di polvere colorata di rosso, giallo e blu",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "spruzzo-colorato",
    "language": "it"
  },
  {
    "name": "Spruzzo Prismatico",
    "level": 7,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore, (cono di 18 metri)",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Otto raggi di luce multicolore si sprigionano dalla mano dell'incantatore. Ogni raggio e' di un colore diverso e ha un potere e una funzione diversa. Ogni creatura situata entro un cono di 18 metri deve effettuare un tiro salvezza su Destrezza. Per ogni bersaglio si tira un d8 per determinare quale raggio colorato viene influenzato.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "spruzzo-prismatico",
    "language": "it"
  },
  {
    "name": "Spruzzo Velenoso",
    "level": 0,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore allunga la mano verso una creatura entro gittata e che egli sia in grado di vedere e proietta uno sbuffo di gas velenoso dal suo palmo. La creatura deve superare un tiro salvezza su Costituzione, altrimenti subisce 1d12 danni da veleno. I danni di questo incantesimo aumentano di 1d12 quando l'incantatore arriva al 5° livello (2d12), 11° livello (3d12) e 17° livello (4d12).",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d12"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "spruzzo-velenoso",
    "language": "it"
  },
  {
    "name": "Stretta Folgorante",
    "level": 0,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "Un fulmine si sprigiona dalla mano dell'incantatore per trasmettere una scarica folgorante a una creatura da lui toccata. L'incantatore effettua un attacco in mischia con questo incantesimo contro il bersaglio. Se il bersaglio indossa un'armatura fatta di metallo l'incantatore dispone di vantaggio. Se colpisce, il bersaglio subisce 1d8 danni da fulmine e non puo' effettuare reazioni fino all'inizio del suo turno successivo. I danni di questo incantesimo aumentano di 1d8 quando l'incantatore arriva al 5° livello (2d8), 11° livello (3d8) e 17° livello (4d8).",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fulmine"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "stretta-folgorante",
    "language": "it"
  },
  {
    "name": "Suggestione",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " M (una lingua di serpente e un frammento di un alveare o una goccia di olio dolce)"
    ],
    "duration": "Concentrazione, fino a 8 ore",
    "description": "L'incantatore suggerisce un corso d'azione da intraprendere (limitandosi a una o due frasi) e influenza magicamente una creatura entro gittata e che egli sia in grado di vedere. La creatura deve essere in grado di sentire l'incantatore e di capirlo. Le creature che non possono essere affascinate sono immuni a questo effetto. La suggestione deve essere formulata in modo che il corso d'azione appaia ragionevole. Chiedere a una creatura di pugnalarsi, gettarsi su una lancia, immolarsi o compiere altri atti palesemente autolesionistici pone termine all'incantesimo. Il bersaglio deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, deve perseguire il corso d'azione descritto dall'incantatore al meglio delle sue capacita'. Tale corso d'azione puo' proseguire per l'intera durata dell'incantesimo. Se l'attivita' suggerita puo' essere completata in un periodo di tempo piu' breve, l'incantesimo termina quando il soggetto completa cio' che gli e' stato chiesto di fare. L'incantatore puo' anche specificare quali condizioni innescheranno un'attivita' speciale nel corso della durata. Per esempio, potrebbe suggerire che un cavaliere ceda il suo cavallo da guerra al primo mendicante che incontra. Se questa condizione non viene soddisfatta prima che l'incantesimo termini, quell'attivita' non viene effettuata. Se l'incantatore o uno dei suoi compagni infliggono danni al bersaglio, l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una lingua di serpente e un frammento di un alveare o una goccia di olio dolce",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "suggestione",
    "language": "it"
  },
  {
    "name": "Suggestione di Massa",
    "level": 6,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " M (una lingua di serpente e un frammento di un alveare o una goccia di olio dolce)"
    ],
    "duration": "24 ore",
    "description": "L'incantatore suggerisce un corso d'azione da intraprendere (limitandosi a una o due frasi) e influenza magicamente fino a dodici creature a sua scelta entro gittata e che egli sia in grado di vedere. Le creature devono essere in grado di sentire l'incantatore e di capirlo. Le creature che non possono essere affascinate sono immuni a questo effetto. La suggestione deve essere formulata in modo che il corso d'azione appaia ragionevole. Chiedere a una creatura di pugnalarsi, gettarsi su una lancia, immolarsi o compiere altri atti palesemente autolesionistici nega automaticamente l'effetto dell'incantesimo. Ogni bersaglio deve effettuare un tiro salvezza su Saggezza.  Se lo fallisce, deve perseguire il corso d'azione descritto dall'incantatore al meglio delle sue capacita'. Tale corso d'azione puo' proseguire per l'intera durata dell'incantesimo. Se l'attivita' suggerita puo' essere completata in un periodo di tempo piu' breve, l'incantesimo termina quando il soggetto completa cio' che gli e' stato chiesto di fare. L'incantatore puo' anche specificare quali condizioni innescheranno un'attivita' speciale nel corso della durata. Per esempio, potrebbe suggerire che un gruppo di soldati ceda tutto il suo denaro al primo mendicante che incontra. Se questa condizione non viene soddisfatta prima che l'incantesimo termini, quell'attivita' non viene effettuata. Se l'incantatore o uno dei suoi compagni infligge danni a una creatura influenzata da questo incantesimo, l'incantesimo termina per quella creatura. Ai Livelli Superiori. Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 7° livello, la durata e' pari a 10 giorni. Quando usa uno slot incantesimo di 8° livello, la durata e' pari a 30 giorni. Quando usa uno slot incantesimo di 9° livello, la durata e' pari a un anno e un giorno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una lingua di serpente e un frammento di un alveare o una goccia di olio dolce",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "suggestione-di-massa",
    "language": "it"
  },
  {
    "name": "Sussurri Dissonanti",
    "level": 1,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore sussurra una melodia dissonante che soltanto una creatura a sua scelta e situata entro gittata e' in grado di udire; quella creatura sara' scossa da un dolore lancinante. Il bersaglio deve effettuare un tiro salvezza su Saggezza. Se lo falisce, subisce 3d6 danni psichici e, se disponibile, deve usare immediatamente la sua reazione per muoversi fin dove la sua velocita' glielo consente, allontanandosi dall'incantatore. La creatura non si muove su terreno palesemente pericoloso come un incendio o una fossa. Se invece supera il tiro salvezza, il bersaglio subisce soltanto la meta' di quei dani e non deve muoversi per allontanarsi. Una creatura assordata supera automaticamente il tiro salvezza.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Bardo"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "sussurri-dissonanti",
    "language": "it"
  },
  {
    "name": "Taumaturgia",
    "level": 0,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V"
    ],
    "duration": "Fino a 1 minuto",
    "description": "L'incantatore genera una meraviglia minore, una manifestazione di potere soprannaturale. Puo' creare unodegli effetti magici seguenti entro gittata:Se l'incantatore lancia questo incantesimo piu' volte, puo' mantenere attivi fino a tre dei suoi effetti da 1 minutosimultaneamente e puo' congedare uno di quegli effetti con un'azione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "taumaturgia",
    "language": "it"
  },
  {
    "name": "Telecinesi",
    "level": 5,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 10 minuti",
    "description": "L'incantatore ottiene la capacita' di spostare o manipolare le creature o gli oggetti con la forza del pensiero. Quando lancia l'incantesimo e come sua azione ogni round per la durata dell'incantesimo, puo' proiettare la sua volonta' su una creatura o un oggetto situato entro gittata e che egli sia in grado di vedere, causando l'effetto appropriato sottostante. L'incantatore puo' influenzare lo stesso bersaglio round dopo round, oppure sceglierne uno nuovo in qualsiasi momento. Se cambia bersaglio, il bersaglio precedente non e' piu' influenzato dall'incantesimoCreatura. L'incantatore puo' tentare di muovere una creatura di taglia Enorme o inferiore, effettuando una prova di caratteristica con la propria caratteristica da incantatore contrapposta alla prova di Forza della creatura. Se vince la contesa, muove la creatura di un massimo di 9 metri in qualsiasi direzione, anche verticalmente, ma non oltre la gittata dell'incantesimo. Fino alla fine del turno successivo dell'incantatore, la creatura e' trattenuta dalla morsa telecinetica. Una creatura sollevata verticalmente rimane sospesa a mezz'aria. Nei round successivi, l'incantatore puo' usare la sua azione per tentare di mantenere la sua morsa telecinetica sulla creatura ripetendo la contesa. Oggetto. L'incantatore puo' tentare di muovere un oggetto dal peso massimo di 500 kg. Se l'oggetto non e' indossato o trasportato, l'incantatore puo' muoverlo automaticamente di un masimo di 9 metri in qualsiasi direzione, ma non oltre la gittata di questo incantesimo. Se l'oggetto e' indossato o trasportato da una creatura, l'incantatore deve effettuare una prova di caratteristica con la sua caratteristica da incantatore contrapposta a una prova di Forza di quella creatura. Se vince la contesa, strappa l'oggetto a quella creatura e puo' muoverlo di un massimo di 9 metri in qualsiasi direzione, ma non oltre la gittata di questo incantesimo. L'incantatore puo' esercitare un controllo piu' preciso, come manipolare un semplice strumento, aprire una porta o un contenitore, riporre o prelevare un oggetto da un contenitore aperto o versare i contenuti di una fiala.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "telecinesi",
    "language": "it"
  },
  {
    "name": "Telepatia",
    "level": 8,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Illimitata",
    "components": [
      "V",
      " S",
      " M (un paio di anelli d'argento concatenati)"
    ],
    "duration": "24 ore",
    "description": "L'incantatore crea un legame telepatico tra sé stesso e una creatura consenziente che gli e' familiare. La creatura puo' trovarsi in qualsiasi punto dello stesso piano di esistenza dell'incantatore. L'incantesimo termina se l'incantatore o il bersaglio non si trovano piu' sullo stesso piano. Finché l'incantesimo non termina, l'incantatore e il bersaglio possono condividere istantaneamente parole, immagini, suoni e altri messaggi sensoriali attraverso il legame e il bersaglio riconosce l'incantatore come la creatura con cui sta comunicando. L'incantesimo consente a una creatura con un punteggio di Intelligenza pari o superiorea 1 di capire il significato delle parole dell'incantatore e di assimilare il significato dei messaggi sensoriali che egli le invia.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un paio di anelli d'argento concatenati",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "telepatia",
    "language": "it"
  },
  {
    "name": "Teletrasporto",
    "level": 7,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V"
    ],
    "duration": "Istantanea",
    "description": "Questo incantesimo trasporta immediatamente l'incantatore e un massimo di otto creature consenzienti a sua scelta, situate entro gittata e che egli sia in grado di vedere, oppure un singolo oggetto entro gittata e che egli sia in grado di vedere, in una destinazione a sua scelta. Se bersaglia un oggetto, quell'oggetto deve essere interamente conteuto in un cubo con spigolo di 3 metri e non puo' esssere impugnato o trasportato da una creatura non consenziente. La destinazione scelta deve essere nota all'incantatore e deve trovarsi sul suo stesso piano di esistenza. la familiarita' dell'incantatore nei confronti della destinazione determina se l'incantatore riesce a raggiungerla. Il DM tira un d100 e consulta la tabella. Familiarita'ErroreLa magia imprevedibile dell'incantesimo rende il viaggio piu' difficile. Ogni creatura che si teletrasporta (o l'oggetto bersaglio) subisce 3d10 danni da forza e il DM ripete il tiro sulla tabella per determinare dove arrivera' (potrebbe verificarsi piu' di un errore, nel qual caso i danni vengono applicati ogni volta). Area SimileL'incantatore e il suo gruppo (o l'oggetto bersaglio) arrivano in un'area diversa che e' visivamente o tematicamente simile all'area bersaglio. Per esempio, se e' diretto al suo laboratorio personale, potrebbe finire nel laboratorio di un altro mago o in un negozio di sostanze alchemiche che contiene molti strumenti e materiali simili a quelli del suo laboratorio. In genere appare nel luogo simile piu' vicino, ma dal momento che l'incantesimo non ha limiti di gittata, in teoria potrebbe finire in un qualsiasi punto del piano. Fuori BersaglioL'incantatore e il suo gruppo (o l'oggetto bersaglio) compaiono a una distanza casuale dalla destinazione in una direzione casuale. La distanza fuori bersaglio e' pari a 1d10 x 1d10 percento della distanza da percorrere. Per esempio, se un incantatore tenta di viaggaire di 180 km, arriva fuori bersaglio e ottiene un 5 e un 3 al tiro dei due d10, arriva fuori bersaglio del 15 per cento, vale a dire 27 km. Il DM determina la direzione fuori bersaglio tirando un d8:Se l'incantatore voleva teletrasportarsi fino a una citta' costiera e finisce 27 km al largo della costa, e' nei guai. Sul BersaglioL'incantatore e il suo gruppo (o l'oggetto bersaglio) compaiono dove l'incantatore desidera.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d8",
      "d10"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "teletrasporto",
    "language": "it"
  },
  {
    "name": "Tempesta di Fuoco",
    "level": 7,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 45 metri",
    "components": [
      "Componenti: V",
      " S",
      ""
    ],
    "duration": "Durata: Istantanea",
    "description": "Appaino fino a dieci cubi di lato 3 metri, che puoi collocare a tuo piacimento. Ogni cubo deve toccare almeno la faccia di un altro cubo. Ogni creatura nell'area dei cubi effettua un tiro salvezza sulla Destrezza. Nel caso fallisca, subisce 7d10 danni da fuoco , o la meta' nel caso riesca. Il fuoco danneggia gli oggetti nell'area e incendia quelli infiammabili che non sono indossati o trasportati. E' possibile isolare le piante dall'effetto dell'incantesimo",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "fuoco"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "tempesta-di-fuoco",
    "language": "it"
  },
  {
    "name": "Tempesta di Ghiaccio",
    "level": 4,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "90 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di polvere e alcune gocce d'acqua)"
    ],
    "duration": "Istantanea",
    "description": "Chicchi di grandine duri quanto pietre piovono sul terreno all'interno di un cilindro del raggio di 6 metri e alto 12 metri centrato su un punto entro gittata. Ogni creatura entro il cilindro deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 2d8 danni contundenti e 4d6 danni da freddo, mentre se lo supera, subisce soltanto la meta' di quei danni. La grandine trasforma l'area di effetto della tempesta in terreno difficile fino alla fine del turno successivo dell'incantatore.",
    "atHigherLevels": "Quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 5° livello o superiore, i danni contundenti aumentano di 1d8 per ogni slot di livello superiore al 4°.",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di polvere e alcune gocce d'acqua",
    "damageTypes": [
      "contundenti",
      "freddo"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6",
      "d8"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "tempesta-di-ghiaccio",
    "language": "it"
  },
  {
    "name": "Tempesta di Nevischio",
    "level": 3,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "45 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di polvere e alcune gocce d'acqua)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Finché l'incantesimo non termina, una gelida pioggia di nevischio cade in un cilindro del raggio di 12 metri e alto 6 metri, centrato su un punto a scelta dell'incantatore e situato entro gittata. L'area e' pesantemente oscurata e le fiamme scoperte vengono estinte. Il terreno entro l'area e' coperto di ghiaccio scivoloso e diventa terreno difficile. Quando una creatura entra nell'area dell'incantesimo per la prima volta in un turno o vi inizia il proprio turno, deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, cade a terra prona. Se una creatura cerca di concentrarsi nell'area dell'incantesimo, deve superare un tiro salvezza su Costituzione contro la CD del tiro salvezza dell'incantesimo lanciato dall'incantatore, altrimenti perdera' la concentrazione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di polvere e alcune gocce d'acqua",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "tempesta-di-nevischio",
    "language": "it"
  },
  {
    "name": "Tempesta di Vendetta",
    "level": 9,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Vista",
    "components": [
      "V",
      " S",
      ""
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore genera una minacciosa nube tempestosa, che si espande fino a un raggio di 110 metri centrato su un punto che egli sia in grado di vedere. L'area e' scossa da tuoni, fulmini e venti forti. Ogni creatura situata sotto la nube (a non piu' di 1. 500 metri sotto di essa) nel momento in cui compare deve effettuare un tiro salvezza su Costituzione. Se lo fallisce, subisce 2d6 danni da tuono e diventa assordata per 5 minuti. Per ogni round in cui l'incantatore mantiene la concentrazione su questo incantesimo, la tempesta produce ulteriori effetti nel suo turno. Round 2. Dalla nube cade una pioggia acida. Ogni creatura e oggetto sotto di essa subisce 1d6 danni da acido. Round 3. L'incantatore invoca sei fulmini che scendono dalla nube e colpiscono sei creature o oggetti a sua scelta situati sotto la nube.  Una determinata creatura o oggetto puo' essere colpita da piu' di un fulmine. Una creatura colpita deve effettuare un tiro salvezza su Destrezza. Se lo fallisce subisce 10d6 danni da fulmine, mentre se lo supera ne subisce la meta'. Round 4. Dalla nube cade una violenta grandinata. Ogni creatura sotto la nube subisce 2d6 danni contundenti. Round 5-10. L'area sotto la nube e' attraversata da raffiche di vento e pioggia gelida. L'area diventa terreno difficile e pesantemente oscurato e ogni creatura al suo interno subisce 1d6 danni da freddo. Gli attacchi con le armi a distanza sono impossibili. Il vento e la pioggia contano come gravi distrazioni al fine di mantenere la concentrazione sugli incantesimi. Infine raffiche di vento forte disperdono automaticamente nebbia, foschia e fenomeni simili nell'area, comuni o magici che siano.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "acido",
      "contundenti",
      "freddo",
      "fulmine",
      "tuono"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Costituzione"
    ],
    "urlFriendlyName": "tempesta-di-vendetta",
    "language": "it"
  },
  {
    "name": "Tentacoli Neri di Evard",
    "level": 4,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "27 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di tentacolo appartenuto a una piovra o una seppia gigante)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "Una massa di tentacoli brulicanti di color ebano riempiono un quadrato con lato di 6 metri situato sul terreno, entro gittata e che l'incantatore sia in grado di vedere. Per la durata dell'incantesimo, quei tentacoli trasformano il terreno di quell'area in terreno difficile. Quando una creatura entra nell'area influenzata per la prima volta in un turno o vi inizia il proprio turno, deve superare un tiro salvezza su Destrezza, altrimenti subisce 3d6 danni contundenti ed e' trattenuta dai tentacoli finché l'incantesimo non termina. Una creatura che inizia il suo turno nell'area ed e' gia' trattenuta dai tentacoli subisce 3d6 danni contundenti. Una creatura trattenuta dai tentacoli puo' usare la sua azione per effettuare una prova di Forza o di Destrezza (a sua scelta) contro la CD del tiro salvezza dell'incantesimo. In caso di successo, si libera.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di tentacolo appartenuto a una piovra o una seppia gigante",
    "damageTypes": [
      "contundenti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "tentacoli-neri-di-evard",
    "language": "it"
  },
  {
    "name": "Terremoto",
    "level": 8,
    "school": "Invocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "150 metri",
    "components": [
      "V",
      " S",
      " M (un pizzico di terriccio, un frammento di pietra e un pezzo di argilla)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea una scossa sismica in un punto del terreno situato entro gittata e che egli sia in grado di vedere. Per la durata dell'incantesimo, un intenso tremito scuote il terreno entro un raggio di 30 metri centrato su quel punto, coinvolgendo le creature e le strutture a contatto con il terreno in quell'area. Il terreno nell'area diventa terreno difficile. Ogni creatura sul terreno che si stia concentrando deve superare un tiro salvezza su Costituzione, se lo fallisce la sua concentrazione e' interrotta. Quando l'incantatore lancia questo incantesimo e alla fine di ogni turno da lui trascorso a concentrarsi su di esso, ogni creatura sul terreno nell'area deve effettuare un tiro salvezza su Destrezza. In caso di fallimento, cade a terra prona. Questo incantesimo puo' avere effetti aggiuntivi a seconda del terreno nell'area, come determinato dal DM. Crepe: In tutta l'area dell'incantesimo si aprono delle crepe a partire dall'inizio del turno successivo dell'incantatore a quello in cui l'incantesimo e' stato lanciato. Un totale di 1d6 crepe si aprono nell'area dell'incantesimo in punti scelti dal DM. Ciascuna e' profonda 1d10 x 3 metri, larga 3 metri e si estende da un bordo dell'area dell'incantesimo al bordo opposto. Una creatura che si trovi in un punto in cui si apre una fessura deve passare un tiro salvezza su Destrezza o vi cadra' dentro. Se la creatura supera il tiro salvezza, riesce a spostarsi assieme al bordo della crepa quando questa viene a crearsi. Una fessura che si apre sotto una struttura la fa automaticamente crollare (vedi sotto). Strutture: La scossa sismica infligge 50 danni contundenti a qualsiasi struttura a contatto con il terreno nell'area in cui e' stato lanciato l'incantesimo e all'inizio di ogni turno dell'incantatore finché l'incantesimo non termina. Se una struttura scende a 0 punti ferita, essa crolla e potrebbe infliggere danni alle creature vicine. Una creatura situata entro una distanza pari alla meta' dell'altezza della struttura deve effettuare un tiro salvezza su Destrezza. Se lo fallisce, subisce 5d6 danni contundenti, cade a terra prona ed e' seppellita dai detriti. Per liberarsi deve usare un'azione per effettuare una prova di Forza (Atletica) con CD 20. Il DM puo' aumentare o ridurre la CD, in base alla natura dei detriti. In caso di tiro salvezza superato, la creatura subisce soltanto la meta' di quei danni, non cade a terra prona e non viene seppellita.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico",
      "Druido",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di terriccio, un frammento di pietra e un pezzo di argilla",
    "damageTypes": [
      "contundenti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6",
      "d10"
    ],
    "savingThrows": [
      "Costituzione,Destrezza"
    ],
    "urlFriendlyName": "terremoto",
    "language": "it"
  },
  {
    "name": "Terreno Illusorio",
    "level": 4,
    "school": "Illusione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "90 metri",
    "components": [
      "V",
      " S",
      " M (una pietra, un rametto e alcuni frammenti di un vegetale fresco)"
    ],
    "duration": "24 ore",
    "description": "L'incantatore fa in modo che un terreno naturale contenuto in un cubo con spigolo di 45 metri appaia, suoni e odori come un altro tipo di terreno naturale. Un campo aperto o una strada potrebbe quindi sembrare una palude, una collina, un creapaccio o un qualche altro tipo di terreno difficile o invalicabile. Uno stagno potrebbe apparire come un prato erboso, un precipizio come un dolce pendio e un fosso erto di rocce come una strada ampia e accogliente. Le strutture artificiali, l'equipaggiamento e le creature entro l'area non cambiano aspetto.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Druido",
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una pietra, un rametto e alcuni frammenti di un vegetale fresco",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "terreno-illusorio",
    "language": "it"
  },
  {
    "name": "Tocco del Vampiro",
    "level": 3,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Incantatore",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: Concentrazione fino a 1 minuto",
    "description": "Il tocco della mano dell'incantatore, avviluppata in una cortina d'ombra, puo' risucchiare l'energia vitale delle altre creature per curare le proprie ferite. L'incantatore effettua un attacco in mischia con questo incantesimo contro una creatura entro portata. Se colpisce, il bersaglio subisce 3d6 danni necrotici e l'incantatore recupera un ammontare di punti ferita pari alla meta' dei danni necrotici inflitti. Finché l'incantesimo non termina, l'incantatore puo' effettuare l'attacco di nuovo ogni suo turno con azioneA livelli piu' alti.  Quando si lancia l'incantesimo usando uno slot incantesimo di 4°livello o superiore, i danni aumentano di 1d6 per ogni slot di livello superiore al 3°",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d6"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "tocco-del-vampiro",
    "language": "it"
  },
  {
    "name": "Tocco Gelido",
    "level": 0,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: 36 metri",
    "components": [
      "Componenti: V",
      " S"
    ],
    "duration": "Durata: 1 round",
    "description": "L'incantatore crea una mano scheletrica e spettrale nello spazio di una creatura entro gittata, effettuando un attacco a distanza con questo incantesimo contro quella creatura per colpirla con un flusso di gelo sepolcrale. Se viene colpito, il bersaglio subisce 1d8 danni necrotici e non puo' recuperare punti ferita fino all'inizio del turno successivo dell'incantatore. Fino ad allora, la mano si avvinghia al bersaglio. Se l'incantatore colpisce un bersaglio non morto, quel bersaglio subisce anche svantaggio ai suoi tiri per colpire contro l'incantatore fino alla fine del turno successivo di quest'ultimo. I danni di questo incantesimo aumentano di 1d8 quando l'incantatore arriva al 5° livello (2d8), 11° livello (3d8) e 17° livello (4d8).",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "necrotici"
    ],
    "isDamaging": true,
    "damageDices": [
      "d8"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "tocco-gelido",
    "language": "it"
  },
  {
    "name": "Trama Ipnotica",
    "level": 3,
    "school": "Illusione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "36 metri",
    "components": [
      "S",
      " M (un bastoncino d'incenso acceso o una fiala di cristallo riempita di materiale fosforescente)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore crea un complicato intreccio di colori che si snoda nell'aria all'interno di un cubo con spigolo di 9 metri entro gittata. La trama appare soltanto per un istante, poi svanisce. Ogni creatura entro l'area che la veda deve effettuare un tiro salvezza su Saggezza. Se lo fallisce, diventa affascinata da questo incantesimo. Finché e' affascinata, la creatura e' incapacitata e la sua velocita' e' pari a 0. L'incantesimo su una creatura influenzata termina se la creatura subisce danni o se qualcun altro usa un'azione per scuotere la creatura, destandola dal suo stato confusionale.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un bastoncino d'incenso acceso o una fiala di cristallo riempita di materiale fosforescente",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Saggezza"
    ],
    "urlFriendlyName": "trama-ipnotica",
    "language": "it"
  },
  {
    "name": "Trasformazione",
    "level": 9,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un diadema di giada del valore di almeno 1.500 mo, che l'incantatore deve indossare prima di lanciare l'incantesimo)"
    ],
    "duration": "Concentrazione, fino a 1 ora",
    "description": "L'incantatore assume la forma di una creatura diversa per la durata dell'incantesimo. La nuova forma puo' essere quella di qualsiasi creatura con un grado di sfida pari o inferiore al livello dell'incantatore. La creatura non puo' essere un costrutto o un non morto e deve essere un tipo di creatura che l'incantatore abbia visto almeno una volta. L'incantatore si trasforma in un normale esemplare di quella creatura, privo di livelli di classe e del tratto \"Incantesimi\". Le statistiche di gioco vengono sostituite dalle statistiche della creatura scelta, ma l'incantatore conserva il suo allineamento e i suoi punteggi di Intelligenza, Seggezza e Carisma. Conserva inoltre tutte le sue competenze nelle abilita' e nei tiri salvezza, oltre a ottenere quelle della creatura. Se la creatura possiede una competenza che anche l'incantatore possiede e il bonus elencato nelle sue statistiche e' superiore a quello dell'incantatore, quest'ultimo usa il bonus della creatura al posto del proprio. L'incantatore non puo' usare nessuna azione leggendaria o di tana nella nuova forma. L'incantatore assume i punti ferita e i Dadi Vita della nuova forma, e quando riassume la sua forma normale, ritorna al numero di punti ferita che possedeva prima di essere trasformato. Se riassume la forma normale per essere sceso a 0 punti ferita, ogni eventuale danno in eccesso si trasferisce alla sua forma normale. Fintanto che i danni in eccesso non portano la forma normale dell'incantatore a 0 punti ferita, l'incantatore non cade privo di sensi. L'incantatore conserva il beneficio degli eventuali privilegi fornitigli dalla sua classe, razza o altre fonti, e puo' usarli, purché la sua nuova forma glielo consenta fisicamente. Non puo' usare alcun senso speciale che possieda (come per esempio la scurovisione), a meno che la sua nuova forma non lo possieda a sua volta. Puo' parlare solo se la creatura e' normalmente in grado di parlare. Quando l'incantatore si trasforma, sceglie se lasciare cadere a terra il suo equipaggiamento, se tale equipaggiamento si fonde nella sua nuova forma o se indossarlo. L'equipaggiamento indossato funziona normalmente, ma spetta al DM decidere se e' pratico o meno che la nuova forma indossi ogni determinato oggetto di equipaggiamento, in base alla forma e alla taglia della creatura. L'equipaggiamento dell'incantatore non cambia taglia o forma per adattarsi alla nuova forma, e ogni oggetto di equipaggiamento che la nuova forma non puo' indossare deve cadere a terra o fondersi nella nuova forma dell'incantatore. L'equipaggiamento fuso alla nuova forma non ha alcun effetto in quello stato. Per la durata dell'incantesimo, l'incantatore puo' usare la sua azione per assumere una forma diversa seguendo le stesse regole e restrizioni relative alla forma originale, con una eccezione: se la nuova forma possiede piu' punti ferita rispetto ai punti ferita attuali dell'incantatore, i punti ferita di quest'ultimo rimangono al suo valore attuale.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un diadema di giada del valore di almeno 1.500 mo, che l'incantatore deve indossare prima di lanciare l'incantesimo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "trasformazione",
    "language": "it"
  },
  {
    "name": "Traslazione Arborea",
    "level": 5,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Incantatore",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore ottiene la capacita' di entrare in un albero e di muoversi dall'interno di quell'albero a un altro albero dello stesso tipo situato entro 150 metri. Entrambi gli alberi devono essere vivi e di taglia pari o superiore a quella dell'incantatore. L'incantatore deve usare 1,5 metri di movimento per entrare in un albero. Apprende istantaneamente l'ubicazione di tutti gli altri alberi dello stesso tipo entro 150 metri e, come parte del movimento usato per entrare al suo interno, puo' scegliere se passare in uno di quegli alberi o emergere dall'albero in cui si trova. L'incantatore ricompare in un punto a sua scelta entro 1,5 metri dall'albero di destinazione usando ulteriori 1,5 metri di movimento. Se non gli rimane piu' alcun movimento, ricompare entro 1,5 metri dall'albero in cui e' entrato. L'incantatore puo' usare questa capacita' di trasporto una volta per round per la durata dell'incantesimo. Deve concludere ogni suo turno fuori da un albero.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido",
      "Ranger"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "traslazione-arborea",
    "language": "it"
  },
  {
    "name": "Trasporto Vegetale",
    "level": 6,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "1 round",
    "description": "Questo incantesimo crea un legame magico tra un vegetale inanimato di taglia Grande o superiore situato entro gittata e un altro vegetale, situato a qualsiasi distanza sullo stesso piano di esistenza. L'incantatore deve avere visto o toccato il vegetale di destinazione almeno una volta in precedenza. Per la durata dell'incantesimo, qualsiasi ceatura puo' entrare nel vegetale bersaglio e uscire da quello di destinazione usando 1,5 metri di movimento.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "trasporto-vegetale",
    "language": "it"
  },
  {
    "name": "Trova Cavalcatura",
    "level": 2,
    "school": "Evocazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "9 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore evoca uno spirito che assume la forma di una cavalcatura insolitamente forte, intelligente e fedele, stringendo con lei un legame duraturo. La cavalcatura appare in uno spazio libero entro gittata e assume una forma a scelta dell'incantatore tra un cavallo da guerra, un pony, un cammello, un alce o un mastino. (Il DM potrebbe consentire di evocare altri animali come cavalcature. ) La cavalcatura usa le statistiche della forma scelta, anche se si tratta di un celestiale, un folletto o un immondo (a scelta dell'incantatore) anziché di un tipo normale. Inoltre, se la cavalcatura ha un'Intelligenza pari o inferiore a 5, la sua Intelligenza diventa 6 e ottiene la capacita' di capire un linguaggio a scelta dell'incantatore e che l'incantatore sia in grado di parlare. La cavalcatura serve l'incantatore sia in combattimento che in altri momenti, e grazie al legame istintivo che li unisce, i due combattono come un'unita' perfettamente coesa. Quando l'incantatore e' in sella alla cavalcatura, puo' fare in modo che ogni incantesimo che bersaglia solo se stesso bersagli anche la sua cavalcatura. Quando la cavalcatura scende a O punti ferita, scompare, non lasciandosi dietro alcuna forma fisica. L'incantatore puo' anche congedare la sua cavalcatura in qualsiasi momento con un'azione, facendola scomparire. In ogni caso, un nuovo lancio di questo incantesimo evochera' la stessa cavalcatura, riportata al massimo dei suoi punti ferita. Finché la cavalcatura si trova entro 1,5 km dall'incantatore, questi puo' comunicare con lei telepaticamente. L'incantatore non puo' legarsi a piu' di una cavalcatura alla volta tramite questo incantesimo. Con un'azione, puo' liberare la cavalcatura dal suo legame in qualsiasi momento, facendola scomparire.",
    "atHigherLevels": "",
    "availableClasses": [
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "trova-cavalcatura",
    "language": "it"
  },
  {
    "name": "Trova Famiglio",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 ora",
    "ritual": true,
    "concentration": false,
    "range": "3 metri",
    "components": [
      "V",
      " S",
      " M (carbone, incenso ed erbe del valore di 10 mo da bruciare in un braciere d'ottone)"
    ],
    "duration": "Istantanea",
    "description": "L'incantatore ottiene il servizio di un famiglio, uno spirito che assume una forma animale a scelta dell'incantatore: cavalluccio marino, corvo, faina, falco, gatto, granchio, gufo, lucertola, pesce (quipper), piovra, pipistrello, ragno, rana (rospo), serpente velenoso, topo. Il famiglio compare in uno spazio libero entro gittata e possiede le statistiche della forma scelta, anche se si tratta di un celestiale, un folletto o un immondo (a scelta dell'incantatore) anziché di una bestia. Il famiglio agisce in modo indipendente dall'incantatore, ma obbedisce sempre ai suoi comandi. In combattimento tira per la propria iniziativa e agisce nel proprio turno. Un famiglio non puo' attaccare ma puo' effettuare altre azioni normalmente. Quando il famiglio scende a 0 punti ferita, scompare e non lascia dietro di sé alcuna forma fisica. Ricompare dopo che l'incantatore ha lanciato di nuovo questo incantesimo. Finché il famiglio si trova entro 30 metri dall'incantatore, quest'ultimo puo' comunicare con lui telepaticamente. Inoltre, con un'azione, l'incantatore puo' vedere attraverso gli occhi del famiglio e sentire cio' che esso sente fino all'inizio del proprio turno successivo, beneficiando degli eventuali sensi speciali posseduti dal famiglio. Durante questo periodo, l'incantatore e' sordo e cieco ai fini dei propri sensi. Con un'azione, l'incantatore puo' temporaneamente congedare il suo famiglio, che scompare in una sacca dimensionale dove attende di essere richiamato. In alternativa, l'incantatore puo' congedarlo per sempre. Con un'azione, finché il famiglio e' congedato temporaneamente, l'incantatore puo' farlo ricomparire in uno spazio libero entro 9 metri da lui. Un incantatore non puo' avere piu' di un famiglio alla volta. Se lancia questo incantesimo quando gia' possiede un famiglio, impartisce a quel famiglio una nuova forma, scelta dalla lista soprastante. Il famiglio si trasforma nella creatura scelta. Infine, quando l'incantatore lancia un incantesimo con gittata a contatto, il famiglio puo' trasmettere l'incantesimo come se fosse stato lui a lanciarlo. Il famiglio deve trovarsi entro 30 metri dall'incantatore e deve usare la sua reazione per trasmettere l'incantesimo quando l'incantatore lo lancia. Se l'incantesimo richiede un tiro per colpire, l'incantatore usa il suo modificatore di attacco per quel tiro.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "carbone, incenso ed erbe del valore di 10 mo da bruciare in un braciere d'ottone",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "trova-famiglio",
    "language": "it"
  },
  {
    "name": "Trucco della Corda",
    "level": 2,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (estratto di mais in polvere e un pezzo di pergamena annodato)"
    ],
    "duration": "Durata: 1 ora",
    "description": "L'incantatore tocca un pezzo di corda di una lunghezza massima di 18 metri. Un'estremita' della corda sale in aria finché essa non pende perpendicolarmente al terreno. All'estremita' superiore della corda si apre un'entrata invisibile verso uno spazio extradimensionale che permane finché l'incantesimo non termina. È possibile raggiungere lo spazio extradimensionale arrampicandosi in cima alla corda. Lo spazio puo' contenere un massimo di otto creature di taglia Media o inferiore. . La corda puo' essere ritratta all'interno dello spazio, nel qual caso sparira' dalla vista di chi osserva all'esterno dello spazio. Gli attacchi e gli incantesimi non possono attraversare in entrata o in uscita lo spazio extradimensionale, ma coloro che si trovano all'interno possono vedere all'esterno come se osservassero da una finestra di 90 cm per 1,5 m centrata sulla corda. Tutto cio' che si trova all'interno dello spazio extradimensionale cade all'esterno quando l'incantesimo termina.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "estratto di mais in polvere e un pezzo di pergamena annodato",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "trucco-della-corda",
    "language": "it"
  },
  {
    "name": "Tsunami",
    "level": 8,
    "school": "Evocazione",
    "castingTime": "1 minuto",
    "ritual": false,
    "concentration": true,
    "range": "Vista",
    "components": [
      "V",
      " S"
    ],
    "duration": "Concentrazione, fino a 6 round",
    "description": "Un muro d'acqua si materializza in un punto a scelta dell'incantatore situato entro gittata. Il muro puo' avere dimensioni massime di 90 metri di lunghezza, 90 metri di altezza e 15 metri di spessore e permane per la durata dell'incantesimo. Quando il muro appare, ogni creatura all'interno della sua area deve effettuare un tiro salvezza su Forza. Se lo fallisce, subisce 6d10 danni contundenti, mentre se lo supera, subisce soltanto la meta' di quei danni. All'inizio di ogni turno dell'incantatore, dopo che il muro e' comparso, esso si muove di 15 metri allontanandosi dall'incantatore assieme alle creature che contiene. Ogni creatura di taglia Enorme o inferiore situata all'interno del muro e ogni creatura in uno spazio in cui il muro entra quando si muove, deve superare un tiro salvezza su Forza, altrimenti subisce 5d10 danni contundenti. Una creatura puo' subire questi danni soltanto una volta per round. Alla fine del turno, l'altezza del muro si riduce di 15 metri e i danni che le creature subiscono dall'incantesimo nei round successivi sono ridotti di 1d10. QUando un muro scende a 0 metri di altezza, l'incantesimo termina. Una creatura immersa nel muro puo' muoversi nuotando. Data la forza dell'onda, tuttavia, deve effettuare con successo una prova di Forza (Atletica) contro la CD del tiro salvezza dell'incantesimo per muoversi. Se fallisce la prova, non puo' muoversi. Se una creatura muovendosi esce dall'area, cade a terra.",
    "atHigherLevels": "",
    "availableClasses": [
      "Druido"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "contundenti"
    ],
    "isDamaging": true,
    "damageDices": [
      "d10"
    ],
    "savingThrows": [
      "Forza"
    ],
    "urlFriendlyName": "tsunami",
    "language": "it"
  },
  {
    "name": "Unto",
    "level": 1,
    "school": "Evocazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S",
      " M (un frammento di grasso di maiale o di burro)"
    ],
    "duration": "1 minuto",
    "description": "Una patina viscida di unto ricopre un quadrato di terreno con lato di 3 metri, centrato in un punto entro gittata, trasformandolo in terreno difficile per la durata dell'incantesimo. Quando l'unto compare, ogni creatura che si trova entro l'area deve superare un tiro salvezza su Destrezza altrimenti cade a terra prona. Anche una creatura che entra nell'area o vi termina il proprio turno deve superare un tiro salvezza su Destrezza o cade a terra prona.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un frammento di grasso di maiale o di burro",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Destrezza"
    ],
    "urlFriendlyName": "unto",
    "language": "it"
  },
  {
    "name": "Vedere Invisibilita'",
    "level": 2,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Incantatore",
    "components": [
      "V",
      " S",
      " M (un pizzico di talco e una manciata di polvere d'argento)"
    ],
    "duration": "1 ora",
    "description": "Per la durata dell'incantesimo, l'incantatore vede le creature e gli oggetti invisibili come se fossero visibili e puo' vedere sul Piano Etereo. Le creature e gli oggetti eterei appaiono spettrali e trasparenti.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un pizzico di talco e una manciata di polvere d'argento",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "vedere-invisibilita-",
    "language": "it"
  },
  {
    "name": "Velocita'",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "9 metri",
    "components": [
      "V",
      " S",
      " M (una buccia di radice di liquirizia)"
    ],
    "duration": "Concentrazione, fino a 1 minuto",
    "description": "L'incantatore sceglie una creatura consenziente entro gittata e che egli sia in grado di vedere. Finché l'incantesimo non termina, il bersaglio ottiene un bonus di +2 alla CA, dispone di vantaggio ai tiri salvezza su Destrezza, la sua velocita' raddoppia, e ottiene un'azione aggiuntiva a ogni suo turno. L'azione aggiuntiva puo' essere usata soltanto per effettuare un'azione di Attacco (solo attacchi con le armi), Disimpegno, Nascondersi, Scatto o Usare un Oggetto. Quando l'incantesimo termina, il bersaglio non puo' muoversi o effettuare azioni fino alla fine del suo turno successivo, in quanto e' sopraffatto da un'ondata di spossatezza.",
    "atHigherLevels": "",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una buccia di radice di liquirizia",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "velocita-",
    "language": "it"
  },
  {
    "name": "Vigilanza e Interdizione",
    "level": 6,
    "school": "Abiurazione",
    "castingTime": "10 minuti",
    "ritual": false,
    "concentration": false,
    "range": "Corridoi. Tutti i corridoi protetti si riempiono di nebbia e diventano pesantemente oscurati. Inoltre, a ogni incrocio o diramazione che richieda di scegliere una direzione esiste una probabilità del 50 per cento che una creatura diversa dall'incantatore creada di andare nella direzione opposta rispetto a quella che ha scelto.",
    "components": [
      "Collocare Luci Danzanti in quattro corridoi. L'incantatore può designare un semplice programma che le luci ripeteranno fintanto che vigilanza e interdizione permane."
    ],
    "duration": "Collocare Bocca Magica in due luoghi.",
    "description": "L'incantatore crea un'interdizione che protegge un'area quadrata con lato di 15 metri, o cento quadrati con lato di 1,5 metri, o venticinque quadrati con lato di 3 metri. L'area protetta puo' essere alta fino a 6 metri e avere la forma desiderata dall'incantatore. E' possibile proteggere vari piani di una roccaforte ripartendo l'area su piu' piani, purché l'incantatore possa camminare in ogni area contigua mentre lancia l'incantesimo. Quando l'incantatore lancia l'incantesimo, puo' specificare quali individui non saranno influenzati da alcuni o da tutti gli effetti a sua scelta. Puo' anche specificare una parola d'ordine che, una volta pronunciata a voce alta, rendera' immune a questi effetti chi la pronuncia. Vigilanza e Interdizione crea gli effetti seguenti all'interno dell'area protetta:L'intera area protetta emana magia. Un incantesimo Dissolvi Magie lanciato con successo un un effetto specifico rimuove soltanto quell'effetto. L'incantatore puo' creare una struttura permanentemente soggetta a vigilanza e interdizione lanciando questo incantesimo sulla struttura ogni giorno per un anno.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "vigilanza-e-interdizione",
    "language": "it"
  },
  {
    "name": "Vincolo di Interdizione",
    "level": 2,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un paio di anelli di platino del valore di 50 mo, che l’incantatore e il bersaglio devono portare per tutta la durata dell’incantesimo)"
    ],
    "duration": "1 ora",
    "description": "Questo incantesimo protegge una creatura consenziente toccata dall’incantatore e crea tra i due un legame mistico che permane finché l’incantesimo non termina. Finché il bersaglio si trova entro 18 metri dall’incantatore, ottiene un bonus di +1 alla CA e ai tiri salvezza e resistenza a tutti i danni. Inoltre, ogni volta che subisce danni, l’incantatore subisce lo stesso ammontare di danni. L’incantesimo termina se l’incantatore scende a 0 punti ferita, se l’incantatore e il bersaglio si separano per piu' di 18 metri di distanza o se l’incantesimo viene lanciato di nuovo su una delle creature collegate. Inoltre, l’incantatore puo' interrompere l’incantesimo con un’azione.",
    "atHigherLevels": "",
    "availableClasses": [
      "Chierico"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un paio di anelli di platino del valore di 50 mo, che l’incantatore e il bersaglio devono portare per tutta la durata dell’incantesimo",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "vincolo-di-interdizione",
    "language": "it"
  },
  {
    "name": "Visione del Vero",
    "level": 6,
    "school": "Divinazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S",
      " M (un unguento per gli occhi del costo di 25 mo, ricavato da polvere di funghi, zolfo e grasso, che l'incantesimo consuma)"
    ],
    "duration": "1 ora",
    "description": "Questo incantesimo conferisce alla creatura toccata dall'incantatore la capacita' di vedere le cose per cio' che effettivamente sono. Per la durata dell'incantesimo, la creatura e' dotata di vista pura, nota le porte segrete nascoste dalla magia ed e' in grado di vedere sul Piano Etereo, entro un raggio di 36 metri.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "un unguento per gli occhi del costo di 25 mo, ricavato da polvere di funghi, zolfo e grasso, che l'incantesimo consuma",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "visione-del-vero",
    "language": "it"
  },
  {
    "name": "Vita Falsata",
    "level": 1,
    "school": "Necromanzia",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Gittata: incantatore",
    "components": [
      "Componenti: V",
      " S",
      " M (una piccola quantità di alcol o di liquore distillato)"
    ],
    "duration": "Durata: 1 ora",
    "description": "L'incantatore si rafforza con un duplicato necromantico di vita e ottiene 1d4+4 punti ferita temporanei per la durata dell'incantesimo.",
    "atHigherLevels": "quando l'incantatore lancia questo incantesimo usando uno slot incantesimo di 2° livello o superiore, ottiene 5 punti ferita temporanei per ogni slot di livello superiore al 1°.",
    "availableClasses": [
      "Mago",
      "Stregone"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "una piccola quantità di alcol o di liquore distillato",
    "damageTypes": [],
    "isDamaging": true,
    "damageDices": [
      "d4"
    ],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "vita-falsata",
    "language": "it"
  },
  {
    "name": "Volare",
    "level": 3,
    "school": "Trasmutazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": true,
    "range": "Gittata: Contatto",
    "components": [
      "Componenti: V",
      " S",
      " M (la piuma dell'ala di un qualsiasi uccello)"
    ],
    "duration": "Durata: Concentrazione fino a 10 minuti",
    "description": "L'incantatore tocca una creatura consenziente. Il bersaglio ottiene una velocita' di volare di 18 m per la durata dell'incantesimo. Quando l'incantesimo termina, il bersaglio cade se era ancora sospeso in aria, a meno che non abbia modo di impedire la caduta.",
    "atHigherLevels": "L'incantatore puo' bersagliare una creatura aggiuntiva per ogni slot incantesimo di livello superiore al 3°.",
    "availableClasses": [
      "Mago",
      "Stregone",
      "Warlock"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": "la piuma dell'ala di un qualsiasi uccello",
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "volare",
    "language": "it"
  },
  {
    "name": "Vuoto Mentale",
    "level": 8,
    "school": "Abiurazione",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "Contatto",
    "components": [
      "V",
      " S"
    ],
    "duration": "24 ore",
    "description": "Finché l'incantesimo non termina, una creatura consenziente toccata dall'incantatore e' immune ai danni psichici, a qualsiasi effetto che percepirebbe le sue emozioni o leggerebbe i suoi pensieri, agli incantesimi di divinazione e alla condizione di affascinato. L'incantesimo neutralizza perfino gli incantesimi Desiderio e gli incantesimi o effetti di potenza analoga usati per influenzare la mente del bersaglio o ottenere informazioni su quel bersaglio.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Mago"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [
      "psichici"
    ],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      ""
    ],
    "urlFriendlyName": "vuoto-mentale",
    "language": "it"
  },
  {
    "name": "Zona di Verita'",
    "level": 2,
    "school": "Ammaliamento",
    "castingTime": "1 azione",
    "ritual": false,
    "concentration": false,
    "range": "18 metri",
    "components": [
      "V",
      " S"
    ],
    "duration": "10 minuti",
    "description": "L'incantatore crea una zona magica protetta dagli inganni entro una sfera del raggio di 4,5 metri centrata su un punto a sua scelta entro gittata. Finché l'incantesimo non termina, una creatura che inizia il suo turno dentro o entra nell'area non puo' piu' mentire mentre e' nell'area, a meno che non superi un tiro salvezza su Carisma. Se lo fallisce puo' mentire deliberatamente finché si trova entro l'area. L'incantatore e' consapevole di chi supera e chi fallisce il tiro salvezza e le creature colpite sono consapevoli della restrizione. La creatura interessata puo' evitare di rispondere alle domande a cui normalmente risponderebbe mentendo. Una tale creatura puo' fornire risposte sfuggenti, purché rimanga entro i confini della verita'.",
    "atHigherLevels": "",
    "availableClasses": [
      "Bardo",
      "Chierico",
      "Paladino"
    ],
    "bookSource": "Manuale del Giocatore",
    "sourcePage": "",
    "materialComponents": null,
    "damageTypes": [],
    "isDamaging": false,
    "damageDices": [],
    "savingThrows": [
      "Carisma"
    ],
    "urlFriendlyName": "zona-di-verita-",
    "language": "it"
  }
]

export default spells_it;
  